// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"ic68B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _common = require("./common");
var _radioPlaceholderSvg = require("url:../images/radio_placeholder.svg");
var _radioPlaceholderSvgDefault = parcelHelpers.interopDefault(_radioPlaceholderSvg);
var _personSvg = require("url:../images/person.svg");
var _personSvgDefault = parcelHelpers.interopDefault(_personSvg);
var _soundWaveSvg = require("url:../images/sound_wave.svg");
var _soundWaveSvgDefault = parcelHelpers.interopDefault(_soundWaveSvg);
var _podcastSvg = require("url:../images/podcast.svg");
var _podcastSvgDefault = parcelHelpers.interopDefault(_podcastSvg);
var _icCoinsSvg = require("url:../images/ic_coins.svg");
var _icCoinsSvgDefault = parcelHelpers.interopDefault(_icCoinsSvg);
var _config = require("./config");
const podcastFeedParser = require("ad81798b25f8b0b0");
var uid;
var uiName;
var nav;
var trans;
var btnToggleNav;
var mainNav = 0;
var vRadiosRef, uvRadiosRef, usersRef, userRef, vPodsRef, uvPodsRef;
var navs, navMeat, navTitles;
var navContent, radioContent, editContent, mainContent, userContent, podContent;
var imgLogo, imgBanner, inRadioName, radioAlert, inSlogan, inDesc, inStream, elAudio, pAudioAlert, inLocation, inEmail, inPhone, inWeb, btnGoStream, inTestUrl, lblTestUrl;
var inAdminName, pRequestDate, pRadioId, iRadioId, pAdminId, iAdminId, iRequestDate, inWebStream, inWelcome;
var btnRequestInfo, btnReject, btnApprove, btnUpdate, btnTestUrl, btnAddProduct, btnAddCoinPack;
var dWelcome, dTestStream;
var btnBack;
var iRadioInfo;
var xRadioId;
var xRadioAdmin;
var radioClass;
var podClass;
var iVerified;
var firstInit = true;
var isMainContent = true;
var iPodContent;
var xPodId;
var prodRef;
var wdRef, userWdRef, approvedWdRef, balanceRef;
var btnClearSearch, btnSearch;
var divResults, pResultLoader, pEmpty, spName, spNotFound, divSearchList, btnRadioRevision;
const SearchType = {
    sum: "SUM",
    radio: "RADIO",
    users: "USERS",
    pod: "PODCAST",
    purchase: "PURCHASE",
    wd: "WD"
};
var searchType, inSearch, updatingModal, btnGoWeb;
var fromSearch = false;
var progressModal, reviseRadios;
$(document).ready(function() {
    initViews();
    translatePage();
    initSelections();
    checkWindowWidth();
    checkUser();
    (0, _common.reformatPaste)();
});
function initViews() {
    nav = document.getElementById("nav");
    btnToggleNav = document.getElementById("btnToggleNav");
    navs = navList.querySelectorAll("a");
    mainContent = document.getElementById("mainContent");
    navContent = document.getElementById("navContent");
    navMeat = mainContent.querySelectorAll(".meat");
    navTitles = navList.querySelectorAll("a .title");
    editContent = document.getElementById("editContent");
    radioContent = document.getElementById("radioContent");
    userContent = document.getElementById("userContent");
    podContent = document.getElementById("podContent");
    imgLogo = document.getElementById("imgRadioLogo");
    imgBanner = document.getElementById("imgRadioBanner");
    inRadioName = document.getElementById("inRadioName");
    inSlogan = document.getElementById("inSlogan");
    inStream = document.getElementById("inStream");
    inLocation = document.getElementById("inLocation");
    inEmail = document.getElementById("inEmail");
    inPhone = document.getElementById("inPhone");
    inWeb = document.getElementById("inWeb");
    radioAlert = radioContent.querySelector(".alert span");
    inDesc = document.getElementById("inDesc");
    elAudio = radioContent.querySelector("audio");
    pAudioAlert = document.getElementById("pAudioAlert").querySelector("span");
    btnRequestInfo = document.getElementById("btnRequestInfo");
    btnReject = document.getElementById("btnReject");
    btnApprove = document.getElementById("btnApprove");
    btnUpdate = document.getElementById("btnUpdate");
    btnGoStream = document.getElementById("btnGoStream");
    inAdminName = document.getElementById("inAdminName");
    pAdminId = document.getElementById("pAdminId").querySelector("span");
    iAdminId = document.getElementById("pAdminId").querySelector("i");
    pRequestDate = document.getElementById("pRequestDate").querySelector("span");
    iRequestDate = document.getElementById("pRequestDate").querySelector("i");
    pRadioId = document.getElementById("pRadioId").querySelector("span");
    iRadioId = document.getElementById("pRadioId").querySelector("i");
    btnBack = document.getElementById("btnBack");
    inWebStream = document.getElementById("inWebStream");
    dWelcome = document.getElementById("dWelcome");
    inWelcome = document.getElementById("inWelcome");
    dTestStream = document.getElementById("dTestStream");
    inTestUrl = document.getElementById("inTestUrl");
    lblTestUrl = document.getElementById("lblTestUrl");
    btnTestUrl = document.getElementById("btnTestUrl");
    btnAddCoinPack = document.getElementById("btnAddCoinPack");
    btnAddProduct = document.getElementById("btnAddProduct");
    btnClearSearch = document.getElementById("btnClearSearch");
    btnSearch = document.getElementById("btnSearch");
    divResults = document.getElementById("divResults");
    pResultLoader = document.getElementById("pResultLoader");
    pEmpty = divResults.querySelector(".empty");
    spName = document.getElementById("spName");
    spNotFound = document.getElementById("spNotFound");
    divSearchList = document.getElementById("divSearchList");
    inSearch = document.getElementById("inSearch");
    updatingModal = document.getElementById("updatingModal");
    btnGoWeb = document.getElementById("btnGoWeb");
    btnRadioRevision = document.getElementById("btnRadioRevision");
    progressModal = document.getElementById("progressModal");
    reviseRadios = document.getElementById("reviseRadios");
}
function checkWindowWidth() {
    var navDisplay = nav.style.display;
    if (window.innerWidth <= 840) {
        if (navDisplay == "" || navDisplay == "none") btnToggleNav.title = trans.showNavMenu;
        else btnToggleNav.title = trans.hideNavMenu;
    }
}
function checkUser() {
    const msg = progress.querySelector(".message");
    msg.textContent = trans.requestingInfo;
    (0, _common.setDisplay)(progress, "flex");
    firebase.auth().onAuthStateChanged(function(user) {
        const btnLogin = login.querySelector("button");
        (0, _common.disableButton)(btnLogin, false);
        if (user) {
            msg.textContent = trans.verifyingInfo;
            uid = user.uid;
            checkPermission(uid);
        } else //Request login
        requestLogin();
    });
}
function requestLogin() {
    (0, _common.setDisplay)(progress, "none");
    (0, _common.setDisplay)(login, "flex");
    const inputs = login.querySelectorAll("input");
    const elEmail = inputs[0];
    const elPass = inputs[1];
    const elMsg = login.querySelector(".message span");
    const btnLogin = login.querySelector("button");
    btnLogin.addEventListener("click", function() {
        var email = elEmail.value.trim();
        var pass = elPass.value.trim();
        if (email == "") {
            elMsg.textContent = trans.invalidEmail;
            (0, _common.setDisplay)(login.querySelector(".message"), "flex");
            $(elEmail).shake();
        } else if (pass == "") {
            elMsg.textContent = trans.invalidPassword;
            (0, _common.setDisplay)(login.querySelector(".message"), "flex");
            $(elPass).shake();
        } else {
            (0, _common.disableButton)(btnLogin, true);
            loginUser(email, pass);
        }
    });
}
function loginUser(email, pass) {
    progress.querySelector(".message").textContent = trans.signingIn;
    (0, _common.setDisplay)(progress, "flex");
    const inputs = login.querySelectorAll("input");
    const elEmail = inputs[0];
    const elPass = inputs[1];
    const elMsg = login.querySelector(".message span");
    const btnLogin = login.querySelector("button");
    firebase.auth().signInWithEmailAndPassword(email, pass).catch(function(error) {
        var errorCode = error.code;
        (0, _common.disableButton)(btnLogin, false);
        (0, _common.setDisplay)(login.querySelector(".message"), "block");
        (0, _common.setDisplay)(progress, "none");
        switch(errorCode){
            case "auth/invalid-email":
                elMsg.textContent = trans.invalidEmail;
                $(elEmail).shake();
                break;
            case "auth/user-disabled":
                elMsg.textContent = trans.userDisabled;
                break;
            case "auth/user-not-found":
                elMsg.textContent = trans.userNotFound;
                break;
            case "auth/wrong-password":
                elMsg.textContent = trans.invalidPassword;
                elPass.value = "";
                $(elPass).shake();
                break;
            default:
                elMsg.textContent = trans.unknownError;
                break;
        }
    });
}
function checkPermission(userId) {
    var adminRef = firebase.database().ref("App/cm-admin/" + userId);
    adminRef.on("value", function(data) {
        (0, _common.setDisplay)(progress, "none");
        if (data.exists()) {
            //Authorized user
            (0, _common.setDisplay)(login, "none");
            (0, _common.showToast)(trans.loadingData, "toast");
            if (firstInit) {
                initClasses();
                initMainListeners();
                firstInit = false;
            }
            initData();
        } else //Unauthorized user
        denyPermission();
    });
}
function denyPermission() {
    var msg = login.querySelector(".message");
    msg.querySelector("span").textContent = trans.permissionDenied;
    (0, _common.setDisplay)(msg, "flex");
    requestLogin();
}
function initMainListeners() {
    btnToggleNav.addEventListener("click", function() {
        toggleNav();
    });
    var copyButtons = links.querySelectorAll("button");
    var aLinks = links.querySelectorAll("a span");
    for(let index = 0; index < copyButtons.length; index++){
        const element = copyButtons[index];
        element.addEventListener("click", function() {
            (0, _common.copyText)(aLinks[index]);
            (0, _common.showToast)("Text copied", "toast");
        });
    }
    var aTranslate1 = document.getElementById("aTranslate");
    aTranslate1.addEventListener("click", function() {
        (0, _common.setDisplay)("langDropdown", "flex");
    });
    window.onclick = function(event) {
        if (!event.target.matches(".dropbtn")) (0, _common.setDisplay)("langDropdown", "none");
        if (!event.target.matches("#imgProfile")) (0, _common.setDisplay)(uOptions, "none");
    };
    aEn.addEventListener("click", function() {
        translatePage("en");
    });
    aEs.addEventListener("click", function() {
        translatePage("es");
    });
    for(let index = 0; index < navs.length; index++){
        const nav = navs[index];
        nav.addEventListener("click", function() {
            if (uid) {
                checkPhoneNav();
                displayContent(index);
            } else (0, _common.showToast)(trans.permissionDenied, "toast");
        });
    }
    inScroll.querySelector(".uv").addEventListener("click", function() {
        verify.scrollIntoView();
    });
    inScroll.querySelector(".ve").addEventListener("click", function() {
        verified.scrollIntoView();
    });
    $(mainContent).scroll(function() {
        if (isMainContent && mainNav > 0) scrollFunction(mainContent, inScroll, 50);
    });
    imgProfile.addEventListener("click", function() {
        showUserOptions();
    });
    btnLogout.addEventListener("click", function() {
        confirmLogout();
    });
    signout.querySelector(".btn-close").addEventListener("click", function() {
        (0, _common.setDisplay)(signout, "none");
    });
    signout.querySelector(".btn-blue").addEventListener("click", function() {
        logout();
    });
    confirmDialog.querySelector(".btn-close").addEventListener("click", function() {
        (0, _common.setDisplay)(confirmDialog, "none");
    });
    reasonDialog.querySelector(".btn-close").addEventListener("click", function() {
        (0, _common.setDisplay)(reasonDialog, "none");
    });
    podReasonDialog.querySelector(".btn-close").addEventListener("click", function() {
        (0, _common.setDisplay)(podReasonDialog, "none");
    });
    wdDeclineDialog.querySelector(".btn-close").addEventListener("click", function() {
        (0, _common.setDisplay)(wdDeclineDialog, "none");
    });
    btnBack.addEventListener("click", function() {
        showMainContent();
    });
    elAudio.addEventListener("error", function(e) {
        var noSourcesLoaded = this.networkState === HTMLMediaElement.NETWORK_NO_SOURCE;
        initAudioAlert(noSourcesLoaded);
    // if (noSourcesLoaded) {
    //   initAudioAlert(true);
    // }
    }, true);
    btnTestUrl.addEventListener("click", function() {
        var url = inTestUrl.value.trim();
        if (url != "") initAudio(url);
        else $(inTestUrl).shake();
    });
    btnRequestInfo.addEventListener("click", function() {
        if (iRadioInfo != null && xRadioId != null) showReasonDialog(false);
    });
    btnReject.addEventListener("click", function() {
        if (iRadioInfo != null && xRadioId != null) ConfirmDeleteRadio();
    });
    btnApprove.addEventListener("click", function() {
        if (iRadioInfo != null && xRadioId != null) confirmApproval();
    });
    btnUpdate.addEventListener("click", function() {
        if (iRadioInfo != null && xRadioId != null) updateRadio();
    });
    var undoBtns = radioContent.querySelectorAll(".undo");
    for(let index = 0; index < undoBtns.length; index++){
        const btnUndo = undoBtns[index];
        btnUndo.addEventListener("click", function() {
            if (iRadioInfo != null) resetInput(index);
        });
    }
    var lReasons = reasonDialog.querySelectorAll("input");
    lReasons.forEach((element)=>{
        element.addEventListener("click", function() {
            (0, _common.setDisplay)(taOther, rad4.checked ? "block" : "none");
        });
    });
    var wdReasons = wdDeclineDialog.querySelectorAll("input");
    wdReasons.forEach((element)=>{
        element.addEventListener("click", function() {
            (0, _common.setDisplay)(wdTaOther, wdRad3.checked ? "block" : "none");
        });
    });
    var lPodReasons = podReasonDialog.querySelectorAll("input");
    lPodReasons.forEach((element)=>{
        element.addEventListener("click", function() {
            (0, _common.setDisplay)(taPodOther, podRad4.checked ? "block" : "none");
        });
    });
    unverifiedTotal.addEventListener("click", function() {
        displayContent(1);
        verify.scrollIntoView();
    });
    radioTotal.addEventListener("click", function() {
        displayContent(1);
        verified.scrollIntoView();
    });
    userTotal.addEventListener("click", function() {
        displayContent(2);
    });
    unverifiedPodTotal.addEventListener("click", function() {
        displayContent(3);
        podVerify.scrollIntoView();
    });
    podTotal.addEventListener("click", function() {
        displayContent(3);
        podVerified.scrollIntoView();
    });
    var podUndoBtns = podContent.querySelectorAll(".undo");
    for(let index = 0; index < podUndoBtns.length; index++){
        const btnUndo = podUndoBtns[index];
        btnUndo.addEventListener("click", function() {
            if (iPodContent != null) resetPodInput(index);
        });
    }
    //for podcasts
    btnRequestPodInfo.addEventListener("click", function() {
        if (iPodContent != null && xPodId != null) showPodReasonDialog(false);
    });
    btnRejectPod.addEventListener("click", function() {
        if (iPodContent != null && xPodId != null) ConfirmDeletePod();
    });
    btnApprovePod.addEventListener("click", function() {
        if (iPodContent != null && xPodId != null) //todo: test approval, test send message, test reject
        //todo: feed and title unique in android (add url in podcast class if title taken
        //todo: ex: Talk Show > url = talk-show1) allow users to edit their url (check if unique)
        confirmPodApproval();
    });
    btnUpdatePod.addEventListener("click", function() {});
    btnSearch.addEventListener("click", function() {
        var search1 = inSearch.value.trim();
        if (search1) searchGroup(search1);
    });
    btnClearSearch.addEventListener("click", function() {
        clearSearch();
    });
    inSearch.addEventListener("keyup", function(event) {
        if ("Enter" === event.key) {
            event.preventDefault();
            btnSearch.click();
        }
    });
    $(btnRadioRevision).click(function(e) {
        e.stopPropagation();
        addRadioRevision();
    });
}
function addRadioRevision() {
    if (iRadioInfo != null && xRadioId != null) {
        progressModal.querySelector("span").textContent = trans.addingRevision;
        (0, _common.setDisplay)(progressModal, "flex");
        var reviseRef = firebase.database().ref(`checkRadio/${xRadioId}`);
        var date = new Date().getTime();
        reviseRef.set(date, function(error) {
            if (error) (0, _common.showToast)(trans.unknownError, "toast");
            else (0, _common.showToast)(trans.successRevision, "toast");
            (0, _common.setDisplay)(progressModal, "none");
        });
    }
}
function updateRadio() {
    (0, _common.setDisplay)(updatingModal, "flex");
    var nRadioClass = radioClass;
    nRadioClass.admin_ID = iRadioInfo.admin_ID;
    nRadioClass.admin_Name = iRadioInfo.admin_Name;
    nRadioClass.admin_Pass = iRadioInfo.admin_Pass ? iRadioInfo.admin_Pass : iRadioInfo.admin_pass ? iRadioInfo.admin_pass : "0";
    nRadioClass.radio_ID = xRadioId;
    nRadioClass.radio_image = iRadioInfo.radio_image ? iRadioInfo.radio_image : null;
    nRadioClass.banner = iRadioInfo.banner ? iRadioInfo.banner : null;
    var radioName = inRadioName.value.trim().replace(/--/g, "-");
    var slogan = inSlogan.value.trim();
    var stream = inStream.value.trim();
    var desc = inDesc.value.trim();
    var phone = inPhone.value.trim();
    var location = inLocation.value.trim();
    var email = inEmail.value.trim();
    var web = inWeb.value.trim();
    var webStream = inWebStream.value.trim();
    nRadioClass.radio_Name = radioName != "" ? radioName : iRadioInfo.radio_Name.replace(/--/g, "-");
    nRadioClass.radio_Slogan = slogan != "" ? slogan : iRadioInfo.radio_Slogan ? iRadioInfo.radio_Slogan : null;
    nRadioClass.phone_no = phone != "" ? phone : iRadioInfo.phone_no ? iRadioInfo.phone_no : null;
    nRadioClass.radio_location = location != "" ? location : iRadioInfo.radio_location;
    nRadioClass.radio_Stream = stream != "" ? stream : iRadioInfo.radio_Stream;
    nRadioClass.radio_Description = desc != "" ? desc : iRadioInfo.radio_Description;
    nRadioClass.radio_email = email != "" ? email : iRadioInfo.radio_email ? iRadioInfo.radio_email : null;
    nRadioClass.website = web != "" ? web : iRadioInfo.website ? iRadioInfo.website : null;
    nRadioClass.webStream = webStream != "" ? webStream : iRadioInfo.webStream ? iRadioInfo.webStream : null;
    if (nRadioClass.radio_email != null && !nRadioClass.radio_email.includes("@")) nRadioClass.radio_email = null;
    nRadioClass.lowCaseName = nRadioClass.radio_Name.toLowerCase();
    nRadioClass.date_created = iRadioInfo.date_created;
    // Check if name changed
    if (nRadioClass.radio_Name != iRadioInfo.radio_Name) //check if radio name already exists
    checkRadioName(nRadioClass);
    else if (nRadioClass.radio_Stream != iRadioInfo.radio_Stream) //check if radio stream already exists
    checkRadioStream(nRadioClass);
    else //Nothing changed, upload info
    uploadRadioChanges(nRadioClass);
}
function checkRadioName(nRadioClass) {
    var radiosRef = firebase.database().ref("Radio Stations");
    radiosRef.orderByChild("info/radio_Name").equalTo(nRadioClass.radio_Name).once("value", function(snapshot) {
        if (snapshot.exists()) {
            //Radio name taken
            (0, _common.showToast)(trans.errorRadioNameTaken, "toast");
            (0, _common.setDisplay)(updatingModal, "none");
        } else if (nRadioClass.radio_Stream != iRadioInfo.radio_Stream) //check if radio stream already exists
        checkRadioStream(nRadioClass);
        else //Nothing changed, upload info
        uploadRadioChanges(nRadioClass);
    });
}
function checkRadioStream(nRadioClass) {
    var radiosRef = firebase.database().ref("Radio Stations");
    radiosRef.orderByChild("info/radio_Stream").equalTo(nRadioClass.radio_Name).once("value", function(snapshot) {
        if (snapshot.exists()) {
            //Radio name taken
            (0, _common.showToast)(trans.errorRadioStreamTaken, "toast");
            (0, _common.setDisplay)(updatingModal, "none");
        } else //check if radio stream already exists
        uploadRadioChanges(nRadioClass);
    });
}
function uploadRadioChanges(nRadioClass) {
    var radioRef = firebase.database().ref("Radio Stations/" + xRadioId + "/info");
    radioRef.set(nRadioClass, function(error) {
        if (error) (0, _common.showToast)(trans.unknownError, "toast");
        else (0, _common.showToast)(trans.successUpdate, "toast");
        (0, _common.setDisplay)(updatingModal, "none");
    });
}
function searchGroup(search1) {
    if (searchType == null) return;
    (0, _common.setDisplay)(btnClearSearch, "block");
    (0, _common.setDisplay)(divResults, "block");
    (0, _common.setDisplay)(pResultLoader, "block");
    (0, _common.setDisplay)(pEmpty, "none");
    switch(searchType){
        case SearchType.radio:
            searchRadios(search1);
            break;
        case SearchType.pod:
            break;
        default:
            break;
    }
}
function searchRadios(search1) {
    let lSearch = search1.toLowerCase();
    var searchQuery = firebase.database().ref("Radio Stations").orderByChild("info/lowCaseName").startAt(lSearch).endAt(lSearch + "");
    searchQuery.once("value", function(data) {
        if (data.exists()) {
            (0, _common.setDisplay)(pEmpty, "none");
            data.forEach(function(radio) {
                if (document.getElementById(radio.key + "search")) divSearchList.textContent = "";
                addRadio(radio.key, "search", radio.val().info, divSearchList, true, null);
            });
        } else {
            spName.textContent = search1;
            (0, _common.setDisplay)(pEmpty, "block");
            divSearchList.textContent = "";
        }
        (0, _common.setDisplay)(pResultLoader, "none");
    });
}
function checkPodName(nPod) {
    var podRef = firebase.database().ref("podcast");
    podRef.orderByChild("feed").equalTo(nPod.feed).once("value", function(data) {
        if (data.exists()) {
            (0, _common.setDisplay)(progress, "none");
            (0, _common.showToast)(trans.errorFeedExists, "toast");
            $(inFeed).shake();
        } else {
            var podRef = firebase.database().ref("podcast");
            podRef.orderByChild("title").equalTo(nPod.title).once("value", function(data) {
                if (data.exists()) {
                    var lnk = nPod.title.replace(/--/g, "_");
                    lnk = lnk.replace(/\s+/g, "-");
                    lnk = lnk.replace(/_/g, "--");
                    nPod.url = "p=" + lnk + "id=" + (0, _common.getRandomNum)();
                    // setDisplay(progress, "none");
                    // showToast(trans.errorPodNameExists, "toast");
                    // $(inPodTitle).shake();
                    verifyPod(nPod);
                } else verifyPod(nPod);
            });
        }
    });
}
function confirmPodApproval() {
    const dialog = document.getElementById("confirmDialog");
    const btnRed = dialog.querySelector(".redBtn");
    const btnBlue = dialog.querySelector(".blueBtn");
    $(btnBlue).unbind();
    $(btnRed).unbind();
    $(btnBlue).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
        //check radio information for completion
        checkPodInfo();
    });
    $(btnRed).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
    });
    dialog.querySelector("h3 span").textContent = trans.confirmApprove;
    dialog.querySelector(".msg").innerHTML = trans.podApprovalMsg;
    (0, _common.setDisplay)(dialog, "flex");
}
function checkPodInfo() {
    //inAdminName.value.trim(),inRadioName.value.trim(),
    //inDescription.value.trim(),inRadioStream.value.trim(),
    //inPassword.value.trim(),countries.value, inRadioEmail.value.trim())
    progress.querySelector(".message").innerHTML = trans.verifyingPodInfo;
    (0, _common.setDisplay)(progress, "flex");
    var nPodClass = podClass;
    nPodClass.uid = iPodContent.uid;
    nPodClass.icon = iPodContent.icon ? iPodContent.icon : null;
    nPodClass.host = iPodContent.host ? iPodContent.host : null;
    nPodClass.lang = selPodLang.selectedIndex;
    nPodClass.genre = selGenres.selectedIndex;
    var email = inHostEmail.value.trim();
    var podEmail = inPodEmail.value.trim();
    var podName = inPodTitle.value.trim().replace(/--/g, "-");
    var feed = inFeed.value.trim();
    var desc = inPodDesc.value.trim();
    var country = (0, _common.getCountryCode)(selPodCountry.selectedIndex).toLowerCase();
    var web = inPodWeb.value.trim().replace("n/a", "");
    var phone = inPodPhone.value.trim().replace("n/a", "");
    var fb = inFb.value.trim();
    var tw = inTw.value.trim();
    var ins = inIn.value.trim();
    var yt = inYt.value.trim();
    var tk = inTk.value.trim();
    var msgWelcome = inPodWelcome.value.trim().replace("n/a", "");
    nPodClass.fb = fb ? fb : iPodContent.fb ? iPodContent.fb : null;
    nPodClass.tw = tw ? tw : iPodContent.tw ? iPodContent.tw : null;
    nPodClass.ig = ins ? ins : iPodContent.ig ? iPodContent.ig : null;
    nPodClass.yt = yt ? yt : iPodContent.yt ? iPodContent.yt : null;
    nPodClass.tk = tk ? tk : iPodContent.tk ? iPodContent.tk : null;
    nPodClass.msgWelcome = msgWelcome ? msgWelcome : iPodContent.msgWelcome ? iPodContent.msgWelcome : null;
    nPodClass.title = podName != "" ? podName : iPodContent.title.replace(/--/g, "-");
    nPodClass.phone = phone != "" ? phone : iPodContent.phone ? iPodContent.phone : null;
    nPodClass.country = country != "" ? country : iPodContent.country;
    nPodClass.feed = feed != "" ? feed : iPodContent.feed;
    nPodClass.desc = desc != "" ? desc : iPodContent.desc;
    nPodClass.email = email != "" ? email : iPodContent.email ? iPodContent.email : null;
    nPodClass.pod_email = podEmail != "" ? podEmail : iPodContent.pod_email ? iPodContent.pod_email : null;
    nPodClass.web = web != "" ? web : iPodContent.web ? iPodContent.web : null;
    if (!nPodClass.pod_email.includes("@")) nPodClass.pod_email = null;
    nPodClass.lcTitle = nPodClass.title.toLowerCase();
    nPodClass.date = new Date().getTime();
    nPodClass.verified = true;
    checkPodName(nPodClass);
}
function verifyPod(nPod) {
    progress.querySelector(".message").innerHTML = trans.uploadingInfo;
    //Upload to Radio Stations
    var podRef = firebase.database().ref("podcast/" + xPodId);
    podRef.set(nPod, function(error) {
        if (error) {
            (0, _common.setDisplay)(progress, "none");
            (0, _common.showToast)(trans.unknownError, "toast");
        } else {
            var userPodRef = firebase.database().ref("Users/" + nPod.uid + "/podcast/" + xPodId);
            userPodRef.set(true, function(error) {
                if (error) {
                    podRef.remove();
                    (0, _common.setDisplay)(progress, "none");
                    (0, _common.showToast)(trans.unknownError, "toast");
                } else {
                    var genreRef = firebase.database().ref(`tag/genre/podcast/${nPod.genre}/${xPodId}`);
                    genreRef.set(nPod.date, function(error) {
                        if (error) {
                            podRef.remove();
                            (0, _common.setDisplay)(progress, "none");
                            (0, _common.showToast)(trans.unknownError, "toast");
                        } else {
                            var countryRef = firebase.database().ref(`tag/country/podcast/${nPod.country}/${xPodId}`);
                            countryRef.set(nPod.date, function(error) {
                                if (error) {
                                    genreRef.remove();
                                    podRef.remove();
                                    (0, _common.setDisplay)(progress, "none");
                                    (0, _common.showToast)(trans.unknownError, "toast");
                                } else {
                                    var langRef = firebase.database().ref(`tag/lang/podcast/${nPod.lang}/${xPodId}`);
                                    langRef.set(nPod.date, function(error) {
                                        if (error) {
                                            countryRef.remove();
                                            genreRef.remove();
                                            podRef.remove();
                                            (0, _common.setDisplay)(progress, "none");
                                            (0, _common.showToast)(trans.unknownError, "toast");
                                        } else removePodVerify(nPod);
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }
    });
}
function removePodVerify(nPod) {
    progress.querySelector(".message").innerHTML = trans.verifyingInfo;
    (0, _common.setDisplay)(progress, "flex");
    var verifyRef = firebase.database().ref(`verify/podcast/${xPodId}`);
    verifyRef.remove(function(error) {
        if (error) {
            (0, _common.setDisplay)(progress, "none");
            (0, _common.showToast)(trans.unknownError, "toast");
        } else {
            showMainContent();
            //Send Alert
            sendVerifiedPodAlert(nPod);
        }
    });
}
function sendVerifiedPodAlert(nPod) {
    progress.querySelector(".message").innerHTML = trans.sendingConfirmation;
    var alert = {
        date: new Date().getTime(),
        type: "podcast",
        reason: 4,
        email: nPod.email ? nPod.email : null,
        rName: nPod.title ? nPod.title : null,
        uName: inPodAdmin.value ? inPodAdmin.value : null,
        msg: null,
        sub: trans.sub1,
        from: uiName,
        fromId: uid ? uid : null
    };
    alert.sub = alert.sub.replace("$name", alert.rName ? alert.rName : "");
    var message = trans.approvePodEmail.replace("$name", nPod.title);
    var lnk = nPod.title.replace(/--/g, "_");
    lnk = lnk.replace(/\s+/g, "-");
    lnk = lnk.replace(/_/g, "--");
    message = message.replace(/\$wName/g, lnk);
    message = message.replace("$urlSsl", "");
    message += "<br><br>" + trans.concludeMsg;
    alert.msg = message;
    var verifyRef = firebase.database().ref(`alert/${nPod.uid}/${xPodId}`);
    verifyRef.set(alert, function(error) {
        (0, _common.setDisplay)(progress, "none");
        if (error) //request failed
        (0, _common.showToast)(trans.unknownError, "toast", 2500);
        else //request sent
        (0, _common.showToast)(trans.podApproved, "toast", 2500);
    });
}
function resetPodInput(index) {
    switch(index){
        case 0:
            var hostEmail = iPodContent.email;
            inHostEmail.value = hostEmail ? hostEmail : "";
            break;
        case 1:
            var title = iPodContent.title;
            inPodTitle.value = title ? title : "";
            break;
        case 2:
            var oDesc = iPodContent.desc;
            inPodDesc.value = oDesc ? oDesc : "";
            break;
        case 3:
            var oStream = iPodContent.feed;
            inFeed.value = oStream ? oStream : "";
            break;
        case 4:
            var genre = iPodContent.genre;
            selGenres.selectedIndex = genre ? genre : "";
            break;
        case 5:
            var lang = iPodContent.lang;
            selPodLang.selectedIndex = lang ? lang : "";
            break;
        case 6:
            var country = iPodContent.country;
            selPodCountry.selectedIndex = country ? (0, _common.getCountryIndex)(country.toUpperCase()) : (0, _common.getCountryIndex)("US");
            break;
        case 7:
            var wMsg = iPodContent.welcomeMsg;
            inPodWelcome.value = wMsg ? wMsg : "n/a";
            break;
        case 8:
            var oWeb = iPodContent.web;
            inPodWeb.value = oWeb ? oWeb : "n/a";
            break;
        case 9:
            var phone = iPodContent.phone;
            inPodPhone.value = phone ? phone : "n/a";
            break;
        case 10:
            var podEmail = iPodContent.pod_email;
            inPodEmail.value = podEmail ? podEmail : "n/a";
            break;
        case 11:
            var fb = iPodContent.fb;
            inFb.value = fb ? fb : "";
            break;
        case 12:
            var tw = iPodContent.tw;
            inTw.value = tw ? tw : "";
            break;
        case 13:
            var insta = iPodContent.ig;
            inIn.value = insta ? insta : "";
            break;
        case 14:
            var yt = iPodContent.yt;
            inYt.value = yt ? yt : "";
            break;
        case 15:
            var tk = iPodContent.tk;
            inTk.value = tk ? tk : "";
            break;
        default:
            break;
    }
}
function confirmApproval() {
    const dialog = document.getElementById("confirmDialog");
    const btnRed = dialog.querySelector(".redBtn");
    const btnBlue = dialog.querySelector(".blueBtn");
    $(btnBlue).unbind();
    $(btnRed).unbind();
    $(btnBlue).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
        //check radio information for completion
        checkRadioInfo();
    });
    $(btnRed).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
    });
    dialog.querySelector("h3 span").textContent = trans.confirmApprove;
    dialog.querySelector(".msg").innerHTML = trans.approvalMsg;
    (0, _common.setDisplay)(dialog, "flex");
}
function checkRadioInfo() {
    //inAdminName.value.trim(),inRadioName.value.trim(),
    //inDescription.value.trim(),inRadioStream.value.trim(),
    //inPassword.value.trim(),countries.value, inRadioEmail.value.trim())
    progress.querySelector(".message").innerHTML = trans.verifyingRadioInfo;
    (0, _common.setDisplay)(progress, "flex");
    var nRadioClass = radioClass;
    nRadioClass.admin_ID = iRadioInfo.admin_ID;
    nRadioClass.admin_Name = iRadioInfo.admin_Name;
    nRadioClass.admin_Pass = iRadioInfo.admin_Pass ? iRadioInfo.admin_Pass : iRadioInfo.admin_pass ? iRadioInfo.admin_pass : "0";
    nRadioClass.radio_ID = xRadioId;
    nRadioClass.radio_image = iRadioInfo.radio_image ? iRadioInfo.radio_image : null;
    nRadioClass.banner = iRadioInfo.banner ? iRadioInfo.banner : null;
    var radioName = inRadioName.value.trim().replace(/--/g, "-");
    var slogan = inSlogan.value.trim();
    var stream = inStream.value.trim();
    var desc = inDesc.value.trim();
    var phone = inPhone.value.trim();
    var location = inLocation.value.trim();
    var email = inEmail.value.trim();
    var web = inWeb.value.trim();
    var webStream = inWebStream.value.trim();
    nRadioClass.radio_Name = radioName != "" ? radioName : iRadioInfo.radio_Name.replace(/--/g, "-");
    nRadioClass.radio_Slogan = slogan != "" ? slogan : iRadioInfo.radio_Slogan ? iRadioInfo.radio_Slogan : null;
    nRadioClass.phone_no = phone != "" ? phone : iRadioInfo.phone_no ? iRadioInfo.phone_no : null;
    nRadioClass.radio_location = location != "" ? location : iRadioInfo.radio_location;
    nRadioClass.radio_Stream = stream != "" ? stream : iRadioInfo.radio_Stream;
    nRadioClass.radio_Description = desc != "" ? desc : iRadioInfo.radio_Description;
    nRadioClass.radio_email = email != "" ? email : iRadioInfo.radio_email ? iRadioInfo.radio_email : null;
    nRadioClass.website = web != "" ? web : iRadioInfo.website ? iRadioInfo.website : null;
    nRadioClass.webStream = webStream != "" ? webStream : iRadioInfo.webStream ? iRadioInfo.webStream : null;
    if (!nRadioClass.radio_email.includes("@")) nRadioClass.radio_email = null;
    nRadioClass.lowCaseName = nRadioClass.radio_Name.toLowerCase();
    nRadioClass.date_created = new Date().getTime();
    verifyRadio(nRadioClass);
}
function verifyRadio(nRadio) {
    progress.querySelector(".message").innerHTML = trans.uploadingInfo;
    //Upload to Radio Stations
    var radiosRef = firebase.database().ref("Radio Stations/" + xRadioId + "/info");
    radiosRef.set(nRadio, function(error) {
        if (error) {
            //message failed
            (0, _common.setDisplay)(progress, "none");
            (0, _common.showToast)(trans.unknownError, "toast");
        } else {
            //Upload radioInfo
            var userRadiosRef = firebase.database().ref("Users/" + nRadio.admin_ID + "/My_Radios/" + xRadioId + "/verified");
            userRadiosRef.set(true, function(error) {
                if (error) {
                    //message failed
                    (0, _common.setDisplay)(progress, "none");
                    (0, _common.showToast)(trans.unknownError, "toast");
                } else {
                    //Upload userProfile
                    if (xRadioAdmin.date_created) xRadioAdmin.date_created = nRadio.date_created;
                    var adminRadioRef = firebase.database().ref("Radio Stations/" + xRadioId + "/Administrators/" + nRadio.admin_ID);
                    adminRadioRef.set(xRadioAdmin, function(error) {
                        if (error) {
                            //message failed
                            (0, _common.setDisplay)(progress, "none");
                            (0, _common.showToast)(trans.unknownError, "toast");
                        } else {
                            //delete unverified reference
                            var ownerRef = firebase.database().ref("owner/" + xRadioId + "/" + nRadio.admin_ID);
                            var role = {
                                date: nRadio.date_created,
                                img: xRadioAdmin.profile_Image ? xRadioAdmin.profile_Image : null,
                                lcName: xRadioAdmin.name.toLowerCase(),
                                name: xRadioAdmin.name,
                                owner: true
                            };
                            ownerRef.set(role, function(error) {
                                if (error) {
                                    (0, _common.setDisplay)(progress, "none");
                                    (0, _common.showToast)(trans.unknownError, "toast");
                                } else {
                                    var roleRef = firebase.database().ref(`role/${nRadio.admin_ID}/${xRadioId}/owner`);
                                    roleRef.set(true, function(error) {
                                        if (error) {
                                            (0, _common.setDisplay)(progress, "none");
                                            (0, _common.showToast)(trans.unknownError, "toast");
                                        } else removeVerify(nRadio);
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }
    });
}
function removeVerify(nRadio) {
    progress.querySelector(".message").innerHTML = trans.verifyingInfo;
    (0, _common.setDisplay)(progress, "flex");
    var verifyRef = firebase.database().ref(`verify/radio/${xRadioId}`);
    verifyRef.remove(function(error) {
        if (error) {
            (0, _common.setDisplay)(progress, "none");
            (0, _common.showToast)(trans.unknownError, "toast");
        } else {
            showMainContent();
            //Send Alert
            sendVerifiedAlert(nRadio);
        }
    });
}
function sendVerifiedAlert(nRadio) {
    progress.querySelector(".message").innerHTML = trans.sendingConfirmation;
    var alert = {
        date: new Date().getTime(),
        type: "radio",
        reason: 4,
        email: nRadio.radio_email ? nRadio.radio_email : null,
        rName: nRadio.radio_Name ? nRadio.radio_Name : null,
        uName: nRadio.admin_Name ? nRadio.admin_Name : null,
        msg: null,
        sub: trans.sub1,
        from: uiName,
        fromId: uid ? uid : null
    };
    alert.sub = alert.sub.replace("$name", alert.rName ? alert.rName : "");
    var message = trans.approveEmail.replace("$name", nRadio.radio_Name);
    var lnk = nRadio.radio_Name.replace(/--/g, "_");
    lnk = lnk.replace(/\s+/g, "-");
    lnk = lnk.replace(/_/g, "--");
    message = message.replace(/\$wName/g, lnk);
    if (!nRadio.radio_Stream.startsWith("https") && nRadio.webStream == null) message = message.replace("$urlSsl", trans.urlUnsecureMsg);
    else message = message.replace("$urlSsl", "");
    message += "<br><br>" + trans.concludeMsg;
    alert.msg = message;
    var verifyRef = firebase.database().ref(`alert/${nRadio.admin_ID}/${xRadioId}`);
    verifyRef.set(alert, function(error) {
        (0, _common.setDisplay)(progress, "none");
        if (error) //request failed
        (0, _common.showToast)(trans.unknownError, "toast", 2500);
        else //request sent
        (0, _common.showToast)(trans.radioApproved, "toast", 2500);
    });
}
function showMainContent() {
    isMainContent = true;
    (0, _common.setDisplay)(editContent, "none");
    (0, _common.setDisplay)(mainContent, "flex");
    (0, _common.setDisplay)(search, mainNav > 0 ? "flex" : "none");
    (0, _common.setDisplay)(divResults, fromSearch ? "block" : "none");
    inTestUrl.value = "";
}
function ConfirmDeleteRadio() {
    const dialog = document.getElementById("confirmDialog");
    const btnRed = dialog.querySelector(".redBtn");
    const btnBlue = dialog.querySelector(".blueBtn");
    $(btnBlue).unbind();
    $(btnRed).unbind();
    $(btnBlue).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
        showReasonDialog(true);
    });
    $(btnRed).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
    });
    dialog.querySelector("h3 span").textContent = trans.confirmRemoval;
    dialog.querySelector(".msg").innerHTML = trans.confirmRemovalMsg.replace("$name", iRadioInfo.radio_Name);
    (0, _common.setDisplay)(dialog, "flex");
}
function ConfirmDeletePod() {
    const dialog = document.getElementById("confirmDialog");
    const btnRed = dialog.querySelector(".redBtn");
    const btnBlue = dialog.querySelector(".blueBtn");
    $(btnBlue).unbind();
    $(btnRed).unbind();
    $(btnBlue).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
        showPodReasonDialog(true);
    });
    $(btnRed).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
    });
    dialog.querySelector("h3 span").textContent = trans.confirmRemoval;
    dialog.querySelector(".msg").innerHTML = trans.confirmRemovalMsg.replace("$name", iPodContent.title);
    (0, _common.setDisplay)(dialog, "flex");
}
function showReasonDialog(isRemoving) {
    const rDialog = document.getElementById("reasonDialog");
    const btnBlue = rDialog.querySelector(".blueBtn");
    $(btnBlue).unbind();
    $(btnBlue).click(function(e) {
        e.stopPropagation;
        var numReason = rad1.checked ? 1 : rad2.checked ? 2 : rad4.checked ? 4 : 3;
        if (isRemoving) {
            if (iVerified) purgeRadio(numReason);
            else deleteRadio(numReason);
            (0, _common.setDisplay)(rDialog, "none");
        } else {
            if (numReason != 4) {
                (0, _common.setDisplay)(rDialog, "none");
                sendMessage(numReason);
            } else if (taOther.value.trim() != "") {
                (0, _common.setDisplay)(rDialog, "none");
                sendMessage(numReason);
            } else {
                $(taOther).shake();
                (0, _common.showToast)(trans.provideReason, "toast");
            }
        }
    });
    var name = iRadioInfo.admin_Name ? iRadioInfo.admin_Name : iRadioInfo.radio_Name ? iRadioInfo.radio_Name : "";
    rDialog.querySelector(".note").innerHTML = trans.removalNote.replace("$name", name);
    (0, _common.setDisplay)(rDialog, "flex");
}
function showPodReasonDialog(isRemoving) {
    const rDialog = document.getElementById("podReasonDialog");
    const btnBlue = rDialog.querySelector(".blueBtn");
    $(btnBlue).unbind();
    $(btnBlue).click(function(e) {
        e.stopPropagation;
        var numReason = podRad1.checked ? 1 : podRad2.checked ? 2 : podRad4.checked ? 4 : 3;
        if (isRemoving) {
            if (iVerified) purgePod(numReason);
            else deletePod(numReason);
            (0, _common.setDisplay)(rDialog, "none");
        } else {
            if (numReason != 4) {
                (0, _common.setDisplay)(rDialog, "none");
                sendPodMessage(numReason);
            } else if (taPodOther.value.trim() != "") {
                (0, _common.setDisplay)(rDialog, "none");
                sendPodMessage(numReason);
            } else {
                $(taPodOther).shake();
                (0, _common.showToast)(trans.provideReason, "toast");
            }
        }
    });
    var host = inPodAdmin.value;
    var name = host ? host : iPodContent.title ? iPodContent.title : "";
    rDialog.querySelector(".note").innerHTML = trans.removalNote.replace("$name", name);
    (0, _common.setDisplay)(rDialog, "flex");
}
function sendPodMessage(nReason) {
    progress.querySelector(".message").innerHTML = trans.sendingMessage;
    var alert = {
        date: new Date().getTime(),
        type: "radio",
        reason: nReason,
        email: iPodContent.email ? iPodContent.email : null,
        rName: iPodContent.title ? iPodContent.title : null,
        uName: inPodAdmin.value ? inPodAdmin.value : null,
        msg: null,
        sub: null,
        from: uiName,
        fromId: uid ? uid : null
    };
    var message = trans.m4 + "<br><br>";
    switch(nReason){
        case 1:
            alert.sub = trans.sub2;
            message += trans.r1 + "<br>" + trans.m1;
            break;
        case 2:
            alert.sub = trans.sub2;
            message += trans.r2 + "<br>" + trans.m2Pod;
            break;
        case 3:
            alert.sub = trans.sub3;
            message += trans.r3 + "<br>" + trans.m3Pod;
            break;
        case 4:
            alert.sub = trans.sub4.replace("$name", iPodContent.title);
            message += taPodOther.value.trim();
            break;
        default:
            alert.sub = "$name|ChatMurcianys";
            break;
    }
    alert.sub = alert.sub.replace("$name", iPodContent.title);
    var lnk;
    var msgPodInfo;
    if (iVerified) {
        lnk = iPodContent.title.replace(/--/g, "_");
        lnk = lnk.replace(/\s+/g, "-");
        lnk = lnk.replace(/_/g, "--");
    } else lnk = xPodId;
    var msgPodInfo = trans.updatePodInfo.replace(/\$id/g, lnk);
    msgPodInfo = msgPodInfo.replace(/\#/g, iVerified ? "" : "u");
    message += "<br><br>" + msgPodInfo + "<br><br>" + trans.concludeMsg;
    alert.msg = message;
    var verifyRef = firebase.database().ref(`alert/${iPodContent.uid}/${xPodId}`);
    verifyRef.set(alert, function(error) {
        (0, _common.setDisplay)(progress, "none");
        if (error) //request failed
        (0, _common.showToast)(trans.unknownError, "toast");
        else {
            //request sent
            taPodOther.value = "";
            podRad1.checked = true;
            (0, _common.showToast)(trans.messageSent, "toast");
        }
    });
}
function deletePod(nReason) {
    progress.querySelector(".message").innerHTML = trans.removingPod;
    (0, _common.setDisplay)(progress, "flex");
    var verifyRef = firebase.database().ref(`verify/podcast/${xPodId}`);
    verifyRef.remove(function(error) {
        if (error) {
            (0, _common.setDisplay)(progress, "none");
            (0, _common.showToast)(trans.unknownError, "toast");
        } else {
            var userPodRef = firebase.database().ref(`Users/${iPodContent.uid}/podcast/${xPodId}`);
            userPodRef.remove(function(error) {
                showMainContent();
                if (error) {
                    (0, _common.setDisplay)(progress, "none");
                    (0, _common.showToast)(trans.unknownError, "toast");
                } else //Check if radio has images
                if (iPodContent.icon) purgePodImages(nReason);
                else sendPodRemovalReason(nReason);
            });
        }
    });
}
function sendMessage(nReason) {
    progress.querySelector(".message").innerHTML = trans.sendingMessage;
    var alert = {
        date: new Date().getTime(),
        type: "radio",
        reason: nReason,
        email: iRadioInfo.radio_email ? iRadioInfo.radio_email : null,
        rName: iRadioInfo.radio_Name ? iRadioInfo.radio_Name : null,
        uName: iRadioInfo.admin_Name ? iRadioInfo.admin_Name : null,
        msg: null,
        sub: null,
        from: uiName,
        fromId: uid ? uid : null
    };
    var message = trans.m4 + "<br><br>";
    switch(nReason){
        case 1:
            alert.sub = trans.sub2;
            message += trans.r1 + "<br>" + trans.m1;
            break;
        case 2:
            alert.sub = trans.sub2;
            message += trans.r2 + "<br>" + trans.m2;
            break;
        case 3:
            alert.sub = trans.sub3;
            message += trans.r3 + "<br>" + trans.m3;
            break;
        case 4:
            alert.sub = trans.sub4.replace("$name", iRadioInfo.radio_Name);
            message += taOther.value.trim();
            break;
        default:
            alert.sub = "$name|ChatMurcianys";
            break;
    }
    alert.sub = alert.sub.replace("$name", iRadioInfo.radio_Name);
    var lnk;
    if (iVerified) {
        lnk = iRadioInfo.radio_Name.replace(/--/g, "_");
        lnk = lnk.replace(/\s+/g, "-");
        lnk = lnk.replace(/_/g, "--");
    } else lnk = xRadioId;
    var msgRadioInfo = trans.updateRadioInfo.replace(/\$id/g, lnk);
    msgRadioInfo = msgRadioInfo.replace(/\#/g, iVerified ? "" : "u");
    message += "<br><br>" + msgRadioInfo + "<br><br>" + trans.concludeMsg;
    alert.msg = message;
    var verifyRef = firebase.database().ref(`alert/${iRadioInfo.admin_ID}/${xRadioId}`);
    verifyRef.set(alert, function(error) {
        (0, _common.setDisplay)(progress, "none");
        if (error) //request failed
        (0, _common.showToast)(trans.unknownError, "toast");
        else {
            //request sent
            taOther.value = "";
            rad1.checked = true;
            (0, _common.showToast)(trans.messageSent, "toast");
        }
    });
}
function deleteRadio(nReason) {
    progress.querySelector(".message").innerHTML = trans.removingRadio;
    (0, _common.setDisplay)(progress, "flex");
    var verifyRef = firebase.database().ref(`verify/radio/${xRadioId}`);
    verifyRef.remove(function(error) {
        if (error) {
            (0, _common.setDisplay)(progress, "none");
            (0, _common.showToast)(trans.unknownError, "toast");
        } else {
            var userRadioRef = firebase.database().ref(`Users/${iRadioInfo.admin_ID}/My_Radios/${xRadioId}`);
            userRadioRef.remove(function(error) {
                showMainContent();
                if (error) {
                    (0, _common.setDisplay)(progress, "none");
                    (0, _common.showToast)(trans.unknownError, "toast");
                } else //Check if radio has images
                if (iRadioInfo.banner || iRadioInfo.radio_image) purgeRadioImages(nReason);
                else sendRemovalReason(nReason);
            });
        }
    });
}
function purgeRadioImages(nReason) {
    const storageRef = firebase.storage().ref();
    if (iRadioInfo.banner) {
        //Radio has banner
        var bannerRef = storageRef.child(`Radio Stations/${xRadioId}/Banner`);
        bannerRef.delete().then(()=>{
            if (iRadioInfo.radio_image) {
                var logoRef = storageRef.child(`Radio Stations/${xRadioId}/Logo`);
                logoRef.delete().then(()=>{
                    sendRemovalReason(nReason);
                }).catch((error)=>{
                    console.log("error: " + error);
                    sendRemovalReason(nReason);
                });
            } else sendRemovalReason(nReason);
        });
    } else if (iRadioInfo.radio_image) {
        //Radio has logo
        var logoRef = storageRef.child(`Radio Stations/${xRadioId}/Logo`);
        logoRef.delete().then(()=>{
            sendRemovalReason(nReason);
        }).catch((error)=>{
            sendRemovalReason(nReason);
            console.log("error: " + error);
        });
    } else sendRemovalReason(nReason);
}
function sendRemovalReason(nReason) {
    progress.querySelector(".message").innerHTML = trans.sendingConfirmation;
    var alert = {
        date: new Date().getTime(),
        type: "radio",
        reason: nReason,
        email: iRadioInfo.radio_email ? iRadioInfo.radio_email : null,
        rName: iRadioInfo.radio_Name ? iRadioInfo.radio_Name : null,
        uName: iRadioInfo.admin_Name ? iRadioInfo.admin_Name : null,
        msg: null,
        sub: null,
        from: uiName,
        fromId: uid ? uid : null
    };
    var message = trans.rmnMessage.replace("$name", iRadioInfo.radio_Name);
    switch(nReason){
        case 1:
            alert.sub = trans.sub2;
            message += trans.r1 + "<br>" + trans.m1;
            break;
        case 2:
            alert.sub = trans.sub2;
            message += trans.r2 + "<br>" + trans.m2;
            break;
        case 3:
            alert.sub = trans.sub3;
            message += trans.r3 + "<br>" + trans.m3;
            break;
        case 4:
            alert.sub = trans.sub4;
            message += taOther.value;
            break;
        default:
            alert.sub = "$name|ChatMurcianys";
            break;
    }
    alert.sub = alert.sub.replace("$name", iRadioInfo.name);
    message += "<br><br>" + trans.reSubmitRadio + "<br><br>" + trans.concludeMsg;
    alert.msg = message;
    var verifyRef = firebase.database().ref(`alert/${iRadioInfo.admin_ID}/${xRadioId}`);
    verifyRef.set(alert, function(error) {
        (0, _common.setDisplay)(progress, "none");
        if (error) //request failed
        (0, _common.showToast)(trans.unknownError, "toast", 2500);
        else //request sent
        (0, _common.showToast)(trans.radioRemoved, "toast", 2500);
    });
}
/**
 * remove radio from Radio Stations, My_Radios,
 * delete icons, and delete Chats/radioId
 */ function purgeRadio(nReason) {
    progress.querySelector(".message").innerHTML = trans.removingRadio;
    (0, _common.setDisplay)(progress, "flex");
    var radioRef = firebase.database().ref(`Radio Stations/${xRadioId}`);
    radioRef.remove(function(error) {
        if (error) {
            (0, _common.setDisplay)(progress, "none");
            (0, _common.showToast)(trans.unknownError, "toast");
        } else {
            var userRadioRef = firebase.database().ref(`Users/${iRadioInfo.admin_ID}/My_Radios/${xRadioId}`);
            userRadioRef.remove(function(error) {
                if (error) {
                    (0, _common.setDisplay)(progress, "none");
                    (0, _common.showToast)(trans.unknownError, "toast");
                } else {
                    //delete chat room
                    progress.querySelector(".message").innerHTML = trans.removingChat;
                    var chatRef = firebase.database().ref(`Chats/${xRadioId}`);
                    chatRef.remove(function(error) {
                        if (error) (0, _common.showToast)(trans.errorChat, "toast");
                        //Check if radio has images
                        if (iRadioInfo.banner || iRadioInfo.radio_image) {
                            progress.querySelector(".message").innerHTML = trans.removingImages;
                            purgeRadioImages(nReason);
                        } else sendRemovalReason(nReason);
                        showMainContent();
                    });
                }
            });
        }
    });
}
/**
 * remove podcast from Podcasts, users podcast,
 * delete icons, pod like/podcast, tags, and delete Chats/podId
 */ function purgePod(nReason) {
    progress.querySelector(".message").innerHTML = trans.removingPod;
    (0, _common.setDisplay)(progress, "flex");
    var podRef = firebase.database().ref(`podcast/${xPodId}`);
    podRef.remove(function(error) {
        if (error) {
            (0, _common.setDisplay)(progress, "none");
            (0, _common.showToast)(trans.unknownError, "toast");
        } else {
            var userPodRef = firebase.database().ref(`Users/${iPodContent.uid}/podcast/${xPodId}`);
            userPodRef.remove(function(error) {
                if (error) {
                    (0, _common.setDisplay)(progress, "none");
                    (0, _common.showToast)(trans.unknownError, "toast");
                } else {
                    //delete chat roomtrans.error
                    progress.querySelector(".message").innerHTML = trans.removingChat;
                    var chatRef = firebase.database().ref(`Chats/${xPodId}`);
                    chatRef.remove(function(error) {
                        if (error) (0, _common.showToast)(trans.errorChat, "toast");
                        var genreRef = firebase.database().ref(`tag/genre/podcast/${iPodContent.genre}/${xPodId}`);
                        genreRef.remove(function(error) {
                            if (error) (0, _common.showToast)(trans.errorChat, "toast");
                            var countryRef = firebase.database().ref(`tag/country/podcast/${iPodContent.country}/${xPodId}`);
                            countryRef.remove(function(error) {
                                if (error) (0, _common.showToast)(trans.errorChat, "toast");
                                var langRef = firebase.database().ref(`tag/lang/podcast/${iPodContent.lang}/${xPodId}`);
                                langRef.remove(function(error) {
                                    if (error) (0, _common.showToast)(trans.errorChat, "toast");
                                    //Check if podcast has images
                                    if (iPodContent.icon) {
                                        progress.querySelector(".message").innerHTML = trans.removingImages;
                                        purgePodImages(nReason);
                                    } else sendPodRemovalReason(nReason);
                                    showMainContent();
                                });
                            });
                        });
                    });
                }
            });
        }
    });
}
function purgePodImages(nReason) {
    const storageRef = firebase.storage().ref();
    if (iPodContent.icon) {
        //Radio has logo
        var logoRef = storageRef.child(`podcast/${xPodId}/logo`);
        logoRef.delete().then(()=>{
            sendPodRemovalReason(nReason);
        }).catch((error)=>{
            sendPodRemovalReason(nReason);
        });
    } else sendPodRemovalReason(nReason);
}
function sendPodRemovalReason(nReason) {
    progress.querySelector(".message").innerHTML = trans.sendingConfirmation;
    var alert = {
        date: new Date().getTime(),
        type: "podcast",
        reason: nReason,
        email: iPodContent.email ? iPodContent.email : null,
        rName: iPodContent.title ? iPodContent.title : null,
        uName: inPodAdmin.value ? inPodAdmin.value : null,
        msg: null,
        sub: null,
        from: uiName,
        fromId: uid ? uid : null
    };
    var message = trans.rmnMessage.replace("$name", iPodContent.title);
    switch(nReason){
        case 1:
            alert.sub = trans.sub2;
            message += trans.r1 + "<br>" + trans.m1;
            break;
        case 2:
            alert.sub = trans.sub2;
            message += trans.r2 + "<br>" + trans.m2Pod;
            break;
        case 3:
            alert.sub = trans.sub3;
            message += trans.r3 + "<br>" + trans.m3Pod;
            break;
        case 4:
            alert.sub = trans.sub4;
            message += taPodOther.value;
            break;
        default:
            alert.sub = "$name|ChatMurcianys";
            break;
    }
    alert.sub = alert.sub.replace("$name", iPodContent.title);
    message += "<br><br>" + trans.reSubmitPod + "<br><br>" + trans.concludeMsg;
    alert.msg = message;
    var verifyRef = firebase.database().ref(`alert/${iPodContent.uid}/${xPodId}`);
    verifyRef.set(alert, function(error) {
        (0, _common.setDisplay)(progress, "none");
        if (error) //request failed
        (0, _common.showToast)(trans.unknownError, "toast", 2500);
        else //request sent
        (0, _common.showToast)(trans.podRemoved, "toast", 2500);
    });
}
function resetInput(index) {
    switch(index){
        case 0:
            var oRadioName = iRadioInfo.radio_Name;
            inRadioName.value = oRadioName ? oRadioName : "";
            break;
        case 1:
            var oSlogan = iRadioInfo.radio_Slogan;
            inSlogan.value = oSlogan ? oSlogan : "";
            break;
        case 2:
            var oDesc = iRadioInfo.radio_Description;
            inDesc.value = oDesc ? oDesc : "";
            break;
        case 3:
            var oStream = iRadioInfo.radio_Stream;
            inStream.value = oStream ? oStream : "";
            break;
        case 4:
            var oWebStream = iRadioInfo.webStream;
            inWebStream.value = oWebStream ? oWebStream : "";
            break;
        case 5:
            var oLocation = iRadioInfo.radio_location;
            inLocation.value = oLocation ? oLocation : "";
            break;
        case 6:
            var oEmail = iRadioInfo.radio_email;
            inEmail.value = oEmail ? oEmail : "";
            break;
        case 7:
            var oPhone = iRadioInfo.phone_no;
            inPhone.value = oPhone ? oPhone : "";
            break;
        case 8:
            var oWeb = iRadioInfo.website;
            inWeb.value = oWeb ? oWeb : "";
            break;
        case 9:
            var oWelcome = iRadioInfo.welcome;
            inWelcome.value = oWelcome ? oWelcome : "";
            break;
        default:
            break;
    }
}
function initClasses() {
    radioClass = {
        admin_ID: null,
        admin_Name: null,
        admin_Pass: null,
        radio_Name: null,
        radio_Slogan: null,
        radio_Stream: null,
        radio_Description: null,
        radio_ID: null,
        radio_image: null,
        date_created: null,
        banner: null,
        phone_no: null,
        radio_location: null,
        radio_email: null,
        website: null,
        lowCaseName: null,
        welcome: null,
        webStream: null
    };
    podClass = {
        email: null,
        pod_email: null,
        title: null,
        lcTitle: null,
        host: null,
        uid: null,
        pid: null,
        desc: null,
        feed: null,
        web: null,
        phone: null,
        lang: null,
        country: null,
        genre: null,
        fb: null,
        tw: null,
        ig: null,
        tk: null,
        yt: null,
        wa: null,
        msgWelcome: null,
        icon: null,
        likes: null,
        date: null,
        revenue: null,
        screenBlock: null,
        verified: null,
        donation: null,
        url: null
    };
}
function initAudioAlert(fromError) {
    var msg = "";
    if (fromError) msg += trans.errorAudio;
    if (!elAudio.currentSrc.includes("https")) {
        if (msg == "") msg = trans.unsecureUrl;
        else msg += "<br>" + trans.unsecureUrl;
    }
    dTestStream.style.background = msg == "" ? "#e8f1ff" : "#ffcccc";
    pAudioAlert.innerHTML = msg;
    (0, _common.setDisplay)(dTestStream, "flex");
}
function confirmLogout() {
    (0, _common.setDisplay)(signout, "flex");
    const msg = progress.querySelector(".message");
    msg.textContent = trans.signingOut;
}
function logout() {
    (0, _common.setDisplay)(signout, "none");
    if (uid) {
        (0, _common.setDisplay)(progress, "flex");
        firebase.auth().signOut().then(function() {
            uid = null;
            (0, _common.setDisplay)(progress, "none");
            (0, _common.setDisplay)(login, "flex");
        });
    } else (0, _common.showToast)(trans.userNotFound, "toast");
}
function showUserOptions() {
    var dis = uOptions.style.display;
    if (dis == "flex") (0, _common.setDisplay)(uOptions, "none");
    else (0, _common.setDisplay)(uOptions, "flex");
}
function scrollFunction(elParent, elScroll, px) {
    if (elParent.scrollTop > px) (0, _common.setDisplay)(elScroll, "flex");
    else (0, _common.setDisplay)(elScroll, "none");
}
function displayContent(index) {
    if (mainNav == index) {
        if (mainContent.style.display == "none") {
            (0, _common.setDisplay)(editContent, "none");
            (0, _common.setDisplay)(mainContent, "flex");
        }
        return;
    }
    isMainContent = true;
    (0, _common.setDisplay)(editContent, "none");
    (0, _common.setDisplay)(mainContent, "flex");
    (0, _common.setDisplay)(dTestStream, "none");
    (0, _common.setDisplay)(search, index > 0 ? "flex" : "none");
    //setDisplay(divResults, index > 0 ? "block" : "none");
    (0, _common.setDisplay)(inScroll, "none");
    for(let meat = 0; meat < navMeat.length; meat++){
        const navM = navMeat[meat];
        if (index == meat) {
            (0, _common.setDisplay)(navM, "flex");
            navs[meat].className += "selected";
            initMeat(index);
        } else {
            (0, _common.setDisplay)(navM, "none");
            navs[meat].className = navs[index].className.replace("selected", "");
        }
    }
    mainNav = index;
    navContent.querySelector("h2").textContent = navTitles[mainNav].textContent;
}
function toggleNav() {
    var navDisplay = nav.style.display;
    if (window.innerWidth <= 840) {
        if (navDisplay == "" || navDisplay == "none") {
            (0, _common.setDisplay)(nav, "flex");
            btnToggleNav.title = trans.hideNavMenu;
        } else {
            (0, _common.setDisplay)(nav, "none");
            btnToggleNav.title = trans.showNavMenu;
        }
    } else if (navDisplay == "" || navDisplay == "flex") {
        (0, _common.setDisplay)(nav, "none");
        btnToggleNav.title = trans.showNavMenu;
    } else {
        (0, _common.setDisplay)(nav, "flex");
        btnToggleNav.title = trans.hideNavMenu;
    }
}
function checkPhoneNav() {
    if (window.innerWidth <= 840) {
        var navDisplay = nav.style.display;
        if (navDisplay == "" || navDisplay == "none") {
            (0, _common.setDisplay)(nav, "flex");
            btnToggleNav.title = trans.hideNavMenu;
        } else {
            (0, _common.setDisplay)(nav, "none");
            btnToggleNav.title = trans.showNavMenu;
        }
    }
}
function initData() {
    if (userRef != null) userRef.off();
    userRef = firebase.database().ref("Users/" + uid + "/info");
    userRef.on("value", function(data) {
        if (data.exists()) {
            var user = data.val();
            updateUser(user);
        }
    });
    var vRadioCountRef = firebase.database().ref("radioCount/verified");
    vRadioCountRef.on("value", function(data) {
        var total = data.val();
        radioTotal.querySelector("span").textContent = total ? total : "0";
    });
    var uvRadioCountRef = firebase.database().ref("radioCount/unverified");
    uvRadioCountRef.on("value", function(data) {
        var total = data.val();
        unverifiedTotal.querySelector("span").textContent = total ? total : "0";
    });
    var userCountRef = firebase.database().ref("user/count");
    userCountRef.on("value", function(data) {
        var total = data.val();
        //console.log(numeral(total).format('0,0'));
        userTotal.querySelector("span").textContent = total ? numeral(total).format("0,0") : "0";
    });
    var versionRef = firebase.database().ref("App/version");
    versionRef.on("value", function(data) {
        var version = data.val();
        appInfo.querySelector("span").textContent = version ? version : "0";
    });
    var vPodCountRef = firebase.database().ref("podCount/verified");
    vPodCountRef.on("value", function(data) {
        var total = data.val();
        podTotal.querySelector("span").textContent = total ? total : "0";
    });
    var uvPodCountRef = firebase.database().ref("podCount/unverified");
    uvPodCountRef.on("value", function(data) {
        var total = data.val();
        unverifiedPodTotal.querySelector("span").textContent = total ? total : "0";
    });
// var radiosRef = firebase.database().ref('Radio Stations');
// radiosRef.once("value", function(snapshot) {
//     if(snapshot.exists())
//     {
//         const total = snapshot.numChildren();
//         console.log("total: " + total);
//         // snapshot.forEach(function(childSnapshot) {
//         //     var radioId = childSnapshot.key;
//         //     var admin = childSnapshot.val().info.admin_ID;
//         //     if (admin) {
//         //         var radiosRef = firebase.database().ref(`Users/${admin}/My_Radios/${radioId}/`);
//         //     }
//         // });
//      }
// });
// var ref = firebase.database().ref("Users");
// ref.once('value').then(function(snapshot) {
//     const total = snapshot.numChildren();
//     var verifiedRef = firebase.database().ref('user/count');
//     verifiedRef.set(snapshot.numChildren(),function(error){
//         if(error)
//         {
//             //request failed
//             showToast("Could not update users", "toast");
//         }
//         else{
//             //request sent
//             showToast("Users updated: " + total, "toast");
//         }
//     });
// });
}
function updateUser(user) {
    if (user) {
        var name = user.name;
        var img = user.profile_Image;
        var email = user.email;
        uiName = name;
        var uOptions1 = document.getElementById("uOptions");
        var info = uOptions1.querySelectorAll("div");
        info[0].textContent = name;
        info[1].textContent = email;
        imgProfile.src = img ? img : (0, _personSvgDefault.default);
    }
}
function initMeat(index) {
    switch(index){
        case 1:
            initRadios();
            break;
        case 2:
            initUsers();
            break;
        case 3:
            initPods();
            break;
        case 4:
            initInAppProducts();
            break;
        case 5:
            initWd();
            break;
    }
}
function initWd() {
    searchType = SearchType.wd;
    if (wdRef == null) {
        const divWds = document.getElementById("wds");
        const divWdInfo = document.getElementById("wdInfoFrag");
        const wdList = divWds.querySelector(".wdList");
        const uvEmpty1 = divWds.querySelector("p.empty");
        const btnGoWdRequests = document.getElementById("btnGoWdRequests");
        wdRef = (0, _config.purchaseApp).ref("wd");
        userWdRef = (0, _config.purchaseApp).ref("withdraw");
        balanceRef = (0, _config.purchaseApp).ref("balance");
        approvedWdRef = (0, _config.purchaseApp).ref("wdApproved");
        wdRef.on("child_added", function(data) {
            getWdInfo(data.key, data.val(), wdList, uvEmpty1, divWds, divWdInfo, btnGoWdRequests);
        });
        wdRef.on("child_removed", function(data) {
            deleteElement(data.key);
            if (wdList.children.length === 0) (0, _common.setDisplay)(uvEmpty1, "block");
        });
        btnGoWdRequests.addEventListener("click", function() {
            goToWdReq(divWds, divWdInfo, btnGoWdRequests);
        });
    //const
    }
}
function goToWdReq(divWds, divWdInfo, btnGoWdReq) {
    (0, _common.setDisplay)(divWds, "flex");
    (0, _common.setDisplay)(divWdInfo, "none");
    (0, _common.setDisplay)(btnGoWdReq, "none");
}
function getWdInfo(key, uid, parent, uvEmpty1, divWds, divWdInfo, btnGoWdRequests) {
    userWdRef.child(`${uid}/${key}`).once("value", function(data) {
        if (data.exists()) {
            if (uvEmpty1.style.display == "block") (0, _common.setDisplay)(uvEmpty1, "none");
            var userWd = data.val();
            addWd(key, userWd, parent, divWds, divWdInfo, btnGoWdRequests);
        }
    });
}
var WD_TMP = `<div class="divWd horizFlex btm-top-gray-border point opas wrap-any">
<div class="horizFlex mainTop">
  <p class="name mainTop">Name</p>
  <p class="uid mainTop">9yyDddfcC4evXFiGajccTJRCOGu1</p>
  <p class="mainTop text-end"><span class="money">0.01</span> <span class="currency">USD</span></p>
</div>
</div>`;
function addWd(key, wd, parent, divWds, divWdInfo, btnGoWdRequests) {
    if (key == null || wd == null) return;
    var oldDiv = document.getElementById(key);
    const container = document.createElement("div");
    container.innerHTML = WD_TMP;
    const divWithdraw = container.firstChild;
    divWithdraw.setAttribute("id", key);
    const elName = divWithdraw.querySelector(".name");
    const elUid = divWithdraw.querySelector(".uid");
    const elMoney = divWithdraw.querySelector("span.money");
    var wdName;
    var wdUid = wd.uid;
    var userRef = firebase.database().ref(`Users/${wdUid}/info/name`);
    userRef.once("value", function(data) {
        if (data.exists()) {
            wdName = data.val() ? data.val() : trans.noName;
            elName.textContent = wdName;
        }
        divWithdraw.addEventListener("click", function() {
            showWdInfo(key, wd, wdName, divWds, divWdInfo, btnGoWdRequests);
        });
    });
    var wdMoney = wd.usd;
    elUid.textContent = wdUid ? wdUid : "";
    elMoney.textContent = wdMoney ? wdMoney : "";
    if (oldDiv) parent.replaceChild(divWithdraw, oldDiv);
    else parent.appendChild(divWithdraw);
}
function showWdInfo(key, wd, wdName, divWds, divWdInfo, btnGoWdReq) {
    (0, _common.setDisplay)(divWds, "none");
    (0, _common.setDisplay)(divWdInfo, "flex");
    (0, _common.setDisplay)(btnGoWdReq, "block");
    const divDate = divWdInfo.querySelector(".spWdDate");
    const divUid = divWdInfo.querySelector(".spWdUid");
    const divWdName = document.getElementById("divWdName");
    const divUsd = divWdInfo.querySelector(".spUsd");
    const divRuby = divWdInfo.querySelector(".spRuby");
    const divWdBal = document.getElementById("divWdBal").querySelector("span.spBal");
    const methodInfoList = document.getElementById("divWdMethod").querySelectorAll("span");
    const btnWdApprove1 = document.getElementById("btnWdApprove");
    const btnWdDecline1 = document.getElementById("btnWdDecline");
    divDate.textContent = (0, _common.formatMessageDate)(new Date(wd.date), trans.language);
    divUid.textContent = wd.uid;
    divWdName.textContent = wdName;
    divUsd.textContent = wd.usd;
    divRuby.textContent = wd.value;
    divWdBal.textContent = wd.balance;
    methodInfoList[0].textContent = wd.method;
    methodInfoList[1].textContent = wd.methodInfo;
    $(btnWdApprove1).unbind();
    $(btnWdDecline1).unbind();
    $(btnWdApprove1).click(function(e) {
        e.stopPropagation();
        confirmWithdrawDialog(key, wd, wdName, divWds, divWdInfo, btnGoWdReq);
    });
    $(btnWdDecline1).click(function(e) {
        e.stopPropagation();
        showWdReasonDialog(key, wd, wdName, divWds, divWdInfo, btnGoWdReq);
    });
}
function confirmWithdrawDialog(key, wd, wdName, divWds, divWdInfo, btnGoWdReq) {
    const dialog = document.getElementById("confirmDialog");
    const btnRed = dialog.querySelector(".redBtn");
    const btnBlue = dialog.querySelector(".blueBtn");
    $(btnBlue).unbind();
    $(btnRed).unbind();
    $(btnBlue).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
        approveWithdraw(key, wd, wdName, divWds, divWdInfo, btnGoWdReq);
    });
    $(btnRed).click(function(e) {
        e.stopPropagation();
        (0, _common.setDisplay)(dialog, "none");
    });
    dialog.querySelector("h3 span").textContent = trans.confirmWdNotif;
    dialog.querySelector(".msg").innerHTML = trans.podApprovalMsg;
    (0, _common.setDisplay)(dialog, "flex");
}
function showWdReasonDialog(key, wd, wdName, divWds, divWdInfo, btnGoWdReq) {
    const rDialog = document.getElementById("wdDeclineDialog");
    const btnBlue = rDialog.querySelector(".blueBtn");
    $(btnBlue).unbind();
    $(btnBlue).click(function(e) {
        e.stopPropagation;
        var numReason = wdRad1.checked ? 1 : wdRad2.checked ? 2 : 3;
        if (numReason != 3) {
            (0, _common.setDisplay)(rDialog, "none");
            declineWd(key, wd, wdName, divWds, divWdInfo, btnGoWdReq, numReason, null);
        } else if (wdTaOther.value.trim() != "") {
            (0, _common.setDisplay)(rDialog, "none");
            declineWd(key, wd, wdName, divWds, divWdInfo, btnGoWdReq, numReason, wdTaOther.value.trim());
        } else {
            $(wdTaOther).shake();
            (0, _common.showToast)(trans.provideReason, "toast");
        }
    });
    if (wdName != null) rDialog.querySelector(".note").innerHTML = trans.removalNote.replace("$name", wdName);
    else rDialog.querySelector(".note").innerHTML = "";
    (0, _common.setDisplay)(rDialog, "flex");
}
function declineWd(key, wd, wdName, divWds, divWdInfo, btnGoWdReq, numReason, other) {
    progress.querySelector(".message").innerHTML = trans.sendingMessage;
    (0, _common.setDisplay)(progress, "flex");
    var alert = {
        date: new Date().getTime(),
        type: "withdrawal",
        reason: 1,
        email: wd.email ? wd.email : null,
        rName: key ? key : null,
        uName: wdName ? wdName : null,
        msg: null,
        sub: trans.wdSubDeclined,
        from: uiName,
        fromId: uid ? uid : null
    };
    var message = trans.wdAlertMsgDeclined.replace("$method", wd.method).replace("$acc", wd.methodInfo).replace("$amount", wd.usd);
    if (other) message = message.replace("$reason", other);
    else switch(numReason){
        case 1:
            message = message.replace("$reason", trans.wdR1);
            break;
        case 2:
            message = message.replace("$reason", trans.wdR2);
            break;
        default:
            message = message.replace("$reason", trans.r1);
            break;
    }
    alert.msg = message;
    var verifyRef = firebase.database().ref(`alert/${wd.uid}/${key}`);
    verifyRef.set(alert, function(error) {
        (0, _common.setDisplay)(progress, "none");
        if (error) {
            (0, _common.showToast)(trans.unknownError, "toast", 2500);
            (0, _common.setDisplay)(progress, "none");
        } else {
            //set declined date
            wd.doneDate = alert.date;
            userWdRef.child(`${wd.uid}/${key}`).set(wd, function(error) {
                //remove from wd
                if (error) {
                    (0, _common.showToast)(trans.unknownError, "toast", 2500);
                    (0, _common.setDisplay)(progress, "none");
                } else balanceRef.child(`${wd.uid}/ruby`).transaction((current_value)=>{
                    return (current_value || 0) + wd.value;
                }, function(error, committed, ss) {
                    if (error) {
                        (0, _common.showToast)(trans.unknownError, "toast", 2500);
                        (0, _common.setDisplay)(progress, "none");
                    } else wdRef.child(key).remove(function(error) {
                        if (error) (0, _common.showToast)(trans.unknownError, "toast", 2500);
                        else (0, _common.showToast)(trans.messageSent, "toast", 2500);
                        (0, _common.setDisplay)(progress, "none");
                        goToWdReq(divWds, divWdInfo, btnGoWdReq);
                    });
                });
            });
        }
    });
}
function approveWithdraw(key, wd, wdName, divWds, divWdInfo, btnGoWdReq) {
    if (key == null) return;
    //save wd key and uid to ref
    progress.querySelector(".message").innerHTML = trans.approvingWd;
    (0, _common.setDisplay)(progress, "flex");
    approvedWdRef.child(key).set(wd.uid, function(error) {
        if (error) {
            (0, _common.showToast)(trans.unknownError, "toast");
            (0, _common.setDisplay)(progress, "none");
        } else {
            //Send alert message to user
            var alert = {
                date: new Date().getTime(),
                type: "withdrawal",
                reason: 0,
                email: wd.email ? wd.email : null,
                rName: key ? key : null,
                uName: wdName ? wdName : null,
                msg: null,
                sub: trans.wdSubApprove,
                from: uiName,
                fromId: uid ? uid : null
            };
            var message = trans.wdAlertMsgApproved.replace("$method", wd.method).replace("$acc", wd.methodInfo).replace("$amount", wd.usd);
            alert.msg = message;
            var verifyRef = firebase.database().ref(`alert/${wd.uid}/${key}`);
            verifyRef.set(alert, function(error) {
                (0, _common.setDisplay)(progress, "none");
                if (error) {
                    (0, _common.showToast)(trans.unknownError, "toast", 2500);
                    (0, _common.setDisplay)(progress, "none");
                } else {
                    //set approved date
                    wd.doneDate = alert.date;
                    wd.done = true;
                    userWdRef.child(`${wd.uid}/${key}`).set(wd, function(error) {
                        //remove from wd
                        if (error) {
                            (0, _common.showToast)(trans.unknownError, "toast", 2500);
                            (0, _common.setDisplay)(progress, "none");
                        } else wdRef.child(key).remove(function(error) {
                            if (error) (0, _common.showToast)(trans.unknownError, "toast", 2500);
                            else (0, _common.showToast)(trans.confirmSent, "toast", 2500);
                            (0, _common.setDisplay)(progress, "none");
                            goToWdReq(divWds, divWdInfo, btnGoWdReq);
                        });
                    });
                }
            });
        }
    });
}
function initInAppProducts() {
    searchType = SearchType.purchase;
    //console.log("product=: " + prodApp == null);
    if (prodRef == null) {
        var btnGoProd = document.getElementById("btnGoProd");
        var divProducts1 = document.getElementById("divProducts");
        const uvEmpty1 = divProducts1.querySelector(".empty");
        const parent = divProducts1.querySelector(".coinList");
        var btnAddProd = document.getElementById("btnAddProduct");
        var divCoinPack1 = document.getElementById("divCoinPack");
        var btnAddCoinPack = document.getElementById("btnAddCoinPack");
        var inSku = document.getElementById("inSku");
        var inValue = document.getElementById("inValue");
        var inPrice = document.getElementById("inPrice");
        prodRef = (0, _config.prodApp).ref("product");
        prodRef.on("child_added", function(data) {
            addCoinList(data.key, data.val(), parent);
        });
        prodRef.on("child_changed", function(data) {
            addCoinList(data.key, data.val(), parent);
        });
        prodRef.on("child_removed", function(data) {
            deleteElement(data.key);
            if (parent.children.length === 0) (0, _common.setDisplay)(uvEmpty1, "block");
        });
        btnGoProd.addEventListener("click", function() {
            goToProducts(divProducts1, divCoinPack1, btnGoProd);
        });
        btnAddProd.addEventListener("click", function() {
            (0, _common.setDisplay)(divProducts1, "none");
            (0, _common.setDisplay)(divCoinPack1, "flex");
            (0, _common.setDisplay)(btnGoProd, "block");
        });
        btnAddCoinPack.addEventListener("click", function() {
            addCoinPack(inSku, inValue, inPrice, divProducts1, divCoinPack1, btnGoProd);
        });
    }
}
var COIN_TEMP = `<div class="divCoin horizFlex btm-top-gray-border">
    <img src="` + (0, _icCoinsSvgDefault.default) + `" alt="Coins" class="alt-coins" width="24px">
    <div class="horizFlex mainTop">
      <p class="value mainTop"></p>
      <p class="sku mainTop"></p>
      <p class="cost mainTop text-end">$<span></span></p>
    </div>
  </div>`;
function addCoinList(key, coin, parent) {
    if (key == null || coin == null) return;
    var oldDiv = document.getElementById(key);
    const container = document.createElement("div");
    container.innerHTML = COIN_TEMP;
    const divCoin = container.firstChild;
    divCoin.setAttribute("id", key);
    const elSku = divCoin.querySelector(".sku");
    const elValue = divCoin.querySelector(".value");
    const elCost = divCoin.querySelector(".cost span");
    var coinSku = key;
    var coinValue = coin.value;
    var coinCost = coin.price;
    elSku.textContent = coinSku ? coinSku : trans.noName;
    elValue.textContent = coinValue ? coinValue : "";
    elCost.textContent = coinCost ? coinCost : "";
    if (oldDiv) parent.replaceChild(divCoin, oldDiv);
    else parent.appendChild(divCoin);
}
function addCoinPack(inSku, inValue, inPrice, divProducts1, divCoinPack1, btnGoProd) {
    var sku = inSku.value.trim();
    var val = inValue.value.trim();
    var price = inPrice.value.trim();
    if (sku == "") $(inSku).shake();
    else if (val == "") $(inValue).shake();
    else if (price == "") $(inPrice).shake();
    else {
        var prodClass = {
            sku: sku,
            value: val,
            price: price,
            uid: uid ? uid : null,
            date: new Date().getTime()
        };
        prodRef.child(sku).set(prodClass, function(error) {
            if (error) (0, _common.showToast)(trans.unknownError, "toast");
            else {
                (0, _common.showToast)(trans.coinAddedSuccess, "toast");
                inSku.value = "";
                inValue.value = "";
                inPrice.value = "";
                goToProducts(divProducts1, divCoinPack1, btnGoProd);
            }
        });
    }
}
function goToProducts(divProducts1, divCoinPack1, btnGoProd) {
    (0, _common.setDisplay)(divProducts1, "flex");
    (0, _common.setDisplay)(divCoinPack1, "none");
    (0, _common.setDisplay)(btnGoProd, "none");
}
function initPods() {
    searchType = SearchType.pod;
    if (uvPodsRef == null) {
        const uvEmpty1 = podVerify.querySelector(".empty");
        const parent = podVerify.querySelector(".podList");
        uvPodsRef = firebase.database().ref("verify/podcast");
        uvPodsRef.on("child_added", function(data) {
            var podcast = data.val();
            var emptyDisplay = uvEmpty1.style.display;
            if (emptyDisplay == "block") (0, _common.setDisplay)(uvEmpty1, "none");
            addPodcast(data.key, "uv", podcast, parent, false);
        });
        uvPodsRef.on("child_changed", function(data) {
            var podcast = data.val();
            addPodcast(data.key, "uv", podcast, parent, false);
        });
        uvPodsRef.on("child_removed", function(data) {
            deleteElement(data.key + "uv");
            if (parent.children.length === 0) (0, _common.setDisplay)(uvEmpty1, "block");
        });
    }
    if (vPodsRef == null) {
        const vEmpty = podVerified.querySelector(".empty");
        const parent = podVerified.querySelector(".podList");
        vPodsRef = firebase.database().ref("podcast");
        vPodsRef.on("child_added", function(data) {
            var podcast = data.val();
            var emptyDisplay = vEmpty.style.display;
            if (emptyDisplay == "block") (0, _common.setDisplay)(vEmpty, "none");
            addPodcast(data.key, "v", podcast, parent, true);
        });
        vPodsRef.on("child_changed", function(data) {
            var podcast = data.val();
            addPodcast(data.key, "v", podcast, parent, true);
        });
        vPodsRef.on("child_removed", function(data) {
            deleteElement(data.key + "v");
            if (parent.children.length === 0) (0, _common.setDisplay)(vEmpty, "block");
        });
    }
}
function addPodcast(key, ext, podcast, parent, verified1) {
    if (key == null || podcast == null) return;
    var oldDiv = document.getElementById(key + ext);
    const container = document.createElement("div");
    container.innerHTML = RADIO_TEMPLATE;
    const divPodcast = container.firstChild;
    divPodcast.setAttribute("id", key + ext);
    const elName = divPodcast.querySelector(".name");
    const elTime = divPodcast.querySelector(".time");
    const elLogo = divPodcast.querySelector(".roundImg");
    var podName = podcast.title;
    var podLogo = podcast.icon;
    var time = podcast.date;
    elName.textContent = podName ? podName : trans.noName;
    var creationTime = time ? (0, _common.formatMessageDate)(new Date(time), trans.language) : (0, _common.formatMessageDate)(new Date(), trans.language);
    elTime.textContent = creationTime == "Today" ? trans.today : creationTime == "Yesterday" ? trans.yesterday : creationTime;
    elLogo.src = podLogo ? podLogo : (0, _podcastSvgDefault.default);
    var adminName;
    var userRef = firebase.database().ref(`Users/${podcast.uid}/info/name`);
    userRef.once("value", function(data) {
        if (data.exists()) adminName = data.val();
    });
    divPodcast.addEventListener("click", function() {
        initPodContent(key, podcast, verified1, adminName);
    });
    if (oldDiv) parent.replaceChild(divPodcast, oldDiv);
    else {
        const existingPod = parent.children;
        if (existingPod.length === 0) parent.appendChild(divPodcast);
        else parent.insertBefore(divPodcast, parent.children[0]);
    }
}
function initPodContent(key, podcast, verified1, adminName) {
    isMainContent = false;
    iPodContent = podcast;
    iVerified = verified1;
    xPodId = key;
    (0, _common.setDisplay)(dTestStream, "none");
    (0, _common.setDisplay)(mainContent, "none");
    (0, _common.setDisplay)(editContent, "flex");
    (0, _common.setDisplay)(podContent, "flex");
    (0, _common.setDisplay)(radioContent, "none");
    (0, _common.setDisplay)(search, "none");
    (0, _common.setDisplay)(divResults, "none");
    (0, _common.setDisplay)(btnClearSearch, "none");
    if (verified1) {
        (0, _common.setDisplay)(btnRejectPod, "block");
        (0, _common.setDisplay)(btnApprovePod, "none");
        (0, _common.setDisplay)(btnUpdatePod, "block");
        (0, _common.setDisplay)(dWelcome, "flex");
    } else {
        (0, _common.setDisplay)(btnRejectPod, "block");
        (0, _common.setDisplay)(btnApprovePod, "block");
        (0, _common.setDisplay)(btnUpdatePod, "none");
        (0, _common.setDisplay)(dWelcome, "none");
    }
    var email = podcast.email;
    var title = podcast.title;
    var adminName = adminName;
    var uid = podcast.uid;
    var desc = podcast.desc;
    var feed = podcast.feed;
    var lang = podcast.lang;
    var country = podcast.country;
    var genre = podcast.genre;
    var icon = podcast.icon;
    var date = podcast.date;
    var host = podcast.host;
    //optional info
    var web = podcast.web;
    var phone = podcast.phone;
    var podEmail = podcast.pod_email;
    //after verified
    var fb = podcast.fb;
    var tw = podcast.tw;
    var ig = podcast.ig;
    var tk = podcast.tk;
    var yt = podcast.yt;
    var wa = podcast.wa;
    var welcome = podcast.msgWelcome;
    var likes = podcast.likes;
    var revenue = podcast.revenue;
    var screenBlock = podcast.screenBlock;
    var donation = podcast.donation;
    imgPodLogo.src = icon ? icon : (0, _podcastSvgDefault.default);
    podAdminId.querySelector("span").textContent = uid ? uid : "";
    inPodAdmin.value = adminName ? adminName : "";
    inHostEmail.value = email ? email : "";
    pPodDate.querySelector("span").textContent = date ? formatDate(new Date(date)) : "";
    pPodId.querySelector("span").textContent = key ? key : "";
    inPodHost.value = host;
    inPodTitle.value = title;
    inFeed.value = feed ? feed : "";
    inPodDesc.value = desc ? desc : "";
    inGenre.value = genre ? genre : "";
    selGenres.selectedIndex = genre ? genre : 0;
    inLang.value = lang ? lang : "";
    selPodLang.selectedIndex = lang ? lang : 12;
    inCountry.value = country ? country : "";
    selPodCountry.selectedIndex = country ? (0, _common.getCountryIndex)(country.toUpperCase()) : (0, _common.getCountryIndex)("US");
    inPodWeb.value = web ? web : "n/a";
    inPodPhone.value = phone ? phone : "n/a";
    inPodEmail.value = podEmail ? podEmail : "n/a";
    aPodWeb.href = web ? "$start" + web : "javascript:void(0);";
    if (!aPodWeb.href.includes("http")) aPodWeb.href = aPodWeb.href.replace("$start", "http");
    else aPodWeb.href = aPodWeb.href.replace("$start", "");
    if (podcast.verified) {
        (0, _common.setDisplay)(podVerifiedOnly, "flex");
        inPodWelcome.value = welcome ? welcome : "n/a";
        inFb.value = fb;
        inTw.value = tw;
        inIn.value = ig;
        inYt.value = yt;
        inTk.value = tk;
    } else (0, _common.setDisplay)(podVerifiedOnly, "flex");
    aFeedUrl.href = feed ? feed : "javascript:void(0);";
    //var isStreamWorking = true;
    // if (feed == null || !feed.includes("https")) {
    //   //load and display iframe
    //   isStreamWorking = false;
    //   initAudioAlert(false);
    // } else {
    //   isStreamWorking = true;
    // }
    //initAudio(nStream);
    initPodAudio(feed);
}
async function initPodAudio(feed) {
    podPlayer.innerHTML = "";
    if (feed) {
        const pod = await podcastFeedParser.getPodcastFromURL(feed);
        const episodes = pod.episodes;
        var episodeLink;
        if (episodes != null && episodes.length > 0) episodeLink = episodes[0].enclosure.url;
        if (episodeLink == null) return;
        var source = document.createElement("source");
        source.src = episodeLink;
        podPlayer.appendChild(source);
        podPlayer.load();
    }
}
function initRadios() {
    searchType = SearchType.radio;
    if (uvRadiosRef == null) {
        const uvEmpty1 = verify.querySelector(".empty");
        const parent = verify.querySelector(".radioList");
        uvRadiosRef = firebase.database().ref("verify/radio");
        uvRadiosRef.on("child_added", function(data) {
            var radio = data.val().info;
            var radioAdmins = data.val().Administrators;
            var dis = uvEmpty1.style.display;
            if (dis == "block") (0, _common.setDisplay)(uvEmpty1, "none");
            addRadio(data.key, "uv", radio, parent, false, radioAdmins);
        });
        uvRadiosRef.on("child_changed", function(data) {
            var radio = data.val().info;
            var radioAdmins = data.val().Administrators;
            addRadio(data.key, "uv", radio, parent, false, radioAdmins);
        });
        uvRadiosRef.on("child_removed", function(data) {
            deleteElement(data.key + "uv");
            if (parent.children.length === 0) (0, _common.setDisplay)(uvEmpty1, "block");
        });
        clearSearch();
    }
    if (vRadiosRef == null) {
        var parent = verified.querySelector(".radioList");
        vRadiosRef = firebase.database().ref("Radio Stations");
        vRadiosRef.limitToLast(10).on("child_added", function(data) {
            var key = data.key;
            getRadioInfo(key, parent, null);
        });
        vRadiosRef.on("child_removed", function(data) {
            deleteElement(data.key);
            if (parent.children.length === 0) (0, _common.setDisplay)(uvEmpty, "block");
        });
        var reviseRef = firebase.database().ref(`checkRadio`);
        var reviseList = reviseRadios.querySelector(".radioCheckList");
        let emptyRevisions = reviseRadios.querySelector(".empty");
        reviseRef.on("child_added", function(data) {
            var key = data.key;
            getRadioInfo(key, reviseList, "check");
            (0, _common.setDisplay)(emptyRevisions, "none");
        });
        reviseRef.on("child_removed", function(data) {
            deleteElement(data.key + "check");
            if (parent.children.length === 0) (0, _common.setDisplay)(emptyRevisions, "block");
        });
    }
}
function clearSearch() {
    divSearchList.textContent = "";
    (0, _common.setDisplay)(divResults, "none");
    (0, _common.setDisplay)(pEmpty, "none");
    (0, _common.setDisplay)(btnClearSearch, "none");
    inSearch.value = "";
    inSearch.focus();
}
function getRadioInfo(key, parent, ext) {
    var radioInfoRef = firebase.database().ref("Radio Stations/" + key + "/info");
    radioInfoRef.on("value", function(data) {
        if (data.exists()) {
            var radio = data.val();
            addRadio(key, ext, radio, parent, true, null);
        }
    });
}
var RADIO_TEMPLATE = '<div class="horizFlex radio opas point"><img class="roundImg" src="' + (0, _radioPlaceholderSvgDefault.default) + '" alt="radio logo" width="40px" height="40px">' + '<div class="verticalFlex mainTop" translate="no">' + '<div class="name" translate="no"></div>' + '<div class="time" translate="no"></div>' + "</div>" + '<div class="horizFlex vRes">' + '<button class="btnEdit" title="Edit"><i class="fas fa-edit"></i><span>Edit</span></button>' + '<button class="btnRemove" title="Remove"><i class="fa-solid fa-file-circle-minus"></i><span>Remove</span></button>' + "</div>" + "</div>";
function addRadio(key, ext, radio, parent, verified1, radioAdmins) {
    if (key == null || radio == null) return;
    var oldDiv = document.getElementById(key + ext);
    const container = document.createElement("div");
    container.innerHTML = RADIO_TEMPLATE;
    const divRadio = container.firstChild;
    divRadio.setAttribute("id", key + ext);
    const elName = divRadio.querySelector(".name");
    const elTime = divRadio.querySelector(".time");
    const elLogo = divRadio.querySelector(".roundImg");
    const btnRemove = divRadio.querySelector(".btnRemove");
    const btnEdit = divRadio.querySelector(".btnEdit");
    var radioName = radio.radio_Name;
    var radioLogo = radio.radio_image;
    var time = radio.date_created;
    elName.textContent = radioName ? radioName : trans.noName;
    var creationTime = time ? (0, _common.formatMessageDate)(new Date(time), trans.language) : (0, _common.formatMessageDate)(new Date(), trans.language);
    elTime.textContent = creationTime == "Today" ? trans.today : creationTime == "Yesterday" ? trans.yesterday : creationTime;
    elLogo.src = radioLogo ? radioLogo : (0, _radioPlaceholderSvgDefault.default);
    divRadio.addEventListener("click", function() {
        fromSearch = ext == "search" || btnClearSearch.style.display == "block";
        initRadioContent(key, radio, verified1, radioAdmins);
    });
    if (ext == "check") $(btnRemove).click(function(e) {
        e.stopPropagation();
        removeRevise(key);
    });
    else (0, _common.setDisplay)(btnRemove, "none");
    $(btnEdit).find("span").text(trans.edit);
    $(btnRemove).find("span").text(trans.remove);
    $(btnEdit).attr("title", trans.edit);
    $(btnRemove).attr("title", trans.remove);
    if (oldDiv) parent.replaceChild(divRadio, oldDiv);
    else {
        const existingRadio = parent.children;
        if (existingRadio.length === 0) parent.appendChild(divRadio);
        else parent.insertBefore(divRadio, parent.children[0]);
    }
}
function removeRevise(key) {
    var reviseRef = firebase.database().ref(`checkRadio/${key}`);
    reviseRef.remove(function(error) {
        if (error) (0, _common.showToast)(trans.unknownError, "toast");
        else (0, _common.showToast)(trans.revisionRemoved, "toast");
    });
}
function deleteElement(id) {
    if (document.getElementById(id)) document.getElementById(id).remove();
}
function initRadioContent(key, radio, verified1, radioAdmins) {
    isMainContent = false;
    iRadioInfo = radio;
    iVerified = verified1;
    xRadioId = key;
    for(var i in radioAdmins)xRadioAdmin = radioAdmins[i];
    (0, _common.setDisplay)(dTestStream, "none");
    (0, _common.setDisplay)(mainContent, "none");
    (0, _common.setDisplay)(editContent, "flex");
    (0, _common.setDisplay)(podContent, "none");
    (0, _common.setDisplay)(radioContent, "flex");
    (0, _common.setDisplay)(search, "none");
    (0, _common.setDisplay)(divResults, "none");
    //setDisplay(btnClearSearch, "none");
    if (verified1) {
        (0, _common.setDisplay)(btnReject, "block");
        (0, _common.setDisplay)(btnApprove, "none");
        (0, _common.setDisplay)(btnUpdate, "block");
        (0, _common.setDisplay)(dWelcome, "flex");
    } else {
        (0, _common.setDisplay)(btnReject, "block");
        (0, _common.setDisplay)(btnApprove, "block");
        (0, _common.setDisplay)(btnUpdate, "none");
        (0, _common.setDisplay)(dWelcome, "none");
    }
    var nAdminId = radio.admin_ID;
    var nAdminName = radio.admin_Name;
    var nRadioName = radio.radio_Name;
    var nSlogan = radio.radio_Slogan;
    var nStream = radio.radio_Stream;
    var nDesc = radio.radio_Description;
    var nRadioId = radio.radio_ID;
    var nLogo = radio.radio_image;
    var nTime = radio.date_created;
    var nBanner = radio.banner;
    var nPhone = radio.phone_no;
    var nLocation = radio.radio_location;
    var nEmail = radio.radio_email;
    var nWeb = radio.website;
    var nWelcome = radio.welcome;
    var nWebStream = radio.webStream;
    pAdminId.textContent = nAdminId ? nAdminId : "";
    inAdminName.value = nAdminName ? nAdminName : "";
    inRadioName.value = nRadioName;
    inSlogan.value = nSlogan ? nSlogan : "";
    inStream.value = nStream ? nStream : "";
    inDesc.value = nDesc ? nDesc : "";
    pRadioId.textContent = nRadioId ? nRadioId : key ? key : "";
    imgLogo.src = nLogo ? nLogo : (0, _radioPlaceholderSvgDefault.default);
    pRequestDate.textContent = nTime ? formatDate(new Date(nTime)) : "";
    imgBanner.src = nBanner ? nBanner : (0, _soundWaveSvgDefault.default);
    inPhone.value = nPhone ? nPhone : "";
    inLocation.value = nLocation ? nLocation : "";
    inEmail.value = nEmail ? nEmail : "";
    inWeb.value = nWeb ? nWeb : "";
    inWelcome.value = nWelcome ? nWelcome : "";
    //btnGoStream.href = nStream ? nStream : "javascript:void(0);";
    var fullWeb = nWeb ? "$start" + nWeb : "javascript:void(0);";
    if (!fullWeb.includes("//")) fullWeb = fullWeb.replace("$start", "//");
    else fullWeb = fullWeb.replace("$start", "");
    $(btnGoWeb).off("click");
    if (nWeb) $(btnGoWeb).click(function() {
        window.open(fullWeb, "_blank");
    });
    var fullStream = nStream ? "$start" + nStream : "javascript:void(0);";
    if (!fullStream.includes("//")) fullStream = fullStream.replace("$start", "//");
    else fullStream = fullStream.replace("$start", "");
    $(btnGoStream).off("click");
    if (nStream) $(btnGoStream).click(function() {
        window.open(fullStream, "_blank");
    });
    inWebStream.value = nWebStream ? nWebStream : "";
    var isStreamWorking = true;
    if (nStream == null || !nStream.includes("https")) //load and display iframe
    isStreamWorking = false;
    else isStreamWorking = true;
    initAudioAlert(false);
    initAudio(nStream);
}
function initSelections() {
    var genres = (0, _common.getGenreList)(trans.language);
    if (selGenres.children.length > 0) selGenres.innerHTML = "";
    genres.forEach((genre)=>{
        var option = document.createElement("option");
        option.textContent = genre;
        selGenres.appendChild(option);
    });
    var langs = (0, _common.getLangList)(trans.language);
    if (selPodLang.children.length > 0) selPodLang.innerHTML = "";
    langs.forEach((lng)=>{
        var option = document.createElement("option");
        option.textContent = lng;
        selPodLang.appendChild(option);
    });
    var countryList = (0, _common.getCountryList)(trans.language);
    if (selPodCountry.children.length > 0) selPodCountry.innerHTML = "";
    countryList.forEach((c)=>{
        var option = document.createElement("option");
        option.textContent = c;
        selPodCountry.appendChild(option);
    });
}
function formatDate(date) {
    var nDate = (0, _common.formatMessageDate)(date, trans.language);
    var nTime = (0, _common.formatTime)(date);
    var xTime;
    switch(nTime){
        case "Today":
            xTime = trans.today;
            break;
        case "Yesterday":
            xTime = trans.yesterday;
            break;
        default:
            xTime = nTime;
            break;
    }
    return nDate + " (" + xTime + ")";
}
function initAudio(nStream) {
    elAudio.innerHTML = "";
    if (nStream) {
        var source = document.createElement("source");
        source.src = nStream;
        elAudio.appendChild(source);
        var backupSource = document.createElement("source");
        var backUpUrl;
        if (nStream.endsWith("/")) backUpUrl = nStream + ";";
        else if (nStream.endsWith("/;")) //backupSource.src = radioStream;
        backUpUrl = nStream;
        else //backupSource.src = radioStream + "/;";
        backUpUrl = nStream + "/;";
        backupSource.src = backUpUrl;
        elAudio.appendChild(backupSource);
        elAudio.load();
    }
}
function initUsers() {}
searchType = SearchType.users;
jQuery.fn.shake = function(intShakes, intDistance, intDuration) {
    intShakes = intShakes || 4;
    intDistance = intDistance || 2;
    intDuration = intDuration || 500;
    this.each(function() {
        $(this).css("position", "relative");
        for(var x = 1; x <= intShakes; x++)$(this).animate({
            left: intDistance * -1
        }, intDuration / intShakes / 4).animate({
            left: intDistance
        }, intDuration / intShakes / 2).animate({
            left: 0
        }, intDuration / intShakes / 4);
    });
    return this;
};
var language = {
    eng: {
        language: "en",
        appSum: "App summary",
        radioStations: "Radio stations",
        registeredUsers: "Registered users",
        translate: "Translate",
        unverifiedRadios: "Unverified radios",
        verifiedRadios: "Verified radios",
        totalUsers: "Total users",
        latestVersion: "Latest version",
        contactInfo: "Contact information",
        linksToShare: "Links to share",
        mainWebsite: "Main website",
        googlePlayStore: "Google Play Store",
        shortLink: "Short link",
        noVerification: "No radio station needs verification at this time",
        recentVerifiedRadios: "Recently verified radios",
        uploadingInfo: "Uploading information",
        copy: "Copy",
        search: "Search",
        addContactEmail: "Add my contact email",
        hideNavMenu: "Hide navigation menu",
        showNavMenu: "Show navigation menu",
        noRecentRadios: "No radio stations added recently",
        noName: "No name provided",
        notFound: "was not found",
        scrollUnverified: "Scroll to unverified radios",
        scrollToVerified: "Scroll to verified radios",
        requestingInfo: "Requesting information",
        signingIn: "Signing in",
        verifyingInfo: "Verifying information",
        loadingData: "Loading data",
        login: "Login",
        logIn: "Log in",
        email: "Email",
        password: "Password",
        permissionDenied: "You do not have permission to view this content",
        invalidPassword: "Invalid password",
        invalidEmail: "Invalid email",
        userDisabled: "This account is disabled",
        userNotFound: "The account was not found",
        unknownError: "Unknown error. Please try again later",
        logout: "Logout",
        confirmLogout: "Are you sure you want to logout?",
        close: "Close",
        signOut: "Sign out",
        signingOut: "Signing out",
        slogan: "Slogan",
        description: "Description",
        name: "Name",
        logo: "Logo",
        banner: "Banner",
        streamUrl: "Stream URL",
        location: "Location",
        phone: "Phone",
        website: "Website",
        audioWorking: "Is the audio working?",
        errorAudio: "The audio could not played",
        requestInfo: "Request information",
        removeRadio: "Remove radio",
        approveRadio: "Approve radio",
        updateRadio: "Update radio",
        unsecureUrl: "The radio stream is unsecure (http)",
        errorPlay: "The radio stream could not be loaded",
        successPlay: "The radio stream played successfully",
        testNewStream: "Test a different stream url:",
        test: "Test",
        visitStream: "Visit stream url",
        visitWeb: "Visit website",
        adminInfo: "Admin information",
        adminId: "Admin id",
        requestDate: "Request date",
        radioInfo: "Radio information",
        radioId: "Radio id",
        back: "Back",
        webStream: "Web Streaming URL",
        welcomeMsg: "Welcome message",
        today: "Today",
        yesterday: "Yesterday",
        welcome: "\uD83D\uDC4B Welcome $name \uD83D\uDC4B",
        sendMsg: "Send message",
        undo: "Undo",
        cancel: "Cancel",
        delete: "Delete",
        yes: "Yes",
        no: "No",
        selectReason: "Select reason",
        rmnMessage: "Thank you for submitting your station, <b>$name</b>. Unfortunately, we were unable to add your station to ChatMurcianys for this reason:<br><br>",
        r1: "Invalid/incomplete information",
        m1: "The information you provided could not be verified.",
        r2: "Invalid streaming URL",
        m2: "The streaming URL provided is not working.",
        r3: "Policy violation",
        m3: 'The station violates ChatMurcianys guidelines. Visit <a target="_blank" href="https://chatmurcianys.com/about#privacy">https://chatmurcianys.com/about#privacy</a> for more information.',
        other: "Other",
        m4: "We are contacting you for the following reason:",
        updateRadioInfo: 'You may update your station by visiting <a target="_blank" href="https://chatmurcianys.com/chat/#r=$id">chatmurcianys.com/chat/#r=$id</a> or using the ChatMurcianys app and going to "My radios"',
        reSubmitRadio: "You may re-submit your station by visiting chatmurcianys.com/addRadio or using our app, ChatMurcianys, on the Google Play Store.",
        sub1: "$name approval|ChatMurcianys",
        sub2: "$name submission incomplete|ChatMurcianys",
        sub3: "$name Submission response|ChatMurcianys",
        sub4: "$name Important Information|ChatMurcianys",
        confirmRemoval: "Confirm removal",
        confirmRemovalMsg: "Are you sure you want to remove $name?",
        concludeMsg: "If you have any questions, feel free to respond to this email: info@chatmurcianys.com",
        removalNote: "This information will be made known to <b>$name</b>",
        removingRadio: "Removing radio",
        sendingConfirmation: "Sending confirmation",
        radioRemoved: "Radio removed successfully",
        confirmApprove: "Confirmar aprovaci\xf3n",
        approvalMsg: 'If all the radio station information is accurate, click "Continue"',
        continue: "Continue",
        radioApproved: "The radio was approved successfully",
        errorMissingInfo: "The radio information is incomplete",
        approveEmail: 'Congratulations! Your radio station, <b>$name</b>, was approved.$urlSsl<br><br>Use this link to share with your audience and on social media:<br><br><a target="_blank" href="https://chatmurcianys.com/chat/r=$wName">chatmurcianys.com/chat/r=$wName</a><br><br>To increase and keep the visibility of your station on ChatMurcianys, we encourage you to share the link we have provided. This way you help us keep our services free and bring better things in the future. For more information on how to keep your radio station active in ChatMurcianys, visit <a target="_blank" href="https://chatmurcianys.com/about#station">chatmurcianys.com/chat/about#station</a><br><br>\xa1Welcome to ChatMurcianys!',
        verifyingRadioInfo: "Verifying radio information",
        urlUnsecureMsg: ' However, while your radio station\'s streaming URL is working, the stream is unsecure (http). Because of this, some browsers like Chrome will not play your radio on secured sites (https) like ChatMurcianys.com.In order for your radio to play, you would need to allow unsecured content for ChatMurcianys.com. Chrome users can <a target="_blank" href="https://www.youtube.com/watch?v=v_h0V3NYOGo">watch this video to learn how.</a>Another option would be to contact your provider and request a secured streaming url.',
        removingImages: "Removing images",
        removingChat: "Removing chat room",
        errorChat: "Chat room was not found",
        sendingMessage: "Sending message",
        messageSent: "Menssage sent successfully",
        writeMsgHere: "Write your message here...",
        provideReason: "Provide a reason",
        podcasts: "Podcasts",
        podcast: "Podcast",
        unverifiedPods: "Unverified podcasts",
        noPodVerifications: "No podcast needs verification at this time",
        recentVerifiedPods: "Recently verified podcasts",
        noRecentPods: "No podcasts added recently",
        remove: "Remove",
        update: "Update",
        approve: "Approve",
        sendMessage: "Send message",
        podcastInfo: "Podcast information",
        title: "Title",
        podId: "Id del podcast",
        feedURL: "Feed URL",
        genre: "Genre",
        lang: "Language",
        webPage: "Web page",
        phone_no: "Phone number",
        country: "Country",
        optionalInfo: "Optional information",
        tkLink: "TikTok link",
        ytLink: "YouTube link",
        inLink: "Instagram link",
        twLink: "Twitter link",
        fbLink: "Facebook link",
        addWelcomeMsg: "Add a welcome message",
        verifiedPodcast: "Verified podcast",
        invalidFeed: "Invalid feed",
        removingPod: "Removing podcast",
        m2Pod: "The feed URL provided is not working.",
        m3Pod: "The podcast violates ChatMurcianys guidelines. Visit https://chatmurcianys.com/about#privacy for more information.",
        updatePodInfo: 'You may update your podcast by visiting <a target="_blank" href="https://chatmurcianys.com/chat/#p=$id">chatmurcianys.com/chat/#p=$id</a> or using the ChatMurcianys app and going to "My groups"',
        reSubmitPod: "You may re-submit your podcast by visiting chatmurcianys.com/addPodcast or using our app, ChatMurcianys, on the Google Play Store.",
        podRemoved: "Podcast removed successfully",
        podApproved: "The podcast was approved successfully",
        errorPodMissingInfo: "Podcast information is incomplete",
        podApprovalMsg: 'If all the podcast information is accurate, click "Continue"',
        verifyingPodInfo: "Verifying podcast information",
        approvePodEmail: 'Congratulations! Your podcast, <b>$name</b>, was approved.$urlSsl<br><br>Use this link to share with your audience and on social media:<br><br><a target="_blank" href="https://chatmurcianys.com/chat/p=$wName">chatmurcianys.com/chat/p=$wName</a><br><br>To increase and keep the visibility of your podcast on ChatMurcianys, we encourage you to share the link we have provided. This way you help us keep our services free and bring better things in the future. For more information on how to keep your podcast active in ChatMurcianys, visit <a target="_blank" href="https://chatmurcianys.com/about#podcast">chatmurcianys.com/about#podcast</a><br><br>\xa1Welcome to ChatMurcianys!',
        errorPodNameExists: "The podcast's name is already in use",
        errorFeedExists: "This podcast feed is already registered",
        host: "Host",
        inAppPurchases: "In-app purchases",
        products: "Products",
        noProducts: "No products available at this time",
        coins: "Coins",
        value: "Value",
        id: "Id",
        cost: "Cost",
        addCoinPack: "Add coin pack",
        coinPack: "Coin pack",
        coinAddedSuccess: "Coin added succesfully",
        wdRequests: "Withdrawal requests",
        wds: "Withdrawals",
        noWds: "No withdrawal requests available at this time",
        amount: "Amount",
        wdRequestInfo: "Withdrawal request information",
        date: "Date:",
        reqAmount: "Requested amount",
        initBal: "Initial balance",
        payMethod: "Payout method",
        decline: "Decline",
        approvingWd: "Sending withdrawal approval confirmation",
        confirmSent: "Confirmation sent",
        wdSubApprove: "Withdrawal approval | ChatMurcianys",
        wdSubDeclined: "Withdrawal declined | ChatMurcianys",
        wdAlertMsgApproved: `Your withdrawal request was approved. We have sent the amount requested to the acccount you provided with the following information:<br><ul><li>Method: $method</li><li>Account: $acc</li><li>Amount: $amount USD</li></ul><br>Depending on the payout provider, it may take a while to receive your money. Please allow at least 21 days for the funds to transfer into your account. If you still don't receive your payment, contact us at info@chatmurcianys.com`,
        wdR1: `We could not verify the payout account`,
        wdR2: `The amount requested is greater than the account balance`,
        wdAlertMsgDeclined: `We could not complete your withdrawal request:<br><ul><li>Method: $method</li><li>Account: $acc</li><li>Amount: $amount USD</li></ul><br>Your request was rejected because:<br>$reason<br>If your withdrawal complies with our Policies, you will receive the requested withdrawal amount in Rubies to your ChatMurcianys account balance.<br>For more information, contact us at info@chatmurcianys.com or visit <a href="https://chatmurcianys.com/about#withdrawal-policy">chatmurcianys.com/about#withdrawal-policy</a>`,
        confirmMsg: `If all information is accurate, click "Continue"`,
        confirmWdNotif: `Confirm withdrawal approval`,
        clearSearch: "Clear search",
        searchWait: "Searching...please wait",
        viewAll: "View all",
        errorRadioNameTaken: "Radio name is not available",
        errorRadioStreamTaken: "Radio streaming URL is not available",
        successUpdate: "Information updated successfully",
        markRevision: "Mark for revision",
        successRevision: "Marked for revision",
        addingRevision: "Adding for revision",
        needRevision: "In need of revision",
        noRevisions: "No revisions needed at this time",
        edit: "Edit",
        revisionRemoved: "Removed from revisions"
    },
    es: {
        language: "es",
        appSum: "Resumen de la aplicaci\xf3n",
        radioStations: "Estaciones de radio",
        registeredUsers: "Usuarios registrados",
        translate: "Traducir",
        unverifiedRadios: "Radios no verificadas",
        verifiedRadios: "Radios verificadas",
        totalUsers: "Total de usuarios",
        latestVersion: "Versi\xf3n actual",
        contactInfo: "Informaci\xf3n de contacto",
        linksToShare: "Enlaces para compartir",
        mainWebsite: "Sitio web principal",
        googlePlayStore: "Tienda de Google Play",
        shortLink: "Enlace corto",
        noVerification: "Ninguna estaci\xf3n de radio necesita verificaci\xf3n en este momento",
        recentVerifiedRadios: "Radios verificadas recientemente",
        uploadingInfo: "Subiendo informaci\xf3n",
        copy: "Copiar",
        search: "Buscar",
        addContactEmail: "A\xf1adir mi correo electr\xf3nico",
        hideNavMenu: "Ocultar men\xfa de navegaci\xf3n",
        showNavMenu: "Mostrar men\xfa de navegaci\xf3n",
        noRecentRadios: "No se agregaron estaciones de radio recientemente",
        noName: "Nombre no proporcionado",
        notFound: "No fue encontrado",
        scrollUnverified: "Ir a radios no verificadas",
        scrollToVerified: "Ir a radios verificadas",
        requestingInfo: "Solicitando informaci\xf3n",
        signingIn: "Iniciando sesi\xf3n",
        verifyingInfo: "Verificando informaci\xf3n",
        loadingData: "Bajando informaci\xf3n",
        login: "Entrar al sistema",
        logIn: "Iniciar sesi\xf3n",
        email: "Correo electr\xf3nico",
        password: "Contrase\xf1a",
        permissionDenied: "No tienes permiso de ver este contenido",
        invalidPassword: "La contrase\xf1a es invalida",
        invalidEmail: "El correo electr\xf3nico es invalido",
        userDisabled: "La cuenta est\xe1 deshabilitada",
        userNotFound: "La cuenta no se encontr\xf3",
        unknownError: "Error desconocido. Por favor vuelve a intentarlo m\xe1s tarde",
        logout: "Cerrar sesi\xf3n",
        confirmLogout: "\xbfQuieres cerrar sesi\xf3n?",
        close: "Cerrar",
        signOut: "Cerrar sesi\xf3n",
        signingOut: "Cerrando sesi\xf3n",
        slogan: "Eslogan",
        description: "Descripci\xf3n",
        name: "Nombre",
        logo: "Logotipo",
        banner: "Bandera",
        streamUrl: "URL de transmisi\xf3n de radio",
        location: "Ubicaci\xf3n",
        phone: "Tel\xe9fono",
        website: "Sitio web",
        audioWorking: "\xbfEsta funcionando la radio?",
        errorAudio: "El audio no se pudo reproducir",
        requestInfo: "Solicitar informaci\xf3n",
        removeRadio: "Remover radio",
        approveRadio: "Aprobar radio",
        updateRadio: "Actualizar radio",
        unsecureUrl: "URL de transmisi\xf3n no es seguro (http)",
        errorPlay: "El URL de transmisi\xf3n no se pudo reproducir",
        successPlay: "URL de transmisi\xf3n se repoduci\xf3 con \xe9xito",
        testNewStream: "Prueba un URL de transmisi\xf3n diferente:",
        test: "Probar",
        visitStream: "Visitar URL de transmisi\xf3n",
        visitWeb: "Visitar sitio web",
        adminInfo: "Informaci\xf3n de administrador",
        adminId: "Id de administrador",
        requestDate: "Fecha de solicitud",
        radioInfo: "Informaci\xf3n de la radio",
        radioId: "Id de la radio",
        back: "Regresar",
        webStream: "Sitio web URL de transmisi\xf3n",
        welcomeMsg: "Mensaje de bienvenida",
        today: "Hoy",
        yesterday: "Ayer",
        welcome: "\uD83D\uDC4BBienvenid@ $name \uD83D\uDC4B",
        sendMsg: "Enviar mensaje",
        undo: "Revertir",
        cancel: "Cancelar",
        delete: "Borrar",
        yes: "Si",
        no: "No",
        selectReason: "Seleccionar motivo",
        rmnMessage: "Gracias por someter tu estaci\xf3n, <b>$name</b>. Desafortunadamente, no pudimos agregar tu estaci\xf3n a ChatMurcianys por esta raz\xf3n:<br><br>",
        r1: "Informaci\xf3n invalida/incompleta",
        m1: "La informaci\xf3n sometida no se pudo verificar.",
        r2: "El URL de transmisi\xf3n no es valido",
        m2: "El URL de transmisi\xf3n no se pudo reproducir",
        r3: "Violaci\xf3n de la pol\xedtica",
        m3: 'La estaci\xf3n viola las reglas de ChatMurcianys. Visite <a target="_blank" href="https://chatmurcianys.com/about#privacy">https://chatmurcianys.com/about#privacy</a> para obtener m\xe1s informaci\xf3n.',
        other: "Otra",
        m4: "Te estamos contactando por la siguiente raz\xf3n:",
        updateRadioInfo: 'Puedes actualizar tu estaci\xf3n visitando <a target="_blank" href="https://chatmurcianys.com/chat/#r=$id">chatmurcianys.com/chat/#r=$id</a> o usando la aplicaci\xf3n ChatMurcianys y yendo a "Mis radios"',
        reSubmitRadio: "Puedes volver a someter tu estaci\xf3n visitando chatmurcianys.com/addRadio o usando nuestra aplicaci\xf3n, ChatMurcianys, en Google Play Store.",
        sub1: "$name aprobaci\xf3n|ChatMurcianys",
        sub2: "$name Informaci\xf3n incompleta|ChatMurcianys",
        sub3: "$name Respuesta de la registraci\xf3n|ChatMurcianys",
        sub4: "$name Informaci\xf3n Importante|ChatMurcianys",
        confirmRemoval: "Confirmar eliminaci\xf3n",
        confirmRemovalMsg: "Quieres remover a <b>$name</b>?",
        concludeMsg: "Si tienes alguna pregunta, no dudes en responder a este correo: info@chatmurcianys.com",
        removalNote: "Esta informaci\xf3n se le hara saber a <b>$name</b>",
        removingRadio: "Removiendo la radio",
        sendingConfirmation: "Enviando confirmaci\xf3n",
        radioRemoved: "La radio fue removida con \xe9xito",
        confirmApprove: "Confirmar aprovaci\xf3n",
        approvalMsg: 'Si toda la informaci\xf3n de la radio est\xe1 correcta, presi\xf3na "Continuar"',
        continue: "Continuar",
        radioApproved: "La radio fue aprovada con \xe9xito",
        errorMissingInfo: "La informaci\xf3n de la radio est\xe1 incompleta",
        approveEmail: '\xa1Felicidades! Tu estaci\xf3n de radio, <b>$name</b>, fue aprovada.$urlSsl<br><br>Usa este enlace para compartir con tus oyentes y en las redes sociales:<br><br><a target="_blank" href="https://chatmurcianys.com/chat/r=$wName">chatmurcianys.com/chat/r=$wName</a><br><br>Para aumentar y mantener la visibilidad de tu radio en ChatMurcianys, te recomendamos que compartas el enlace que hemos proveido. De esta manera nos ayudas a mantener nuestros servicios gratis y traer mejores cosas a futuro. Para m\xe1s informaci\xf3n sobre como mantener tu radio activa en ChatMurcianys, visita <a target="_blank" href="https://chatmurcianys.com/about#station">chatmurcianys.com/chat/about#station</a><br><br>\xa1Bievenid@ a ChatMurcianys!',
        verifyingRadioInfo: "Verificando informaci\xf3n de la radio",
        urlUnsecureMsg: ' Sin embargo, aunque el URL de transmisi\xf3n de la radio es valida, la transmisi\xf3n no es segura (http). Debido a esto, algunos navegadores como Chrome no reproducir\xe1n tu radio en sitios seguros (https) como ChatMurcianys.com.Para que tu radio se pueda escuchar, necesitas permitir contenido no seguro para ChatMurcianys.com. Los usuarios de Chrome pueden <a target="_blank" href="https://www.youtube.com/watch?v=v_h0V3NYOGo">mirar este video para aprender como.</a>Otra opci\xf3n ser\xeda que cont\xe1ctes a tu proveedor y solicitar una URL de transmisi\xf3n segura (https).',
        removingImages: "Removiendo las im\xe1genes",
        removingChat: "Removiendo la sala de chat",
        errorChat: "No se encontr\xf3 la sala de chat",
        sendingMessage: "Enviando mensaje",
        messageSent: "Mensaje enviado con \xe9xito",
        writeMsgHere: "Escribe tu mensaje aqu\xed...",
        provideReason: "Provee una raz\xf3n",
        podcasts: "Podcasts",
        podcast: "Podcast",
        unverifiedPods: "Podcasts no verificadas",
        noPodVerifications: "Ning\xfan podcast necesita verificaci\xf3n en este momento",
        recentVerifiedPods: "Podcasts recientemente verificadas",
        noRecentPods: "No se agregaron podcasts recientemente",
        remove: "Remover",
        update: "Actualizar",
        approve: "Aprobar",
        sendMessage: "Enviar mensaje",
        podcastInfo: "Informaci\xf3n del podcast",
        title: "T\xedtulo",
        podId: "Podcast Id",
        feedURL: "Enlace de fuente",
        genre: "G\xe9nero",
        lang: "Idioma",
        webPage: "P\xe1gina web",
        phone_no: "N\xfamero de tel\xe9fono",
        country: "Pa\xeds",
        optionalInfo: "Informaci\xf3n opcional",
        tkLink: "Enlace de TikTok",
        ytLink: "Enlace de YouTube",
        inLink: "Enlace de Instagram",
        twLink: "Enlace de Twitter",
        fbLink: "Enlace de Facebook",
        addWelcomeMsg: "Agregar mensaje de bienvenida",
        verifiedPodcast: "Podcasts verificados",
        invalidFeed: "Enlace de fuente invalido",
        removingPod: "Removiendo podcast",
        m2Pod: "El enlace de la fuente de transmisi\xf3n no se pudo reproducir",
        m3Pod: 'La estaci\xf3n viola las reglas de ChatMurcianys. Visite <a target="_blank" href="https://chatmurcianys.com/about#privacy" para obtener m\xe1s informaci\xf3n.',
        updatePodInfo: 'Puedes actualizar tu podcast visitando <a target="_blank" href="https://chatmurcianys.com/chat/#p=$id">chatmurcianys.com/chat/#p=$id</a> o usando la aplicaci\xf3n ChatMurcianys y yendo a "Mis grupos"',
        reSubmitPod: "Puedes volver a someter tu estaci\xf3n visitando chatmurcianys.com/addPodcast o usando nuestra aplicaci\xf3n, ChatMurcianys, en Google Play Store.",
        podRemoved: "El podcast fue removido con \xe9xito",
        podApproved: "El podcast fue aprovada con \xe9xito",
        errorPodMissingInfo: "La informaci\xf3n del podcast est\xe1 incompleta",
        podApprovalMsg: 'Si toda la informaci\xf3n del podcast est\xe1 correcta, presi\xf3na "Continuar"',
        verifyingPodInfo: "Verificando informaci\xf3n del podcast",
        approvePodEmail: '\xa1Felicidades! Tu podcast, <b>$name</b>, fue aprovada.$urlSsl<br><br>Usa este enlace para compartir con tus oyentes y en las redes sociales:<br><br><a target="_blank" href="https://chatmurcianys.com/chat/p=$wName">chatmurcianys.com/chat/p=$wName</a><br><br>Para aumentar y mantener la visibilidad de tu podcast en ChatMurcianys, te recomendamos que compartas el enlace que hemos proveido. De esta manera nos ayudas a mantener nuestros servicios gratis y traer mejores cosas a futuro. Para m\xe1s informaci\xf3n sobre como mantener tu podcast activo en ChatMurcianys, visita <a target="_blank" href="https://chatmurcianys.com/about#podcast">chatmurcianys.com/about#podcast</a><br><br>\xa1Bievenid@ a ChatMurcianys!',
        errorPodNameExists: "El nombre del podcast ya esta en uso",
        errorFeedExists: "Esta fuente del podcast ya est\xe1 registrada",
        host: "Locutor",
        inAppPurchases: "Compras en la aplicaci\xf3n",
        products: "Productos",
        noProducts: "No hay productos disponibles en este momento",
        coins: "Monedas",
        value: "Valor",
        id: "Id",
        cost: "Precio",
        addCoinPack: "Agregar paquete de monedas",
        coinPack: "Paquete de moneda",
        coinAddedSuccess: "Moneda agregada con \xe9xito",
        wdRequests: "Solicitudes de retiro",
        wds: "Retiros",
        noWds: "No hay solicitudes de retiro en este momento",
        amount: "Cantidad",
        wdRequestInfo: "Informaci\xf3n de solicitud de retiro",
        date: "Fecha:",
        reqAmount: "Cantidad solicitada:",
        initBal: "Balance inicial",
        payMethod: "M\xe9todo de pago",
        decline: "Declinar",
        approvingWd: "Enviando confirmaci\xf3n de aprobaci\xf3n de retiro",
        confirmSent: "Confirmaci\xf3n enviada",
        wdSubApprove: "Aprobaci\xf3n de retiro | ChatMurcianys",
        wdSubDeclined: "Retiro declinado | ChatMurcianys",
        wdAlertMsgApproved: "Tu solicitud de retiro fue aprobada. Hemos enviado el monto solicitado a la cuenta proporcionada con la siguiente informaci\xf3n:<br><ul><li>M\xe9todo: $method</li><li>Cuenta: $acc</li><li>Cantidad: $amount USD</li></ul><br>Dependiendo del proveedor de pago, puede tomar un tiempo recibir tu dinero. Espera al menos 21 d\xedas para que los fondos se transfieran a tu cuenta. Si a\xfan no recibes tu pago, cont\xe1ctanos en info@chatmurcianys.com",
        wdR1: `No pudimos verificar la cuenta de pago`,
        wdR2: `La cantidad solicitada es mayor que el balance de la cuenta`,
        wdAlertMsgDeclined: `No pudimos completar tu solicitud de retiro:<br><ul><li>Método: $method</li><li>Cuenta: $acc</li><li>Cantidad: $amount USD</li></ ul><br>Tu solicitud fue rechazada porque:<br>$reason<br>Si tu retiro cumple con nuestras Políticas, recibirá el monto del retiro solicitado en Rubíes en el saldo de tu cuenta de ChatMurcianys.<br>Para obtener más información, contáctanos en info@chatmurcianys.com o visita <a href="https://chatmurcianys.com/about#withdrawal-policy">chatmurcianys.com/sobre#politica-de-retiros</a>`,
        confirmMsg: `Si toda la información está correcta, presióna "Continuar"`,
        confirmWdNotif: `Confirmar aprobación de retiro`,
        clearSearch: "Borrar b\xfasqueda",
        searchWait: "Buscando...por favor espere",
        viewAll: "Ver todos",
        errorRadioNameTaken: "El nombre de la radio no est\xe1 disponible",
        errorRadioStreamTaken: "El URL de transmisi\xf3n de radio no est\xe1 disponible",
        successUpdate: "Informaci\xf3n actualizada con \xe9xito",
        markRevision: "Marcar para revisi\xf3n",
        successRevision: "Marcado para revisi\xf3n",
        addingRevision: "Agregando para revisar",
        needRevision: "Necesitan revisi\xf3n",
        noRevisions: "No se necesitan revisiones en este momento",
        edit: "Editar",
        revisionRemoved: "Removido de revisiones"
    }
};
function translatePage(lang) {
    var translate = false;
    if (lang) {
        translate = true;
        if (lang.includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            aEn.className = aEn.className.replace("selected", "");
            aEs.className += "selected";
            (0, _common.setCookie)("lang", "es", 365);
        } else {
            trans = language.eng;
            document.getElementsByTagName("html")[0].setAttribute("lang", "en");
            aEs.className = aEn.className.replace("selected", "");
            aEn.className += "selected";
            (0, _common.setCookie)("lang", "en", 365);
        }
    } else if ((0, _common.getCookie)("lang") != "") {
        if ((0, _common.getCookie)("lang").includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className = langs[0].className.replace("selected", "");
            langs[1].className += "selected";
            translate = true;
            (0, _common.setCookie)("lang", "es", 365);
        } else trans = language.eng;
    } else if (window.navigator.language && window.navigator.language.includes("es")) {
        translate = true;
        trans = language.es;
        document.getElementsByTagName("html")[0].setAttribute("lang", "es");
        aEn.className = aEn.className.replace(" selected", "");
        aEs.className += " selected";
    } else trans = language.eng;
    if (translate) {
        $(".copy").attr("title", trans.copy);
        //var navs = navList.querySelectorAll('a .title')
        navTitles[0].textContent = trans.appSum;
        navTitles[1].textContent = trans.radioStations;
        navTitles[2].textContent = trans.registeredUsers;
        navTitles[3].textContent = trans.podcasts;
        navTitles[4].textContent = trans.inAppPurchases;
        navTitles[5].textContent = trans.wds;
        aTranslate.querySelector(".title").textContent = trans.translate;
        navContent.querySelector("h2").textContent = mainNav ? navs[mainNav].textContent : trans.appSum;
        search.querySelector("input").placeholder = trans.search;
        btnSearch.title = trans.search;
        btnClearSearch.title = trans.clearSearch;
        btnClearSearch.querySelector("span").textContent = trans.clearSearch;
        unverifiedTotal.querySelector("h3").textContent = trans.unverifiedRadios;
        radioTotal.querySelector("h3").textContent = trans.verifiedRadios;
        userTotal.querySelector("h3").textContent = trans.totalUsers;
        appInfo.querySelector("h3").textContent = trans.latestVersion;
        unverifiedPodTotal.querySelector("h3").textContent = trans.unverifiedPods;
        podTotal.querySelector("h3").textContent = trans.verifiedPodcast;
        contact.querySelector("h3").textContent = trans.contactInfo;
        btnAddEmail.querySelector("span").textContent = trans.addContactEmail;
        links.querySelector("h3").textContent = trans.linksToShare;
        var linkPs = links.querySelectorAll("p");
        linkPs[0].textContent = trans.mainWebsite;
        linkPs[1].textContent = trans.googlePlayStore;
        linkPs[2].textContent = trans.shortLink;
        verify.querySelector("h3 span").textContent = trans.unverifiedRadios;
        verify.querySelector(".empty span").textContent = trans.noVerification;
        reviseRadios.querySelector("h3 span").textContent = trans.needRevision;
        reviseRadios.querySelector(".empty span").textContent = trans.noRevisions;
        verified.querySelector("h3 span").textContent = trans.recentVerifiedRadios;
        verified.querySelector(".empty span").textContent = trans.noRecentRadios;
        progress.querySelector(".message").textContent = trans.uploadingInfo;
        var navDisplay = nav.style.display;
        if (window.innerWidth <= 840) {
            if (navDisplay == "" || navDisplay == "none") btnToggleNav.title = trans.showNavMenu;
            else btnToggleNav.title = trans.hideNavMenu;
        } else if (navDisplay == "" || navDisplay == "flex") btnToggleNav.title = trans.hideNavMenu;
        else btnToggleNav.title = trans.showNavMenu;
        var scrollButtons = inScroll.querySelectorAll("button");
        scrollButtons[0].title = trans.scrollUnverified;
        scrollButtons[1].title = trans.scrollToVerified;
        var inputs = login.querySelectorAll("input");
        inputs[0].placeholder = trans.email;
        inputs[1].placeholder = trans.password;
        login.querySelectorAll("h3 span").textContent = trans.login;
        login.querySelector("button").textContent = trans.logIn;
        $(".btn-close").attr("title", trans.close);
        signout.querySelector("h3 span").textContent = trans.confirmLogout;
        signout.querySelector(".btn-blue").textContent = trans.logout;
        btnLogout.querySelector("span").textContent = trans.signOut;
        imgLogo.alt = trans.logo;
        imgBanner.alt = trans.banner;
        lblRadioName.textContent = trans.name + ":";
        inRadioName.placeholder = trans.name;
        lblSlogan.textContent = trans.slogan + ":";
        inSlogan.placeholder = trans.slogan;
        lblDesc.textContent = trans.description + ":";
        inDesc.placeholder = trans.description;
        lblStream.textContent = trans.streamUrl + ":";
        inStream.placeholder = trans.streamUrl;
        lblAudio.textContent = trans.audioWorking;
        //audioAlert
        lblLocation.textContent = trans.location + ":";
        inLocation.placeholder = trans.location;
        lblEmail.textContent = trans.email + ":";
        inEmail.placeholder = trans.email;
        lblPhone.textContent = trans.phone + ":";
        inPhone.placeholder = trans.phone;
        lblWeb.textContent = trans.website + ":";
        inWeb.placeholder = trans.website;
        btnRequestInfo.querySelector("span").textContent = trans.sendMsg;
        btnReject.querySelector("span").textContent = trans.removeRadio;
        btnApprove.querySelector("span").textContent = trans.approveRadio;
        btnUpdate.querySelector("span").textContent = trans.updateRadio;
        btnGoStream.textContent = trans.visitStream;
        btnGoWeb.textContent = trans.visitWeb;
        adminInfo.querySelector("h3 span").textContent = trans.adminInfo;
        radioInfo.querySelector("h3 span").textContent = trans.radioInfo;
        iRadioId.textContent = trans.radioId + ": ";
        iRequestDate.textContent = trans.requestDate + ": ";
        iAdminId.textContent = trans.adminId + ": ";
        btnBack.title = trans.back;
        lblWebStream.textContent = trans.webStream + ":";
        lblAdminName.textContent = trans.name + ":";
        lblWelcome.textContent = trans.welcomeMsg + ":";
        inAdminName.placeholder = trans.name;
        inWelcome.placeholder = trans.welcome;
        inWebStream.placeholder = trans.webStream;
        lblTestUrl.textContent = trans.testNewStream;
        btnTestUrl.textContent = trans.test;
        pAudioAlert.textContent = trans.errorAudio;
        $(".undo").attr("title", trans.undo);
        reasonDialog.querySelector(".blueBtn").textContent = trans.continue;
        var lReasons = reasonDialog.querySelectorAll("label");
        lReasons[0].textContent = trans.r1;
        lReasons[1].textContent = trans.r2;
        lReasons[2].textContent = trans.r3;
        lReasons[3].textContent = trans.other;
        reasonDialog.querySelector("h3").textContent = trans.selectReason;
        taOther.placeholder = trans.writeMsgHere;
        $(".tc-write-msg-here").attr("placeholder", trans.writeMsgHere);
        podVerify.querySelector("h3 span").textContent = trans.unverifiedPods;
        podVerify.querySelector(".empty span").textContent = trans.noPodVerifications;
        podVerified.querySelector("h3 span").textContent = trans.recentVerifiedPods;
        podVerified.querySelector(".empty span").textContent = trans.noRecentPods;
        $(".admin-info").text(trans.adminInfo);
        $(".l-admin-id").text(trans.adminId + ": ");
        $(".admin-info").text(trans.adminInfo);
        $(".x-name").text(trans.name);
        $(".req-date").text(trans.requestDate);
        $(".btn-msg").text(trans.sendMsg);
        $(".btn-remove").text(trans.remove);
        $(".btn-approve").text(trans.approve);
        $(".btn-update").text(trans.update);
        $(".x-email").text(trans.email);
        $(".ph-email").attr("placeholder", trans.email);
        $(".ph-name").attr("placeholder", trans.name);
        $(".l-podId").text(trans.podId + ": ");
        podInfo.querySelector("h3 span").textContent = trans.podcastInfo;
        $(".x-title").text(trans.title);
        $(".ph-title").attr("placeholder", trans.title);
        $(".ph-desc").attr("placeholder", trans.description);
        $(".l-desc").text(trans.description + ": ");
        $(".x-audio-test").text(trans.audioWorking);
        aFeedUrl.textContent = trans.visitStream;
        $(".x-test").text(trans.test);
        lblPodTestUrl.textContent = trans.testNewStream;
        inFeed.placeholder = trans.feedURL;
        lblPodFeed.textContent = trans.feedURL;
        $(".x-genre").text(trans.genre);
        $(".ph-genre").attr("placeholder", trans.genre);
        $(".x-lang").text(trans.lang);
        $(".ph-lang").attr("placeholder", trans.lang);
        $(".x-country").text(trans.country);
        $(".ph-country").attr("placeholder", trans.country);
        podOptionalInfo.querySelector("h3 span").textContent = trans.optionalInfo;
        $(".x-web").text(trans.webPage);
        $(".ph-web").text(trans.webPage);
        $(".x-visitWeb").text(trans.visitWeb);
        $(".x-phone").text(trans.phone_no);
        $(".ph-phone").attr("placeholder", trans.phone_no);
        $(".ph-fbLink").attr("placeholder", trans.fbLink);
        $(".ph-twLink").attr("placeholder", trans.twLink);
        $(".ph-inLink").attr("placeholder", trans.inLink);
        $(".ph-ytLink").attr("placeholder", trans.ytLink);
        $(".ph-tkLink").attr("placeholder", trans.tkLink);
        $(".ph-ph-addWelcome").attr("placeholder", trans.addWelcomeMsg);
        $(".l-welcomeMsg").text(trans.welcomeMsg);
        $(".x-selReason").text(trans.selectReason);
        $(".x-invalInfo").text(trans.r1);
        $("#podRad2").text(trans.invalidFeed);
        $(".x-polVio").text(trans.r3);
        $(".x-other").text(trans.other);
        $(".ph-writeMsg").attr("placeholder", trans.writeMsgHere);
        $(".x-continue").text(trans.continue);
        $(".x-host").text(trans.host);
        divProducts.querySelector("h3 span").textContent = trans.products;
        divProducts.querySelector(".empty span").textContent = trans.noProducts;
        coinFrag.querySelector("h4 span").textContent = trans.coins;
        var coinGridList = coinFrag.querySelectorAll(".grid-3 p");
        coinGridList[0].textContent = trans.value;
        coinGridList[1].textContent = trans.id;
        coinGridList[2].textContent = trans.cost;
        btnAddProduct.textContent = trans.addCoinPack;
        btnAddCoinPack.textContent = trans.addCoinPack;
        divCoinPack.querySelector("h3 span").textContent = trans.coinPack;
        withdrawals.querySelector("h3 span").textContent = trans.wdRequests;
        wds.querySelector(".empty span").textContent = trans.noWds;
        wdInfoFrag.querySelector("h3 span").textContent = trans.wdRequestInfo;
        divWdReqInfo.querySelector(".wdDate span").textContent = trans.date;
        var wdLabels = divWdUser.querySelectorAll("label");
        wdLabels[0].textContent = trans.name;
        wdLabels[1].textContent = trans.reqAmount;
        wdLabels[2].textContent = trans.initBal;
        wdLabels[3].textContent = trans.payMethod;
        btnWdApprove.textContent = trans.approve;
        btnWdDecline.textContent = trans.decline;
        var btnGoWdRequests = document.getElementById("btnGoWdRequests");
        btnGoWdRequests.querySelector("span").textContent = trans.wdRequests;
        var btnGoProd = document.getElementById("btnGoProd");
        btnGoProd.querySelector("span").textContent = trans.products;
        $(".tc-sel-reason").text(trans.selectReason);
        $(".tc-continue").text(trans.continue);
        var lReasons = wdDeclineDialog.querySelectorAll("label");
        lReasons[0].textContent = trans.wdR1;
        lReasons[1].textContent = trans.wdR2;
        lReasons[2].textContent = trans.other;
        spNotFound.textContent = trans.notFound;
        pResultLoader.querySelector("span").textContent = trans.searchWait;
        btnRadioRevision.querySelector("span").textContent = trans.markRevision;
        $(".btnEdit span").text(trans.edit);
        $(".btnRemove span").text(trans.remove);
        $(".btnEdit").attr("title", trans.edit);
        $(".btnRemove").attr("title", trans.remove);
    }
}

},{"./common":"loJev","url:../images/radio_placeholder.svg":"fCJPK","url:../images/person.svg":"5VoOu","url:../images/sound_wave.svg":"853cL","url:../images/podcast.svg":"6azT2","url:../images/ic_coins.svg":"5UIr4","./config":"cl3hM","ad81798b25f8b0b0":"Je4pI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"loJev":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initCommonViews", ()=>initCommonViews);
parcelHelpers.export(exports, "checkDevice", ()=>checkDevice);
parcelHelpers.export(exports, "closeModal", ()=>closeModal);
parcelHelpers.export(exports, "closeMyModal", ()=>closeMyModal);
parcelHelpers.export(exports, "openCommonModal", ()=>openCommonModal);
parcelHelpers.export(exports, "setDisplay", ()=>setDisplay);
parcelHelpers.export(exports, "setModalMessage", ()=>setModalMessage);
parcelHelpers.export(exports, "showToast", ()=>showToast);
parcelHelpers.export(exports, "getAudioTime", ()=>getAudioTime);
parcelHelpers.export(exports, "getDuration", ()=>getDuration);
parcelHelpers.export(exports, "sameDay", ()=>sameDay);
parcelHelpers.export(exports, "formatMessageDate", ()=>formatMessageDate);
parcelHelpers.export(exports, "formatTime", ()=>formatTime);
parcelHelpers.export(exports, "formatMilTime", ()=>formatMilTime);
parcelHelpers.export(exports, "getDayAbbr", ()=>getDayAbbr);
parcelHelpers.export(exports, "sendVoiceMsg", ()=>sendVoiceMsg);
parcelHelpers.export(exports, "sendTextMessage", ()=>sendTextMessage);
parcelHelpers.export(exports, "sendGifMessage", ()=>sendGifMessage);
parcelHelpers.export(exports, "disableButton", ()=>disableButton);
parcelHelpers.export(exports, "setBackgroundImage", ()=>setBackgroundImage);
parcelHelpers.export(exports, "addSizeToGoogleProfilePic", ()=>addSizeToGoogleProfilePic);
parcelHelpers.export(exports, "linkify", ()=>linkify);
parcelHelpers.export(exports, "setCookie", ()=>setCookie);
parcelHelpers.export(exports, "deleteCookie", ()=>deleteCookie);
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
parcelHelpers.export(exports, "appId", ()=>appId);
parcelHelpers.export(exports, "dragElement", ()=>dragElement);
parcelHelpers.export(exports, "saveLocalFile", ()=>saveLocalFile);
parcelHelpers.export(exports, "saveFile", ()=>saveFile);
parcelHelpers.export(exports, "copyText", ()=>copyText);
parcelHelpers.export(exports, "copyInput", ()=>copyInput);
parcelHelpers.export(exports, "gphClose", ()=>gphClose);
parcelHelpers.export(exports, "gphGif", ()=>gphGif);
parcelHelpers.export(exports, "getGenre", ()=>getGenre);
parcelHelpers.export(exports, "getGenreIndex", ()=>getGenreIndex);
parcelHelpers.export(exports, "getGenreList", ()=>getGenreList);
parcelHelpers.export(exports, "getLangList", ()=>getLangList);
parcelHelpers.export(exports, "getLangCode", ()=>getLangCode);
parcelHelpers.export(exports, "getLangIndex", ()=>getLangIndex);
parcelHelpers.export(exports, "getLangName", ()=>getLangName);
parcelHelpers.export(exports, "getCountryList", ()=>getCountryList);
parcelHelpers.export(exports, "getCountryCode", ()=>getCountryCode);
parcelHelpers.export(exports, "getCountryIndex", ()=>getCountryIndex);
parcelHelpers.export(exports, "getCountryName", ()=>getCountryName);
parcelHelpers.export(exports, "reformatPaste", ()=>reformatPaste);
parcelHelpers.export(exports, "getRandomNum", ()=>getRandomNum);
parcelHelpers.export(exports, "getPodClass", ()=>getPodClass);
parcelHelpers.export(exports, "validateEmail", ()=>validateEmail);
parcelHelpers.export(exports, "validateURL", ()=>validateURL);
parcelHelpers.export(exports, "validateLettersNums", ()=>validateLettersNums);
parcelHelpers.export(exports, "removeTags", ()=>removeTags);
parcelHelpers.export(exports, "parseDuration", ()=>parseDuration);
parcelHelpers.export(exports, "formatTimeHMS", ()=>formatTimeHMS);
parcelHelpers.export(exports, "formatDurationHMS", ()=>formatDurationHMS);
parcelHelpers.export(exports, "DATABASE_IN_APP_PRODUCTS", ()=>DATABASE_IN_APP_PRODUCTS);
parcelHelpers.export(exports, "scrollRight", ()=>scrollRight);
parcelHelpers.export(exports, "scrollLeft", ()=>scrollLeft);
parcelHelpers.export(exports, "scrollTop", ()=>scrollTop);
parcelHelpers.export(exports, "scrollBtm", ()=>scrollBtm);
parcelHelpers.export(exports, "GroupType", ()=>GroupType);
var _gph5Gif = require("url:../images/gph5.gif");
var _gph5GifDefault = parcelHelpers.interopDefault(_gph5Gif);
var _gph1Gif = require("url:../images/gph1.gif");
var _gph1GifDefault = parcelHelpers.interopDefault(_gph1Gif);
var divModal;
var modalMessage;
var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
];
var dias = [
    "Domingo",
    "Lunes",
    "Martes",
    "Mi\xe9rcoles",
    "Jueves",
    "Viernes",
    "S\xe1bado"
];
var dayAbbr = [
    "u",
    "m",
    "t",
    "w",
    "r",
    "f",
    "s"
];
var genres = [
    "Arts and culture",
    "Business and economics",
    "Comedy",
    "Education",
    "Fantasy and science fiction",
    "Food and cooking",
    "Health and wellness",
    "History",
    "Kids and family",
    "Language learning",
    "Media and entertainment",
    "Music",
    "News and Politics",
    "Paranormal",
    "Philosophy",
    "Radio drama",
    "Romance",
    "Adult content",
    "Religion and spirituality",
    "Science",
    "Sports and recreation",
    "Storytelling",
    "Talk show replays",
    "Technology",
    "True crime"
];
var generos = [
    "Arte y cultura",
    "Negocios y Econom\xeda",
    "Comedia",
    "Educaci\xf3n",
    "Fantas\xeda y ciencia ficci\xf3n",
    "Comida y cocina",
    "Salud y bienestar",
    "Historial",
    "Ni\xf1os y familia",
    "Aprendizaje de idiomas",
    "Medios y entretenimiento",
    "M\xfasica",
    "Noticias y pol\xedtica",
    "Paranormal",
    "Filosof\xeda",
    "Radio drama",
    "Romance",
    "Contenido para adultos",
    "Religi\xf3n y espiritualidad",
    "Ciencia",
    "Deportes y recreaci\xf3n",
    "Narraci\xf3n de cuentos",
    "Repeticiones de programas de entrevistas",
    "Tecnolog\xeda",
    "Crimen verdadero"
];
var langs = [
    "Afrikaans",
    "Albanian",
    "Arabic",
    "Belarusian",
    "Bulgarian",
    "Bengali",
    "Catalan",
    "Chinese",
    "Croatian",
    "Czech",
    "Danish",
    "Dutch",
    "English",
    "Esperanto",
    "Estonian",
    "Finnish",
    "French",
    "Galician",
    "Georgian",
    "German",
    "Greek",
    "Gujarati",
    "Haitian",
    "Hebrew",
    "Hindi",
    "Hungarian",
    "Icelandic",
    "Indonesian",
    "Irish",
    "Italian",
    "Japanese",
    "Kannada",
    "Korean",
    "Lithiuanian",
    "Latvian",
    "Macedonian",
    "Marathi",
    "Malay",
    "Maltese",
    "Norwegian",
    "Persian",
    "Polish",
    "Portuguese",
    "Romanian",
    "Russian",
    "Slovak",
    "Slovenian",
    "Spanish",
    "Swedish",
    "Swahili",
    "Tagalog",
    "Tamil",
    "Telugu",
    "Thai",
    "Turkish",
    "Ukrainian",
    "Urdu",
    "Vietnamese",
    "Welsh"
];
var lengs = [
    "Africaans",
    "Alban\xe9s",
    "Ar\xe1bica",
    "Bielorruso",
    "B\xfalgaro",
    "Bengal\xed",
    "Catal\xe1n",
    "Chino",
    "Croata",
    "Checo",
    "Dan\xe9s",
    "Holand\xe9s",
    "Ingl\xe9s",
    "Esperanto",
    "Estonio",
    "Finland\xe9s",
    "Franc\xe9s",
    "Gallego",
    "Georgiano",
    "Alem\xe1n",
    "Griego",
    "Gujarati",
    "Haitiano",
    "Hebreo",
    "Hindi",
    "H\xfangaro",
    "Island\xe9s",
    "Indonesio",
    "Irland\xe9s",
    "Italiano",
    "Japon\xe9s",
    "Kannada",
    "Coreano",
    "Lituano",
    "Let\xf3n",
    "Macedonio",
    "Marathi",
    "Malayo",
    "Malt\xe9s",
    "Noruego",
    "Persia",
    "Polaco",
    "Portugu\xe9s",
    "Romano",
    "Ruso",
    "Eslovaco",
    "Esloveno",
    "Espa\xf1ol",
    "Sueco",
    "Swahili",
    "Tagalog",
    "Tamil",
    "Telugu",
    "Tailand\xe9s",
    "Turco",
    "Ucraniano",
    "Urdu",
    "Vietnamita",
    "Gal\xe9s"
];
var langCode = [
    "af",
    "sq",
    "ar",
    "be",
    "bg",
    "bn",
    "ca",
    "zh",
    "hr",
    "cs",
    "da",
    "nl",
    "en",
    "eo",
    "et",
    "fi",
    "fr",
    "gl",
    "ka",
    "de",
    "el",
    "gu",
    "ht",
    "he",
    "hi",
    "hu",
    "is",
    "id",
    "ga",
    "it",
    "ja",
    "kn",
    "ko",
    "lt",
    "lv",
    "mk",
    "mr",
    "ms",
    "mt",
    "no",
    "fa",
    "pl",
    "pt",
    "ro",
    "ru",
    "sk",
    "sl",
    "es",
    "sv",
    "sw",
    "tl",
    "ta",
    "te",
    "th",
    "tr",
    "uk",
    "ur",
    "vi",
    "cy"
];
const paisList = [
    "Afganist\xe1n",
    "Albania",
    "Argelia",
    "Samoa Americana",
    "Andorra",
    "Angola",
    "Anguila",
    "Ant\xe1rtida",
    "Antigua y Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaiy\xe1n",
    "Bahamas",
    "Bahr\xe9in",
    "Bangladesh",
    "Barbados",
    "Bielorrusia",
    "B\xe9lgica",
    "Belice",
    "Benin",
    "Islas Bermudas",
    "But\xe1n",
    "Bolivia (Estado Plurinacional de)",
    "Bonaire, Sint Eustatius y Saba",
    "Bosnia y Herzegovina",
    "Botswana",
    "Isla Bouvet",
    "Brasil",
    "Territorio Brit\xe1nico del Oc\xe9ano \xcdndico",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Camboya",
    "Camer\xfan",
    "Canad\xe1",
    "Islas Caim\xe1n",
    "Rep\xfablica Centroafricana",
    "Chad",
    "Chile",
    "Porcelana",
    "Isla de Navidad",
    "Islas Cocos (Keeling)",
    "Colombia",
    "Comoras",
    "Congo (Rep\xfablica Democr\xe1tica del)",
    "Congo",
    "Islas Cook",
    "Costa Rica",
    "Croacia",
    "Cuba",
    "Curazao",
    "Chipre",
    "Chequia",
    "C\xf4te d'Ivoire",
    "Dinamarca",
    "Djibouti",
    "Dominica",
    "Rep\xfablica Dominicana",
    "Ecuador",
    "Egipto",
    "El Salvador",
    "Guinea Ecuatorial",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Etiop\xeda",
    "Islas Falkland [Malvinas]",
    "Islas Faroe",
    "Fiji",
    "Finlandia",
    "Francia",
    "Guayana Francesa",
    "Polinesia franc\xe9s",
    "Territorios Franceses del Sur",
    "Gab\xf3n",
    "Gambia",
    "Georgia",
    "Alemania",
    "Ghana",
    "Gibraltar",
    "Grecia",
    "Groenlandia",
    "Granada",
    "Guadalupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guayana",
    "Hait\xed",
    "Islas Heard y McDonald",
    "Santa Sede",
    "Honduras",
    "Hong Kong",
    "Hungr\xeda",
    "Islandia",
    "India",
    "Indonesia",
    "Ir\xe1n (Rep\xfablica Isl\xe1mica de)",
    "Irak",
    "Irlanda",
    "Isla del hombre",
    "Israel",
    "Italia",
    "Jamaica",
    "Jap\xf3n",
    "Su\xe9ter",
    "Jord\xe1n",
    "Kazajst\xe1n",
    "Kenia",
    "Kiribati",
    "Corea (Rep\xfablica Popular Democr\xe1tica de)",
    "Corea (Rep\xfablica de)",
    "Kuwait",
    "Kirguist\xe1n",
    "Rep\xfablica Democr\xe1tica Popular Lao",
    "Letonia",
    "L\xedbano",
    "Lesoto",
    "Liberia",
    "Libia",
    "Liechtenstein",
    "Lituania",
    "Luxemburgo",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malasia",
    "Maldivas",
    "Mal\xed",
    "Malta",
    "Islas Marshall",
    "Martinica",
    "Mauritania",
    "Mauricio",
    "Mayotte",
    "M\xe9xico",
    "Micronesia (Estados Federados de)",
    "Moldova (la Rep\xfablica de)",
    "M\xf3naco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Marruecos",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Pa\xedses Bajos",
    "Nueva Caledonia",
    "Nueva Zelanda",
    "Nicaragua",
    "N\xedger",
    "Nigeria",
    "Niue",
    "Isla Norfolk",
    "Islas Marianas del Norte",
    "Noruega",
    "Om\xe1n",
    "Pakist\xe1n",
    "Palau",
    "Palestina, Estado de",
    "Panam\xe1",
    "Pap\xfaa Nueva Guinea",
    "Paraguay",
    "Per\xfa",
    "Filipinas",
    "Pitcairn",
    "Polonia",
    "Portugal",
    "Puerto Rico",
    "Katar",
    "Rep\xfablica de Macedonia del Norte",
    "Rumania",
    "Federaci\xf3n Rusa",
    "Ruanda",
    "Cita",
    "San Bartolom\xe9",
    "Santa Elena, Ascensi\xf3n y Tristan da Cunha",
    "Saint Kitts y Nevis",
    "Santa Luc\xeda",
    "San Mart\xedn (parte francesa)",
    "San Pedro y Miquel\xf3n",
    "San Vicente y las Granadinas",
    "Samoa",
    "San Marino",
    "Santo Tom\xe9 y Pr\xedncipe",
    "Arabia Saudita",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leona",
    "Singapur",
    "Sint Maarten (parte holandesa)",
    "Eslovaquia",
    "Eslovenia",
    "Islas Salom\xf3n",
    "Somalia",
    "Sud\xe1frica",
    "Georgia del sur y las islas Sandwich del sur",
    "Sud\xe1n del Sur",
    "Espa\xf1a",
    "Sri Lanka",
    "Sud\xe1n",
    "Surinam",
    "Svalbard y Jan Mayen",
    "Suecia",
    "Suiza",
    "Rep\xfablica \xc1rabe Siria",
    "Taiw\xe1n",
    "Tayikist\xe1n",
    "Rep\xfablica Unida de Tanzan\xeda",
    "Tailandia",
    "Timor-Leste",
    "Ir",
    "Tokelau",
    "Tonga",
    "Trinidad y Tobago",
    "T\xfanez",
    "Pavo",
    "Turkmenist\xe1n",
    "Islas Turcas y Caicos",
    "Tuvalu",
    "Uganda",
    "Ucrania",
    "Emiratos \xc1rabes Unidos",
    "Reino Unido de Gran Breta\xf1a e Irlanda del Norte",
    "Islas menores alejadas de los Estados Unidos",
    "Estados Unidos",
    "Uruguay",
    "Uzbekist\xe1n",
    "Vanuatu",
    "Venezuela (Rep\xfablica Bolivariana de)",
    "Vietnam",
    "Islas V\xedrgenes (Brit\xe1nicas)",
    "Islas V\xedrgenes (EE. UU.)",
    "Wallis y Futuna",
    "Sahara Occidental",
    "Yemen",
    "Zambia",
    "Zimbabue",
    "Islas Aland"
];
const countryList = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia (Plurinational State of)",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo (the Democratic Republic of the)",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cura\xe7ao",
    "Cyprus",
    "Czechia",
    "C\xf4te d'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Falkland Islands [Malvinas]",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Holy See",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran (Islamic Republic of)",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea (the Democratic People's Republic of)",
    "Korea (the Republic of)",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People's Democratic Republic",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia (Federated States of)",
    "Moldova (the Republic of)",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine, State of",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of North Macedonia",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "R\xe9union",
    "Saint Barth\xe9lemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin (French part)",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom of Great Britain and Northern Ireland",
    "United States Minor Outlying Islands",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela (Bolivarian Republic of)",
    "Viet Nam",
    "Virgin Islands (British)",
    "Virgin Islands (U.S.)",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "\xc5land Islands"
];
const countryCodeList = [
    "AF",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BV",
    "BR",
    "IO",
    "BN",
    "BG",
    "BF",
    "BI",
    "CV",
    "KH",
    "CM",
    "CA",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CD",
    "CG",
    "CK",
    "CR",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "CI",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "SZ",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "MK",
    "RO",
    "RU",
    "RW",
    "RE",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "UM",
    "US",
    "UY",
    "UZ",
    "VU",
    "VE",
    "VN",
    "VG",
    "VI",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW",
    "AX"
];
var podClass = {
    email: null,
    pod_email: null,
    title: null,
    lcTitle: null,
    host: null,
    uid: null,
    pid: null,
    desc: null,
    feed: null,
    web: null,
    phone: null,
    lang: null,
    country: null,
    genre: null,
    fb: null,
    tw: null,
    ig: null,
    tk: null,
    yt: null,
    wa: null,
    msgWelcome: null,
    icon: null,
    likes: null,
    date: null,
    revenue: null,
    screenBlock: null,
    verified: null,
    donation: null,
    url: null
};
function initCommonViews() {
    divModal = document.getElementById("myModal");
    modalMessage = document.getElementById("modalMessage");
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
        if (event.target == this.divModal) this.closeMyModal(divModal);
    };
}
function checkDevice() {
    var isAndroid = /(android)/i.test(navigator.userAgent);
    if (isAndroid) setDisplay(downloadApp, "flex");
}
function closeModal(modalId) {
    if (!modalId.style) modalId = document.getElementById(modalId);
    modalId.style.display = "none";
}
function closeMyModal() {
    divModal.style.display = "none";
}
function openCommonModal() {
    //closeNav();
    divModal.style.display = "flex";
}
function setDisplay(element, displayType) {
    if (!element.style) element = document.getElementById(element);
    element.style.display = displayType;
}
function setModalMessage(message) {
    if (message != undefined) modalMessage.innerHTML = message;
}
function showToast(message, elmnt, duration) {
    var x = document.getElementById(elmnt ? elmnt : "snackbar");
    if (x == null) {
        x = document.getElementById("toast");
        if (x == null) return;
    }
    x.textContent = message;
    x.className = "show";
    setTimeout(function() {
        x.className = x.className.replace("show", "");
    }, duration ? duration : 3000);
}
function getAudioTime(millis) {
    let sec1 = Math.floor(millis / 1000);
    let hrs = Math.floor(sec1 / 3600);
    sec1 -= hrs * 3600;
    let min1 = Math.floor(sec1 / 60);
    sec1 -= min1 * 60;
    sec1 = "" + sec1;
    sec1 = ("00" + sec1).substring(sec1.length);
    if (hrs > 0) {
        min1 = "" + min1;
        min1 = ("00" + min1).substring(min1.length);
        return hrs + ":" + min1 + ":" + sec1;
    } else return min1 + ":" + sec1;
}
function getDuration(seconds) {
    sec = Math.floor(seconds);
    min = Math.floor(sec / 60);
    min = min >= 10 ? min : "0" + min; //if min >10 don't add 0 infront
    sec = Math.floor(sec % 60);
    sec = sec >= 10 ? sec : "0" + sec;
    return min + ":" + sec;
}
function sameDay(d1, d2) {
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}
function formatMessageDate(date, lang) {
    var messageDate;
    const today = new Date();
    const oneDay = 86400000;
    const yesterday = today - oneDay;
    var month;
    if (lang != null && lang === "es") month = meses[date.getMonth()];
    else month = months[date.getMonth()];
    var day = date.getDate();
    var year = date.getFullYear();
    if (sameDay(today, new Date(date))) messageDate = "Today";
    else if (date >= yesterday && date < today) messageDate = "Yesterday";
    else messageDate = month + " " + day + ", " + year;
    return messageDate;
}
function formatTime(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? " PM" : " AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + ampm;
}
function formatMilTime(date, end) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? " PM" : " AM";
    if (end && ampm == " AM" && hours == 0) hours = "24";
    else if (hours == 0) hours = "00";
    if (minutes < 10) minutes = "0" + minutes;
    // if (selStartAmPm.value == "am") {
    //     mH = hr == 12? "00":hrs;
    // }
    return hours + ":" + minutes + " " + ampm;
}
function getDayAbbr(index) {
    if (index < 0 || index >= dayAbbr.length) index = 0;
    return dayAbbr[index];
}
function sendVoiceMsg(url, bmRef, chatRef, rMessage, rKey, chatType, userInfo, chatInfo, chatKey, position, groupList, audDuration) {
    var time = new Date().getTime();
    var messageKey = chatRef.push().key;
    var message = {
        userId: userInfo.userId,
        userName: userInfo.name,
        type: "Audio",
        isUploaded: true,
        audioFile: null,
        phoneFilePath: "web",
        filePath: "web",
        receiverName: chatInfo.name,
        message_key: null,
        receiverId: chatKey,
        audioLength: audDuration,
        isReply: false,
        rePosition: null,
        reSenderName: null,
        reSenderId: null,
        reType: null,
        reMessageKey: null,
        reText: null,
        reFileUrl: null,
        reMediaLength: null,
        messageTime: time,
        web: true
    };
    //
    if (rKey) {
        message.isReply = true;
        message.rePosition = position;
        message.reSenderId = rMessage.userId;
        message.reSenderName = rMessage.userName;
        message.reType = rMessage.type;
        message.reMessageKey = rKey;
        switch(rMessage.type){
            case "Text":
            case "SongRequest":
                message.reText = rMessage.textMessage;
                break;
            case "Audio":
                message.reMediaLength = getAudioTime(rMessage.audioLength);
                break;
            case "Picture":
            case "Gif":
                message.reFileUrl = rMessage.filePath;
                break;
            case "TextPicture":
            case "TextGif":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.filePath;
                break;
            case "Video":
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
            case "TextVideo":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
        }
    }
    var bookmark = {
        type: chatType,
        name: chatInfo.name ? chatInfo.name : null,
        id: chatKey,
        imageUrl: null,
        messageType: "Audio",
        unread_messages: 0,
        email: null,
        date: time,
        radioStream: null,
        creatorId: null,
        lowCaseName: null,
        audioDuration: audDuration
    };
    var audioStRef, friendBmRef, friendChatRef, friendBm, groupBmRef, groupChatRef;
    switch(chatType){
        case "RadioChat":
            audioStRef = firebase.storage().ref().child(`Radio Stations/${chatKey}/Audios/${messageKey}`);
            if (chatInfo.radio_Stream) {
                message.receiverName = chatInfo.radio_Name;
                bookmark.radioStream = chatInfo.radio_Stream;
                bookmark.name = chatInfo.radio_Name;
                bookmark.lowCaseName = chatInfo.radio_Name.toLowerCase();
                if (chatInfo.radio_image) bookmark.imageUrl = chatInfo.radio_image;
            } else {
                bookmark.radioStream = chatInfo.radioStream;
                if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            }
            break;
        case "privateChat":
            audioStRef = firebase.storage().ref().child(`Users/${userInfo.userId}/${chatKey}/Audios/${messageKey}`);
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            friendChatRef = firebase.database().ref("PrivateChat/" + chatKey + "/" + userInfo.userId + "/" + messageKey);
            friendBm = {
                type: chatType,
                name: userInfo.name,
                id: userInfo.userId,
                imageUrl: userInfo.profileImage,
                messageType: "Audio",
                unread_messages: 0,
                email: userInfo.email,
                date: time,
                radioStream: null,
                creatorId: null,
                lowCaseName: userInfo.name.toLowerCase(),
                audioDuration: audDuration
            };
            if (chatInfo.profile_Image) bookmark.imageUrl = chatInfo.profile_Image;
            else if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            if (chatInfo.email) bookmark.email = chatInfo.email;
            friendBmRef = firebase.database().ref("Users/" + chatKey + "/Chat_Bookmarks/" + userInfo.userId);
            break;
        case "GroupChat":
            audioStRef = firebase.storage().ref().child(`GroupChats/${chatKey}/Audios/${messageKey}`);
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            bookmark.email = chatInfo.email;
            if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            bookmark.creatorId = chatInfo.creatorId;
            groupChatRef = firebase.database().ref("GroupChats/" + chatKey + "/chat");
            groupBmRef = firebase.database().ref("Users");
            break;
        case "podChat":
            audioStRef = firebase.storage().ref().child(`podcast/${chatKey}/Audios/${messageKey}`);
            bookmark.name = chatInfo.title ? chatInfo.title : chatInfo.name;
            bookmark.lowCaseName = bookmark.name.toLowerCase();
            bookmark.radioStream = chatInfo.feed;
            bookmark.imageUrl = chatInfo.icon;
            break;
    }
    //upload audio
    var uploadTask = audioStRef.put(url);
    uploadTask.on("state_changed", function(snapshot) {}, function(error) {
        switch(error.code){
            case "storage/unauthorized":
                // User doesn't have permission to access the object
                //showToast(trans.errorStoragePermission);
                console.log("storage/unauthorized");
                break;
            case "storage/canceled":
                //showToast(trans.errorUploadCanceled);
                console.log("storage/canceled");
                break;
            case "storage/unknown":
                // Unknown error occurred, inspect error.serverResponse
                //showToast(trans.errorRegister);
                console.log("storage/unknown");
                break;
        }
    //setDisplay(loader, "none");
    //disableButton(btnRegister, false);
    }, function() {
        // Handle successful uploads on complete
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            message.audioFile = downloadURL;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                console.log(`Error sending message: ${error} Try again later.`);
                else //message sent
                bmRef.set(bookmark, function(error) {
                    if (error) console.log(`bmRef could not be set: ${error}`);
                    else {
                        if (friendChatRef != null) friendChatRef.set(message, function(error) {
                            if (error) //message failed
                            console.log("Error sending friend message. Try again later.");
                            else //message sent
                            chatRef.child(messageKey).child("sent").set(true, function(error) {
                                if (error) console.log(`Could not set set to true: ${error}`);
                                else friendBmRef.set(friendBm);
                            });
                        });
                        else if (groupChatRef != null) for (let participant of groupList)groupChatRef.child(participant).child(messageKey).set(message, function(error) {
                            if (error) //request failed
                            console.log(`Error sending message to group. Try again later.`);
                            else //request sent
                            groupBmRef.child(participant).child("Chat_Bookmarks").child(chatKey).set(bookmark);
                        });
                    }
                });
            });
        });
    });
}
function sendTextMessage(input1, bmRef, chatRef, rMessage, rKey, chatType, userInfo, chatInfo, chatKey, position, groupList) {
    var time = new Date().getTime();
    var message;
    var messageKey = chatRef.push().key;
    var bookmark;
    message = {
        textMessage: input1,
        userName: userInfo.name,
        userId: userInfo.userId,
        type: "Text",
        isReply: false,
        rePosition: null,
        reSenderName: null,
        reSenderId: null,
        reType: null,
        reMessageKey: null,
        reText: null,
        reFileUrl: null,
        reMediaLength: null,
        messageTime: time
    };
    if (rKey) {
        message.isReply = true;
        message.rePosition = position;
        message.reSenderId = rMessage.userId;
        message.reSenderName = rMessage.userName;
        message.reType = rMessage.type;
        message.reMessageKey = rKey;
        switch(rMessage.type){
            case "Text":
            case "SongRequest":
                message.reText = rMessage.textMessage;
                break;
            case "Audio":
                message.reMediaLength = getAudioTime(rMessage.audioLength);
                break;
            case "Picture":
            case "Gif":
                message.reFileUrl = rMessage.filePath;
                break;
            case "TextPicture":
            case "TextGif":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.filePath;
                break;
            case "Video":
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
            case "TextVideo":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
        }
    }
    bookmark = {
        type: chatType,
        name: chatInfo.name ? chatInfo.name : null,
        id: chatKey,
        imageUrl: null,
        message: input1,
        messageType: "Text",
        unread_messages: 0,
        lowCaseName: null,
        email: null,
        date: time,
        radioStream: null,
        creatorId: null
    };
    switch(chatType){
        case "RadioChat":
            if (chatInfo.radio_Stream) {
                bookmark.radioStream = chatInfo.radio_Stream;
                bookmark.name = chatInfo.radio_Name;
                bookmark.lowCaseName = chatInfo.radio_Name.toLowerCase();
                if (chatInfo.radio_image) bookmark.imageUrl = chatInfo.radio_image;
            } else {
                bookmark.radioStream = chatInfo.radioStream;
                if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            }
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else //message sent
                bmRef.set(bookmark);
            });
            break;
        case "privateChat":
            // chatRef = firebase.database()
            //     .ref("PrivateChat/" + userInfo.userId +"/" + chatKey + "/" + messageKey);
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            var friendChatRef = firebase.database().ref("PrivateChat/" + chatKey + "/" + userInfo.userId + "/" + messageKey);
            var friendBookmark = {
                type: "privateChat",
                name: userInfo.name,
                id: userInfo.userId,
                imageUrl: userInfo.profileImage,
                message: input1,
                messageType: "Text",
                unread_messages: 0,
                lowCaseName: userInfo.name.toLowerCase(),
                email: userInfo.email,
                date: time,
                radioStream: null,
                creatorId: null
            };
            if (chatInfo.profile_Image) bookmark.imageUrl = chatInfo.profile_Image;
            else if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            if (chatInfo.email) bookmark.email = chatInfo.email;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //request failed
                showToast("Error sending message. Try again later.");
                else {
                    //request sent
                    bmRef.set(bookmark);
                    var friendBmRef = firebase.database().ref("Users/" + chatKey + "/Chat_Bookmarks/" + userInfo.userId);
                    friendChatRef.set(message, function(error) {
                        if (error) //message failed
                        showToast("Error sending friend message. Try again later.");
                        else {
                            //message sent
                            chatRef.child(messageKey).child("sent").set(true);
                            friendBmRef.set(friendBookmark);
                        }
                    });
                //showToast("message sent successfully");
                }
            });
            break;
        case "GroupChat":
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            bookmark.email = chatInfo.email;
            if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            bookmark.creatorId = chatInfo.creatorId;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else {
                    //message sent
                    bmRef.set(bookmark);
                    var groupChatRef = firebase.database().ref("GroupChats/" + chatKey + "/chat");
                    var groupBmRef = firebase.database().ref("Users");
                    for (let participant of groupList)groupChatRef.child(participant).child(messageKey).set(message, function(error) {
                        if (error) //request failed
                        showToast("Error sending message to group. Try again later.");
                        else //request sent
                        groupBmRef.child(participant).child("Chat_Bookmarks").child(chatKey).set(bookmark);
                    });
                //groupChatRef.child()
                //showToast("Petition sent successfully");
                }
            });
            break;
        case "podChat":
            bookmark.name = chatInfo.title ? chatInfo.title : chatInfo.name;
            bookmark.lowCaseName = bookmark.name.toLowerCase();
            bookmark.radioStream = chatInfo.feed ? chatInfo.feed : chatInfo.radioStream;
            bookmark.imageUrl = chatInfo.icon ? chatInfo.icon : chatInfo.imageUrl;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else //message sent
                bmRef.set(bookmark);
            });
            break;
    }
}
function sendGifMessage(input1, bmRef, chatRef, rMessage, rKey, chatType, userInfo, chatInfo, chatKey, file, groupList) {
    var time = new Date().getTime();
    var messageKey = chatRef.push().key;
    var bookmark;
    var message = {
        textMessage: null,
        userName: userInfo.name,
        userId: userInfo.userId,
        type: "Gif",
        isReply: false,
        rePosition: null,
        reSenderName: null,
        reSenderId: null,
        reType: null,
        reMessageKey: null,
        reText: null,
        reFileUrl: null,
        reMediaLength: null,
        messageTime: time,
        filePath: file,
        isUploaded: true,
        receiverName: chatInfo.name,
        receiverId: chatKey
    };
    if (rKey) {
        message.isReply = true;
        //message.rePosition = position;
        message.reSenderId = rMessage.userId;
        message.reSenderName = rMessage.userName;
        message.reType = rMessage.type;
        message.reMessageKey = rKey;
        switch(rMessage.type){
            case "Text":
            case "SongRequest":
                message.reText = rMessage.textMessage;
                break;
            case "Audio":
                message.reMediaLength = getAudioTime(rMessage.audioLength);
                break;
            case "Picture":
            case "Gif":
                message.reFileUrl = rMessage.filePath;
                break;
            case "TextPicture":
            case "TextGif":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.filePath;
                break;
            case "Video":
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
            case "TextVideo":
                message.reText = rMessage.textMessage;
                message.reFileUrl = rMessage.videoThumb;
                message.reMediaLength = rMessage.videoLength;
                break;
        }
    }
    bookmark = {
        type: chatType,
        name: chatInfo.name,
        id: chatKey,
        imageUrl: null,
        message: null,
        messageType: "Gif",
        unread_messages: 0,
        lowCaseName: null,
        email: null,
        date: time,
        radioStream: null,
        creatorId: null
    };
    if (input1) {
        message.textMessage = input1;
        message.type = "TextGif";
        bookmark.message = input1;
        bookmark.messageType = "TextGif";
    }
    switch(chatType){
        case "RadioChat":
            if (chatInfo.radio_Stream) {
                message.receiverName = chatInfo.radio_Name;
                bookmark.radioStream = chatInfo.radio_Stream;
                bookmark.name = chatInfo.radio_Name;
                bookmark.lowCaseName = chatInfo.radio_Name.toLowerCase();
                if (chatInfo.radio_image) bookmark.imageUrl = chatInfo.radio_image;
            } else {
                bookmark.radioStream = chatInfo.radioStream;
                if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            }
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else //message sent
                bmRef.set(bookmark);
            });
            break;
        case "privateChat":
            // chatRef = firebase.database()
            //     .ref("PrivateChat/" + userInfo.userId +"/" + chatKey + "/" + messageKey);
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            var friendChatRef = firebase.database().ref("PrivateChat/" + chatKey + "/" + userInfo.userId + "/" + messageKey);
            var friendBookmark = {
                type: "privateChat",
                name: userInfo.name,
                id: userInfo.userId,
                imageUrl: userInfo.profileImage,
                message: input1,
                messageType: "Text",
                unread_messages: 0,
                lowCaseName: userInfo.name.toLowerCase(),
                email: userInfo.email,
                date: time,
                radioStream: null,
                creatorId: null
            };
            if (chatInfo.profile_Image) bookmark.imageUrl = chatInfo.profile_Image;
            else if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            if (chatInfo.email) bookmark.email = chatInfo.email;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //request failed
                showToast("Error sending message. Try again later.");
                else {
                    //request sent
                    bmRef.set(bookmark);
                    var friendBmRef = firebase.database().ref("Users/" + chatKey + "/Chat_Bookmarks/" + userInfo.userId);
                    friendChatRef.set(message, function(error) {
                        if (error) //message failed
                        showToast("Error sending friend message. Try again later.");
                        else {
                            //message sent
                            chatRef.child(messageKey).child("sent").set(true);
                            friendBmRef.set(friendBookmark);
                        }
                    });
                //showToast("message sent successfully");
                }
            });
            break;
        case "GroupChat":
            bookmark.lowCaseName = chatInfo.name.toLowerCase();
            bookmark.email = chatInfo.email;
            if (chatInfo.imageUrl) bookmark.imageUrl = chatInfo.imageUrl;
            bookmark.creatorId = chatInfo.creatorId;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending petition. Try again later.");
                else {
                    //message sent
                    bmRef.set(bookmark);
                    var groupChatRef = firebase.database().ref("GroupChats/" + chatKey + "/chat");
                    var groupBmRef = firebase.database().ref("Users");
                    for (let participant of groupList)groupChatRef.child(participant).child(messageKey).set(message, function(error) {
                        if (error) //request failed
                        showToast("Error sending message to group. Try again later.");
                        else //request sent
                        groupBmRef.child(participant).child("Chat_Bookmarks").child(chatKey).set(bookmark);
                    });
                //groupChatRef.child()
                //showToast("Petition sent successfully");
                }
            });
            break;
        case "podChat":
            bookmark.name = chatInfo.title ? chatInfo.title : chatInfo.name;
            bookmark.lowCaseName = bookmark.name.toLowerCase();
            bookmark.radioStream = chatInfo.feed;
            bookmark.imageUrl = chatInfo.icon;
            chatRef.child(messageKey).set(message, function(error) {
                if (error) //message failed
                showToast("Error sending message. Try again later.");
                else //message sent
                bmRef.set(bookmark);
            });
            break;
    }
}
function disableButton(btn, disable) {
    if (!btn.style) btn = document.getElementById(btn);
    btn.disabled = disable;
}
function setBackgroundImage(element, image, url) {
    if (!element.style) element = document.getElementById(element);
    if (url) element.style.backgroundImage = "url(" + addSizeToGoogleProfilePic(url) + ")";
    else element.style.backgroundImage = "url('" + image + "')";
}
function addSizeToGoogleProfilePic(url) {
    if (url.indexOf("googleusercontent.com") !== -1 && url.indexOf("?") === -1) return url + "?sz=150";
    return url;
}
function linkify(inputText) {
    if (inputText.includes('name="')) return inputText;
    var replacedText, replacePattern1, replacePattern2, replacePattern3;
    //URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    //Change email addresses to mailto:: links.
    replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
    return replacedText;
}
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function deleteCookie(cname) {
    document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
var appId = "d6b72287542044a9bd74d97db02fdd54";
function dragElement(elmnt) {
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    if (document.getElementById(elmnt.id + "Header")) /* if present, the header is where you move the DIV from:*/ document.getElementById(elmnt.id + "Header").onmousedown = dragMouseDown;
    else /* otherwise, move the DIV from anywhere inside the DIV:*/ elmnt.onmousedown = dragMouseDown;
    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }
    function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        //set element's right position
        //   if(elmnt.style.right != null && elmnt.style.right != "auto"){
        //     var offsetright = window.innerWidth-elmnt.offsetLeft-elmnt.offsetWidth;
        //     elmnt.style.right = (offsetright +pos1) + "px";
        //   }
        // set the element's new position:
        elmnt.style.top = elmnt.offsetTop - pos2 + "px";
        elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
    }
    function closeDragElement() {
        /* stop moving when mouse button is released:*/ document.onmouseup = null;
        document.onmousemove = null;
    //elmnt.style.right = "auto";
    }
}
function saveLocalFile(fileName, urlFile) {
    let a = document.createElement("a");
    a.style = "display: none";
    document.body.appendChild(a);
    a.href = urlFile;
    a.download = fileName;
    a.click();
    //window.URL.revokeObjectURL(url);
    a.remove();
}
function saveFile(fileName, urlFile) {
    (async ()=>{
        //create new a element
        let a = document.createElement("a");
        // get image as blob
        let response = await fetch(urlFile);
        let file = await response.blob();
        // use download attribute https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes
        a.download = fileName;
        a.href = window.URL.createObjectURL(file);
        //store download url in javascript https://developer.mozilla.org/en-US/docs/Learn/HTML/Howto/Use_data_attributes#JavaScript_access
        a.dataset.downloadurl = [
            "application/octet-stream",
            a.download,
            a.href
        ].join(":");
        //click on element to start download
        a.click();
        a.remove();
    })();
}
function copyText(el, id) {
    var r = document.createRange();
    r.selectNode(el ? el : document.getElementById(id));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
}
function copyInput(el) {
    if (el != null) {
        // Select the text field
        el.select();
        el.setSelectionRange(0, 99999); // For mobile devices
        // Copy the text inside the text field
        navigator.clipboard.writeText(el.value);
    // Alert the copied text
    }
}
const gphClose = (0, _gph5GifDefault.default);
const gphGif = (0, _gph1GifDefault.default);
function getGenre(lang, index) {
    var genre;
    if (lang == null) lang = "en";
    if (lang === "en") genre = genres[index];
    else if (lang === "es") genre = generos[index];
    return genre;
}
function getGenreIndex(lang, genre) {
    if (lang == null) lang = "en";
    if (lang === "en") return genres.indexOf(genre);
    else if (lang === "es") return generos.indexOf(genre);
}
function getGenreList(lang) {
    if (lang == null) lang = "en";
    if (lang === "en") return genres;
    else if (lang === "es") return generos;
}
function getLangList(lang) {
    if (lang == null) lang = "en";
    if (lang === "en") return langs;
    else if (lang === "es") return lengs;
}
function getLangCode(index) {
    return langCode[index];
}
function getLangIndex(code) {
    return langCode.indexOf(code);
}
function getLangName(lang, index) {
    var name;
    if (lang == null) lang = "en";
    if (lang === "en") name = langs[index];
    else if (lang === "es") name = lengs[index];
    return name;
}
function getCountryList(lang) {
    if (lang == null) lang = "en";
    if (lang === "en") return countryList;
    else if (lang === "es") return paisList;
}
function getCountryCode(index) {
    return countryCodeList[index];
}
function getCountryIndex(code) {
    return countryCodeList.indexOf(code);
}
function getCountryName(lang, index) {
    var name;
    if (lang == null) lang = "en";
    if (lang === "en") name = countryList[index];
    else if (lang === "es") name = paisList[index];
    return name;
}
function reformatPaste() {
    $("[contenteditable]").on("paste", function(e) {
        e.preventDefault();
        var text = "";
        if (e.clipboardData || e.originalEvent.clipboardData) text = (e.originalEvent || e).clipboardData.getData("text/plain");
        else if (window.clipboardData) text = window.clipboardData.getData("Text");
        if (document.queryCommandSupported("insertText")) document.execCommand("insertText", false, text);
        else document.execCommand("paste", false, text);
    });
}
function getRandomNum(n) {
    var add = 1, max = 12 - add;
    if (n > max) return generate(max) + generate(n - max);
    max = Math.pow(10, n + add);
    var min1 = max / 10; // Math.pow(10, n) basically
    var number = Math.floor(Math.random() * (max - min1 + 1)) + min1;
    return ("" + number).substring(add);
}
function getPodClass() {
    return podClass;
}
function validateEmail(input1) {
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return reg.test(input1);
}
function validateURL(input1) {
    let reg = /((?:(?:http?|ftp)[s]*:\/\/)?[a-z0-9-%\/\&=?\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?)/gi;
    ///^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
    return reg.test(input1);
}
function validateLettersNums() {
    let reg = /^([a-zA-Z0-9 ]+)$/;
    return reg.test(input);
}
function removeTags(str) {
    if (str === null || str === "") return;
    else str = str.toString();
    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, "");
}
function parseDuration(duration) {
    let remain = duration;
    let days = Math.floor(remain / 86400000);
    remain = remain % 86400000;
    let hours = Math.floor(remain / 3600000);
    remain = remain % 3600000;
    let minutes = Math.floor(remain / 60000);
    remain = remain % 60000;
    let seconds = Math.floor(remain / 1000);
    remain = remain % 1000;
    let milliseconds = remain;
    return {
        days,
        hours,
        minutes,
        seconds,
        milliseconds
    };
}
function formatTimeHMS(o) {
    let hours = o.hours.toString();
    if (hours == "0") hours = "";
    else if (hours.length === 1) hours = "0" + hours + ":";
    else hours = hours + ":";
    let minutes = o.minutes.toString();
    if (minutes.length === 1) minutes = "0" + minutes;
    let seconds = o.seconds.toString();
    if (seconds.length === 1) seconds = "0" + seconds;
    return hours + minutes + ":" + seconds;
}
function formatDurationHMS(duration) {
    let time = parseDuration(duration);
    return formatTimeHMS(time);
}
const DATABASE_IN_APP_PRODUCTS = "https://chat-murcianys-18752.firebaseio.com/";
function scrollRight(parent, btnR, btnL, display, amount) {
    if (parent == null || btnR == null || btnL == null) return;
    parent.scrollLeft += amount ? amount : 100;
    var isEnd = parent.scrollLeft >= parent.scrollWidth - parent.offsetWidth;
    //var isStart = parent.scrollLeft == 0 ? true : false;
    if (isEnd) setDisplay(btnR, "none");
    setDisplay(btnL, display ? display : "block");
}
function scrollLeft(parent, btnR, btnL, display, amount) {
    if (parent == null || btnR == null || btnL == null) return;
    parent.scrollLeft -= amount ? amount : 100;
    //var isEnd = parent.scrollLeft >= parent.scrollWidth - parent.offsetWidth;
    var isStart = parent.scrollLeft == 0 ? true : false;
    if (isStart) setDisplay(btnL, "none");
    setDisplay(btnR, display ? display : "block");
}
function scrollTop(parent, btnT, btnB, display, amount) {
    if (parent == null || btnT == null || btnB == null) return;
    parent.scrollTop -= amount ? amount : 100;
    //var isBottom = parent.scrollTop >= parent.scrollHeight - parent.offsetHeight;
    var isTop = parent.scrollTop == 0 ? true : false;
    if (isTop) setDisplay(btnT, "none");
    setDisplay(btnB, display ? display : "block");
}
function scrollBtm(parent, btnT, btnB, display, amount) {
    if (parent == null || btnT == null || btnB == null) return;
    parent.scrollTop += amount ? amount : 100;
    var isBottom = parent.scrollTop >= parent.scrollHeight - parent.offsetHeight;
    //var isTop = parent.scrollTop == 0 ? true : false;
    if (isBottom) setDisplay(btnB, "none");
    setDisplay(btnT, display ? display : "block");
}
const GroupType = {
    group: "GROUP",
    radio: "RADIO",
    podcast: "PODCAST"
};
initCommonViews();

},{"url:../images/gph5.gif":"3fNVt","url:../images/gph1.gif":"9KSPX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3fNVt":[function(require,module,exports) {
module.exports = require("d2bad45a69f44226").getBundleURL("lNAe2") + require("60cffd6a0337735e").resolve("c1XkK");

},{"d2bad45a69f44226":"c7Tr5","60cffd6a0337735e":"fyJL2"}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"9KSPX":[function(require,module,exports) {
module.exports = require("37e2017e0d456b1a").getBundleURL("lNAe2") + require("f6a1a2b9bbd9e5c7").resolve("7aZnT");

},{"37e2017e0d456b1a":"c7Tr5","f6a1a2b9bbd9e5c7":"fyJL2"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"fCJPK":[function(require,module,exports) {
module.exports = require("aeede23869b3b9a6").getBundleURL("lNAe2") + require("184ac31cd3c4f353").resolve("3ee5T");

},{"aeede23869b3b9a6":"c7Tr5","184ac31cd3c4f353":"fyJL2"}],"5VoOu":[function(require,module,exports) {
module.exports = require("7486e34f66782c31").getBundleURL("lNAe2") + require("5b0456de16380044").resolve("ci5we");

},{"7486e34f66782c31":"c7Tr5","5b0456de16380044":"fyJL2"}],"853cL":[function(require,module,exports) {
module.exports = require("9d216e1398d9fbfe").getBundleURL("lNAe2") + require("407ff6d15e00b90d").resolve("kFewo");

},{"9d216e1398d9fbfe":"c7Tr5","407ff6d15e00b90d":"fyJL2"}],"6azT2":[function(require,module,exports) {
module.exports = require("9b6b21fbff501d75").getBundleURL("lNAe2") + require("8d56807fd7ec99af").resolve("lI8wn");

},{"9b6b21fbff501d75":"c7Tr5","8d56807fd7ec99af":"fyJL2"}],"5UIr4":[function(require,module,exports) {
module.exports = require("b71829e73aa47175").getBundleURL("lNAe2") + require("8a3c9202f315de35").resolve("Gr5RI");

},{"b71829e73aa47175":"c7Tr5","8a3c9202f315de35":"fyJL2"}],"cl3hM":[function(require,module,exports) {
// function initConfig() {
//   // Firebase configuration
//   var firebaseConfig = {
//     apiKey: "AIzaSyCss8833TpaKYlIrRsC_VkrxKQC-Uuf_nI",
//     authDomain: "chat-murcianys.firebaseapp.com",
//     databaseURL: "https://chat-murcianys.firebaseio.com",
//     projectId: "chat-murcianys",
//     storageBucket: "chat-murcianys.appspot.com",
//     messagingSenderId: "484066067543",
//     appId: "1:484066067543:web:b12e176ab6ad132a0e8f12",
//   };
//   // Initialize Firebase
//   firebase.initializeApp(firebaseConfig);
// }
// initConfig();
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prodApp", ()=>prodApp);
parcelHelpers.export(exports, "defAppRef", ()=>defAppRef);
parcelHelpers.export(exports, "purchaseApp", ()=>purchaseApp);
parcelHelpers.export(exports, "vapidKey", ()=>vapidKey);
const DATABASE_IN_APP_PRODUCTS = "https://chat-murcianys-18752.firebaseio.com/";
const DATABASE_IN_APP_PURCHASES = "https://chat-murcianys-efb7f.firebaseio.com/";
const DEFAULT_DATABASE = {
    apiKey: "AIzaSyCss8833TpaKYlIrRsC_VkrxKQC-Uuf_nI",
    authDomain: "chat-murcianys.firebaseapp.com",
    databaseURL: "https://chat-murcianys.firebaseio.com",
    projectId: "chat-murcianys",
    storageBucket: "chat-murcianys.appspot.com",
    messagingSenderId: "484066067543",
    appId: "1:484066067543:web:b12e176ab6ad132a0e8f12"
};
var productApp;
var defApp;
var purApp;
function initConfig() {
    // Initialize Firebase
    defApp = firebase.initializeApp(DEFAULT_DATABASE);
    productApp = defApp.database(DATABASE_IN_APP_PRODUCTS);
    purApp = defApp.database(DATABASE_IN_APP_PURCHASES);
}
initConfig();
const prodApp = productApp;
const defAppRef = defApp;
const purchaseApp = purApp;
const vapidKey = "BDbMU_3OpCR3PBhal6ZBlAR4SeKUC6m0rDLCgWh8YERs2XiQXUXSV1T2h3AG2wKbMAopHxv-UTkIsMqlmrgL1v0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Je4pI":[function(require,module,exports) {
require("35258b1a6f6b7d49");
const fetch = require("1a6120ffdf7027e0");
const parseString = require("1f186362d83bc70a").parseString;
const ERRORS = exports.ERRORS = {
    "requiredError": new Error("One or more required values are missing from feed."),
    "optionsError": new Error("Invalid options.")
};
/*
============================================
=== CONSTANTS ===
============================================
*/ const NS = rssFeedNamespaces = {
    itunesAuthor: "itunes:author",
    itunesBlock: "itunes:block",
    itunesCategory: "itunes:category",
    itunesComplete: "itunes:complete",
    itunesDuration: "itunes:duration",
    itunesEmail: "itunes:email",
    itunesExplicit: "itunes:explicit",
    itunesImage: "itunes:image",
    itunesKeywords: "itunes:keywords",
    itunesName: "itunes:name",
    itunesOrder: "itunes:order",
    itunesOwner: "itunes:owner",
    itunesSubtitle: "itunes:subtitle",
    itunesSummary: "itunes:summary",
    itunesType: "itunes:type",
    podcastChapters: "podcast:chapters",
    podcastFunding: "podcast:funding",
    podcastLocked: "podcast:locked",
    podcastSoundbite: "podcast:soundbite",
    podcastTranscript: "podcast:transcript",
    podcastValue: "podcast:value",
    podcastValueRecipient: "podcast:valueRecipient"
};
/*
============================================
=== DEFAULT OPTIONS and OPTIONS BUILDING ===
============================================
*/ const fieldsMeta = [
    "author",
    "blocked",
    "categories",
    "complete",
    "description",
    "docs",
    "editor",
    "explicit",
    "funding",
    "generator",
    "guid",
    "imageURL",
    "keywords",
    "language",
    "lastBuildDate",
    "link",
    "locked",
    "pubDate",
    "owner",
    "subtitle",
    "summary",
    "title",
    "type",
    "value",
    "webMaster"
];
const fieldsEpisodes = [
    "author",
    "blocked",
    "chapters",
    "description",
    "duration",
    "enclosure",
    "explicit",
    "funding",
    "guid",
    "imageURL",
    "keywords",
    "language",
    "link",
    "order",
    "pubDate",
    "soundbite",
    "subtitle",
    "summary",
    "title",
    "transcript",
    "value"
];
const requiredMeta = [];
const requiredEpisodes = [];
const uncleanedMeta = [
    "categories",
    "funding",
    "guid",
    "value"
];
const uncleanedEpisodes = [
    "funding",
    "guid",
    "soundbite",
    "transcript",
    "value"
];
const DEFAULT = exports.DEFAULT = {
    fields: {
        meta: fieldsMeta,
        episodes: fieldsEpisodes
    },
    required: {
        meta: requiredMeta,
        episodes: requiredEpisodes
    },
    uncleaned: {
        meta: uncleanedMeta,
        episodes: uncleanedEpisodes
    }
};
// from https://stackoverflow.com/questions/1584370/how-to-merge-two-arrays-in-javascript-and-de-duplicate-items
function mergeDedupe(arr) {
    return [
        ...new Set([].concat(...arr))
    ];
}
const buildOptions = exports.buildOptions = function(params) {
    try {
        let options = {
            fields: {
                meta: fieldsMeta,
                episodes: fieldsEpisodes
            },
            required: {
                meta: requiredMeta,
                episodes: requiredEpisodes
            },
            uncleaned: {
                meta: uncleanedMeta,
                episodes: uncleanedEpisodes
            }
        };
        // if no options parameters given, use default
        if (typeof params === "undefined") {
            options = DEFAULT;
            return options;
        }
        // merge empty options and given options
        Object.keys(options).forEach((key)=>{
            if (params[key] !== undefined) Object.assign(options[key], params[key]);
        });
        // if 'default' given in parameters, merge default options with given custom options
        //  and dedupe
        if (options.fields.meta.indexOf("default") >= 0) {
            options.fields.meta = mergeDedupe([
                DEFAULT.fields.meta,
                params.fields.meta
            ]);
            options.fields.meta.splice(options.fields.meta.indexOf("default"), 1);
        }
        if (options.fields.episodes.indexOf("default") >= 0) {
            options.fields.episodes = mergeDedupe([
                DEFAULT.fields.episodes,
                params.fields.episodes
            ]);
            options.fields.episodes.splice(options.fields.episodes.indexOf("default"), 1);
        }
        return options;
    } catch (err) {
        throw ERRORS.optionsError;
    }
};
/*
=====================
=== GET FUNCTIONS ===
=====================
*/ const GET = exports.GET = {
    author: function(node) {
        if (node.author) return node.author;
        else if (node[NS.itunesAuthor]) return node[NS.itunesAuthor];
    },
    blocked: function(node) {
        return node[NS.itunesBlock];
    },
    categories: function(node) {
        // returns categories as an array containing each category/sub-category
        // grouping in lists. If there is a sub-category, it is the second element
        // of an array.
        const itunesCategories = node["itunes:category"];
        if (Array.isArray(itunesCategories)) {
            const categoriesArray = itunesCategories.map((item)=>{
                let category = "";
                if (item && item["$"] && item["$"].text) {
                    category += item["$"].text // primary category
                    ;
                    if (item[NS.itunesCategory]) category += ">" + item[NS.itunesCategory][0]["$"].text;
                }
                return category;
            });
            return categoriesArray;
        }
        return [];
    },
    chapters: function(node) {
        const items = getItemsWithAttrs(node[NS.podcastChapters]);
        if (items && items[0]) return {
            type: items[0].attrs.type,
            url: items[0].attrs.url
        };
    },
    complete: function(node) {
        return node[NS.itunesComplete];
    },
    duration: function(node) {
        return node[NS.itunesDuration];
    },
    editor: function(node) {
        return node.managingEditor;
    },
    explicit: function(node) {
        return node[NS.itunesExplicit];
    },
    funding: function(node) {
        const items = getItemsWithAttrs(node[NS.podcastFunding]);
        const finalItems = [];
        for (const item of items)finalItems.push({
            value: item.value,
            url: item.attrs.url
        });
        return finalItems;
    },
    guid: function(node) {
        if (node.guid) {
            if (typeof node.guid === "string") return node.guid;
            else if (Array.isArray(node.guid) && node.guid[0] && node.guid[0]._) return node.guid[0]._;
        }
    },
    imageURL: function(node) {
        if (node["itunes:image"] && node["itunes:image"][0] && node["itunes:image"][0]["$"] && node["itunes:image"][0]["$"].href) return node["itunes:image"][0]["$"].href;
        if (typeof node["itunes:image"] === "string") return node["itunes:image"];
        if (node.image && node.image[0] && node.image[0].url[0]) return node.image[0].url[0];
        return undefined;
    },
    /*
    NOTE: This is part of the Podcast Index namespace spec.
    This is a Phase 2 namespace and has not been formalized at this time.
    https://github.com/Podcastindex-org/podcast-namespace/tree/7c9516937e74b8058d7d49e2b389c7c361cc6a48

    ---

    images: function (node) {
      const item = getItemsWithAttrs(node['podcast:images'])
      if (item[0]) {
        const srcset = item.attrs.srcset
        const srcSetArray = convertCommaDelimitedStringToArray(srcset)
        const parsedSrcSet = []
        for (let str of srcSetArray) {
          str = str.trim()
          const srcSetAttrs = str.split(' ')
          if (srcSetAttrs.length === 2) {
            parsedSrcSet.push({
              url: srcSetAttrs[0],
              width: srcSetAttrs[1]
            })
          }
        }

        return {
          srcset: parsedSrcSet
        }
      }
    },
  */ keywords: function(node) {
        return node[NS.itunesKeywords];
    },
    /*
    NOTE: This is part of the Podcast Index namespace spec.
    This is a Phase 2 namespace and has not been formalized at this time.
    https://github.com/Podcastindex-org/podcast-namespace/tree/7c9516937e74b8058d7d49e2b389c7c361cc6a48

    ---

    location: function (node) {
      const item = getItemsWithAttrs(node['podcast:location'])
      if (item) {
        return {
          value: item.value,
          latlon: item.attrs.latlon,
          osmid: item.attrs.osmid
        }
      }
    },
  */ locked: function(node) {
        const items = getItemsWithAttrs(node[NS.podcastLocked]);
        if (items[0]) return {
            value: items[0].value,
            owner: items[0].attrs.owner
        };
    },
    order: function(node) {
        return node[NS.itunesOrder];
    },
    owner: function(node) {
        return node[NS.itunesOwner];
    },
    soundbite: function(node) {
        const items = getItemsWithAttrs(node[NS.podcastSoundbite]);
        const finalItems = [];
        for (const item of items){
            const duration = parseFloat(item.attrs.duration);
            const startTime = parseFloat(item.attrs.startTime);
            if (!duration) continue;
            if (!startTime && startTime !== 0) continue;
            finalItems.push({
                duration,
                startTime,
                title: item.value
            });
        }
        return finalItems;
    },
    subtitle: function(node) {
        return node[NS.itunesSubtitle];
    },
    summary: function(node) {
        return node[NS.itunesSummary];
    },
    transcript: function(node) {
        const items = getItemsWithAttrs(node[NS.podcastTranscript]);
        const finalItems = [];
        if (Array.isArray(items)) for (const item of items){
            const { language, rel, type, url } = item.attrs;
            finalItems.push({
                language,
                rel,
                type,
                url
            });
        }
        return finalItems;
    },
    type: function(node) {
        return node[NS.itunesType];
    },
    /*
    NOTE: This is part of the Podcast Index namespace spec.
    https://github.com/Podcastindex-org/podcast-namespace/tree/7c9516937e74b8058d7d49e2b389c7c361cc6a48
  */ value: function(node) {
        const valueItems = getItemsWithAttrs(node[NS.podcastValue], [
            NS.podcastValueRecipient
        ]);
        let finalValues = null;
        if (valueItems && valueItems.length > 0) {
            finalValues = [];
            for (const valueItem of valueItems){
                const { method, suggested, type } = valueItem.attrs;
                let finalValue = {
                    method,
                    suggested,
                    type
                };
                const valueRecipientItems = valueItem.nestedTags && valueItem.nestedTags[NS.podcastValueRecipient];
                if (Array.isArray(valueRecipientItems)) {
                    const finalRecipients = [];
                    for (const valueRecipientItem of valueRecipientItems){
                        const { address, customKey, customValue, fee, name, split, type } = valueRecipientItem.attrs;
                        finalRecipients.push({
                            address,
                            customKey,
                            customValue,
                            fee,
                            name,
                            split,
                            type
                        });
                    }
                    finalValue.recipients = finalRecipients;
                    finalValues.push(finalValue);
                }
            }
        }
        return finalValues;
    }
};
const getDefault = exports.getDefault = function(node, field) {
    return node[field] ? node[field] : undefined;
};
/*
=======================
=== CLEAN FUNCTIONS ===
=======================
*/ const CLEAN = exports.CLEAN = {
    author: function(obj) {
        return obj;
    },
    blocked: function(string) {
        if (string.toLowerCase == "yes") return true;
        else return false;
    },
    complete: function(string) {
        if (string[0].toLowerCase == "yes") return true;
        else return false;
    },
    duration: function(arr) {
        // gives duration in seconds
        let times = arr[0].split(":"), sum = 0, mul = 1;
        while(times.length > 0){
            sum += mul * parseInt(times.pop());
            mul *= 60;
        }
        return sum;
    },
    enclosure: function(object) {
        return {
            length: object[0]["$"].length,
            type: object[0]["$"].type,
            url: object[0]["$"].url
        };
    },
    explicit: function(string) {
        if ([
            "yes",
            "explicit",
            "true"
        ].indexOf(string[0].toLowerCase()) >= 0) return true;
        else if ([
            "clean",
            "no",
            "false"
        ].indexOf(string[0].toLowerCase()) >= 0) return false;
        else return undefined;
    },
    imageURL: function(string) {
        return string;
    },
    owner: function(object) {
        let ownerObject = {};
        if (object[0].hasOwnProperty(NS.itunesName)) ownerObject.name = object[0][NS.itunesName][0];
        if (object[0].hasOwnProperty(NS.itunesEmail)) ownerObject.email = object[0][NS.itunesEmail][0];
        return ownerObject;
    }
};
const cleanDefault = exports.cleanDefault = function(node) {
    // return first item of array
    if (node !== undefined && Array.isArray(node) && node[0] !== undefined) return node[0];
    else return node;
};
/*
=================================
=== OBJECT CREATION FUNCTIONS ===
=================================
*/ const getInfo = exports.getInfo = function(node, field, uncleaned) {
    // gets relevant info from podcast feed using options:
    // @field - string - the desired field name, corresponding with GET and clean
    //     functions
    // @uncleaned - boolean - if field should not be cleaned before returning
    var info;
    // if field has a GET function, use that
    // if not, get default value
    info = GET[field] ? GET[field].call(this, node) : getDefault(node, field);
    // if field is not marked as uncleaned, clean it using CLEAN functions
    if (!uncleaned && info !== undefined) info = CLEAN[field] ? CLEAN[field].call(this, info) : cleanDefault(info);
    return info;
};
function createMetaObjectFromFeed(channel, options) {
    const meta = {};
    if (Array.isArray(options.fields.meta)) options.fields.meta.forEach((field)=>{
        const obj = {};
        var uncleaned = false;
        if (options.uncleaned && Array.isArray(options.uncleaned.meta)) var uncleaned = options.uncleaned.meta.indexOf(field) >= 0;
        obj[field] = getInfo(channel, field, uncleaned);
        Object.assign(meta, obj);
    });
    if (options.required && Array.isArray(options.required.meta)) options.required.meta.forEach((field)=>{
        if (Object.keys(meta).indexOf(field) < 0) throw ERRORS.requiredError;
    });
    return meta;
}
// function builds episode objects from parsed podcast feed
function createEpisodesObjectFromFeed(channel, options) {
    let episodes = [];
    if (channel && Array.isArray(channel.item)) channel.item.forEach((item)=>{
        const episode = {};
        if (options.fields && Array.isArray(options.fields.episodes)) options.fields.episodes.forEach((field)=>{
            const obj = {};
            var uncleaned = false;
            if (options.uncleaned && Array.isArray(options.uncleaned.episodes)) var uncleaned = options.uncleaned.episodes.indexOf(field) >= 0;
            obj[field] = getInfo(item, field, uncleaned);
            Object.assign(episode, obj);
        });
        if (options.required && Array.isArray(options.required.episodes)) options.required.episodes.forEach((field)=>{
            if (Object.keys(episode).indexOf(field) < 0) throw ERRORS.requiredError;
        });
        episodes.push(episode);
    });
    episodes.sort(function(a, b) {
        // sorts by order first, if defined, then sorts by date.
        // if multiple episodes were published at the same time,
        // they are then sorted by title
        if (a.order == b.order) {
            if (a.pubDate == b.pubDate) return a.title > b.title ? -1 : 1;
            return b.pubDate > a.pubDate ? 1 : -1;
        }
        if (a.order && !b.order) return 1;
        if (b.order && !a.order) return -1;
        return a.order > b.order ? -1 : 1;
    });
    return episodes;
}
/*
======================
=== FEED FUNCTIONS ===
======================
*/ function promiseParseXMLFeed(feedText) {
    return new Promise((resolve, reject)=>{
        parseString(feedText, (error, result)=>{
            if (error) reject(error);
            resolve(result);
        });
    });
}
function parseXMLFeed(feedText) {
    let feed = {};
    parseString(feedText, (error, result)=>{
        if (error) throw error;
        Object.assign(feed, result);
        return result;
    });
    return feed;
}
async function fetchFeed(requestParams) {
    try {
        const { headers, timeout = 20000 } = requestParams;
        const abortController = new AbortController();
        const signal = abortController.signal;
        setTimeout(()=>{
            abortController.abort();
        }, timeout);
        const feedResponse = await fetch(requestParams.url, {
            headers,
            signal
        });
        if (feedResponse.status === 401) throw new Error(401);
        const feedText = await feedResponse.text();
        const feedObject = await promiseParseXMLFeed(feedText);
        return feedObject;
    } catch (err) {
        throw err;
    }
}
/*
=======================
=== FINAL FUNCTIONS ===
=======================
*/ const getPodcastFromURL = exports.getPodcastFromURL = async function(requestParams, buildParams) {
    try {
        const options = buildOptions(buildParams);
        const feedResponse = await fetchFeed(requestParams);
        const channel = feedResponse.rss.channel[0];
        const meta = createMetaObjectFromFeed(channel, options);
        const episodes = createEpisodesObjectFromFeed(channel, options);
        return {
            meta,
            episodes
        };
    } catch (err) {
        throw err;
    }
};
const getPodcastFromFeed = exports.getPodcastFromFeed = function(feed, params) {
    try {
        const options = buildOptions(params);
        const feedObject = parseXMLFeed(feed);
        const channel = feedObject.rss.channel[0];
        const meta = createMetaObjectFromFeed(channel, options);
        const episodes = createEpisodesObjectFromFeed(channel, options);
        return {
            meta,
            episodes
        };
    } catch (err) {
        throw err;
    }
};
/*
=======================
=== HELPER FUNCTIONS ===
=======================
*/ const getItemsWithAttrs = (val, nestedTags = [])=>{
    if (Array.isArray(val)) {
        const items = [];
        for (const item of val){
            if (typeof item === "string") items.push({
                value: item,
                attrs: {}
            });
            else if (item) {
                const finalTags = {};
                if (nestedTags && nestedTags.length > 0) for (const nestedTag of nestedTags){
                    const nestedItem = getItemsWithAttrs(item[nestedTag]);
                    finalTags[nestedTag] = nestedItem;
                }
                items.push({
                    value: item._,
                    attrs: item["$"] ? item["$"] : {},
                    ...Object.keys(finalTags).length > 0 ? {
                        nestedTags: finalTags
                    } : {}
                });
            }
        }
        return items;
    }
    return [];
};
const convertCommaDelimitedStringToArray = (str)=>{
    str = str.replace(/(\r\n|\n|\r)/gm, "");
    str = str.split(",");
    return str;
};

},{"35258b1a6f6b7d49":"6GoGc","1a6120ffdf7027e0":"38hYd","1f186362d83bc70a":"lpLwC"}],"6GoGc":[function(require,module,exports) {
/*globals require, self, window */ var global = arguments[3];
"use strict";
const ac = require("252921b68921d371");
/*eslint-disable @mysticatea/prettier */ const g = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : /* otherwise */ undefined;
/*eslint-enable @mysticatea/prettier */ if (g) {
    if (typeof g.AbortController === "undefined") g.AbortController = ac.AbortController;
    if (typeof g.AbortSignal === "undefined") g.AbortSignal = ac.AbortSignal;
}

},{"252921b68921d371":"1FEj6"}],"1FEj6":[function(require,module,exports) {
/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 * See LICENSE file in root directory for full license.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var eventTargetShim = require("413fe29969f1a805");
/**
 * The signal class.
 * @see https://dom.spec.whatwg.org/#abortsignal
 */ class AbortSignal extends eventTargetShim.EventTarget {
    /**
     * AbortSignal cannot be constructed directly.
     */ constructor(){
        super();
        throw new TypeError("AbortSignal cannot be constructed directly");
    }
    /**
     * Returns `true` if this `AbortSignal`'s `AbortController` has signaled to abort, and `false` otherwise.
     */ get aborted() {
        const aborted = abortedFlags.get(this);
        if (typeof aborted !== "boolean") throw new TypeError(`Expected 'this' to be an 'AbortSignal' object, but got ${this === null ? "null" : typeof this}`);
        return aborted;
    }
}
eventTargetShim.defineEventAttribute(AbortSignal.prototype, "abort");
/**
 * Create an AbortSignal object.
 */ function createAbortSignal() {
    const signal = Object.create(AbortSignal.prototype);
    eventTargetShim.EventTarget.call(signal);
    abortedFlags.set(signal, false);
    return signal;
}
/**
 * Abort a given signal.
 */ function abortSignal(signal) {
    if (abortedFlags.get(signal) !== false) return;
    abortedFlags.set(signal, true);
    signal.dispatchEvent({
        type: "abort"
    });
}
/**
 * Aborted flag for each instances.
 */ const abortedFlags = new WeakMap();
// Properties should be enumerable.
Object.defineProperties(AbortSignal.prototype, {
    aborted: {
        enumerable: true
    }
});
// `toString()` should return `"[object AbortSignal]"`
if (typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol") Object.defineProperty(AbortSignal.prototype, Symbol.toStringTag, {
    configurable: true,
    value: "AbortSignal"
});
/**
 * The AbortController.
 * @see https://dom.spec.whatwg.org/#abortcontroller
 */ class AbortController {
    /**
     * Initialize this controller.
     */ constructor(){
        signals.set(this, createAbortSignal());
    }
    /**
     * Returns the `AbortSignal` object associated with this object.
     */ get signal() {
        return getSignal(this);
    }
    /**
     * Abort and signal to any observers that the associated activity is to be aborted.
     */ abort() {
        abortSignal(getSignal(this));
    }
}
/**
 * Associated signals.
 */ const signals = new WeakMap();
/**
 * Get the associated signal of a given controller.
 */ function getSignal(controller) {
    const signal = signals.get(controller);
    if (signal == null) throw new TypeError(`Expected 'this' to be an 'AbortController' object, but got ${controller === null ? "null" : typeof controller}`);
    return signal;
}
// Properties should be enumerable.
Object.defineProperties(AbortController.prototype, {
    signal: {
        enumerable: true
    },
    abort: {
        enumerable: true
    }
});
if (typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol") Object.defineProperty(AbortController.prototype, Symbol.toStringTag, {
    configurable: true,
    value: "AbortController"
});
exports.AbortController = AbortController;
exports.AbortSignal = AbortSignal;
exports.default = AbortController;
module.exports = AbortController;
module.exports.AbortController = module.exports["default"] = AbortController;
module.exports.AbortSignal = AbortSignal;

},{"413fe29969f1a805":"dX9lh"}],"dX9lh":[function(require,module,exports) {
/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 * @copyright 2015 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @typedef {object} PrivateData
 * @property {EventTarget} eventTarget The event target.
 * @property {{type:string}} event The original event object.
 * @property {number} eventPhase The current event phase.
 * @property {EventTarget|null} currentTarget The current event target.
 * @property {boolean} canceled The flag to prevent default.
 * @property {boolean} stopped The flag to stop propagation.
 * @property {boolean} immediateStopped The flag to stop propagation immediately.
 * @property {Function|null} passiveListener The listener if the current listener is passive. Otherwise this is null.
 * @property {number} timeStamp The unix time.
 * @private
 */ /**
 * Private data for event wrappers.
 * @type {WeakMap<Event, PrivateData>}
 * @private
 */ const privateData = new WeakMap();
/**
 * Cache for wrapper classes.
 * @type {WeakMap<Object, Function>}
 * @private
 */ const wrappers = new WeakMap();
/**
 * Get private data.
 * @param {Event} event The event object to get private data.
 * @returns {PrivateData} The private data of the event.
 * @private
 */ function pd(event) {
    const retv = privateData.get(event);
    console.assert(retv != null, "'this' is expected an Event object, but got", event);
    return retv;
}
/**
 * https://dom.spec.whatwg.org/#set-the-canceled-flag
 * @param data {PrivateData} private data.
 */ function setCancelFlag(data) {
    if (data.passiveListener != null) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error("Unable to preventDefault inside passive event listener invocation.", data.passiveListener);
        return;
    }
    if (!data.event.cancelable) return;
    data.canceled = true;
    if (typeof data.event.preventDefault === "function") data.event.preventDefault();
}
/**
 * @see https://dom.spec.whatwg.org/#interface-event
 * @private
 */ /**
 * The event wrapper.
 * @constructor
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Event|{type:string}} event The original event to wrap.
 */ function Event(eventTarget, event) {
    privateData.set(this, {
        eventTarget,
        event,
        eventPhase: 2,
        currentTarget: eventTarget,
        canceled: false,
        stopped: false,
        immediateStopped: false,
        passiveListener: null,
        timeStamp: event.timeStamp || Date.now()
    });
    // https://heycam.github.io/webidl/#Unforgeable
    Object.defineProperty(this, "isTrusted", {
        value: false,
        enumerable: true
    });
    // Define accessors
    const keys = Object.keys(event);
    for(let i = 0; i < keys.length; ++i){
        const key = keys[i];
        if (!(key in this)) Object.defineProperty(this, key, defineRedirectDescriptor(key));
    }
}
// Should be enumerable, but class methods are not enumerable.
Event.prototype = {
    /**
     * The type of this event.
     * @type {string}
     */ get type () {
        return pd(this).event.type;
    },
    /**
     * The target of this event.
     * @type {EventTarget}
     */ get target () {
        return pd(this).eventTarget;
    },
    /**
     * The target of this event.
     * @type {EventTarget}
     */ get currentTarget () {
        return pd(this).currentTarget;
    },
    /**
     * @returns {EventTarget[]} The composed path of this event.
     */ composedPath () {
        const currentTarget = pd(this).currentTarget;
        if (currentTarget == null) return [];
        return [
            currentTarget
        ];
    },
    /**
     * Constant of NONE.
     * @type {number}
     */ get NONE () {
        return 0;
    },
    /**
     * Constant of CAPTURING_PHASE.
     * @type {number}
     */ get CAPTURING_PHASE () {
        return 1;
    },
    /**
     * Constant of AT_TARGET.
     * @type {number}
     */ get AT_TARGET () {
        return 2;
    },
    /**
     * Constant of BUBBLING_PHASE.
     * @type {number}
     */ get BUBBLING_PHASE () {
        return 3;
    },
    /**
     * The target of this event.
     * @type {number}
     */ get eventPhase () {
        return pd(this).eventPhase;
    },
    /**
     * Stop event bubbling.
     * @returns {void}
     */ stopPropagation () {
        const data = pd(this);
        data.stopped = true;
        if (typeof data.event.stopPropagation === "function") data.event.stopPropagation();
    },
    /**
     * Stop event bubbling.
     * @returns {void}
     */ stopImmediatePropagation () {
        const data = pd(this);
        data.stopped = true;
        data.immediateStopped = true;
        if (typeof data.event.stopImmediatePropagation === "function") data.event.stopImmediatePropagation();
    },
    /**
     * The flag to be bubbling.
     * @type {boolean}
     */ get bubbles () {
        return Boolean(pd(this).event.bubbles);
    },
    /**
     * The flag to be cancelable.
     * @type {boolean}
     */ get cancelable () {
        return Boolean(pd(this).event.cancelable);
    },
    /**
     * Cancel this event.
     * @returns {void}
     */ preventDefault () {
        setCancelFlag(pd(this));
    },
    /**
     * The flag to indicate cancellation state.
     * @type {boolean}
     */ get defaultPrevented () {
        return pd(this).canceled;
    },
    /**
     * The flag to be composed.
     * @type {boolean}
     */ get composed () {
        return Boolean(pd(this).event.composed);
    },
    /**
     * The unix time of this event.
     * @type {number}
     */ get timeStamp () {
        return pd(this).timeStamp;
    },
    /**
     * The target of this event.
     * @type {EventTarget}
     * @deprecated
     */ get srcElement () {
        return pd(this).eventTarget;
    },
    /**
     * The flag to stop event bubbling.
     * @type {boolean}
     * @deprecated
     */ get cancelBubble () {
        return pd(this).stopped;
    },
    set cancelBubble (value){
        if (!value) return;
        const data = pd(this);
        data.stopped = true;
        if (typeof data.event.cancelBubble === "boolean") data.event.cancelBubble = true;
    },
    /**
     * The flag to indicate cancellation state.
     * @type {boolean}
     * @deprecated
     */ get returnValue () {
        return !pd(this).canceled;
    },
    set returnValue (value){
        if (!value) setCancelFlag(pd(this));
    },
    /**
     * Initialize this event object. But do nothing under event dispatching.
     * @param {string} type The event type.
     * @param {boolean} [bubbles=false] The flag to be possible to bubble up.
     * @param {boolean} [cancelable=false] The flag to be possible to cancel.
     * @deprecated
     */ initEvent () {
    // Do nothing.
    }
};
// `constructor` is not enumerable.
Object.defineProperty(Event.prototype, "constructor", {
    value: Event,
    configurable: true,
    writable: true
});
// Ensure `event instanceof window.Event` is `true`.
if (typeof window !== "undefined" && typeof window.Event !== "undefined") {
    Object.setPrototypeOf(Event.prototype, window.Event.prototype);
    // Make association for wrappers.
    wrappers.set(window.Event.prototype, Event);
}
/**
 * Get the property descriptor to redirect a given property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to redirect the property.
 * @private
 */ function defineRedirectDescriptor(key) {
    return {
        get () {
            return pd(this).event[key];
        },
        set (value1) {
            pd(this).event[key] = value1;
        },
        configurable: true,
        enumerable: true
    };
}
/**
 * Get the property descriptor to call a given method property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to call the method property.
 * @private
 */ function defineCallDescriptor(key) {
    return {
        value () {
            const event = pd(this).event;
            return event[key].apply(event, arguments);
        },
        configurable: true,
        enumerable: true
    };
}
/**
 * Define new wrapper class.
 * @param {Function} BaseEvent The base wrapper class.
 * @param {Object} proto The prototype of the original event.
 * @returns {Function} The defined wrapper class.
 * @private
 */ function defineWrapper(BaseEvent, proto) {
    const keys = Object.keys(proto);
    if (keys.length === 0) return BaseEvent;
    /** CustomEvent */ function CustomEvent(eventTarget, event) {
        BaseEvent.call(this, eventTarget, event);
    }
    CustomEvent.prototype = Object.create(BaseEvent.prototype, {
        constructor: {
            value: CustomEvent,
            configurable: true,
            writable: true
        }
    });
    // Define accessors.
    for(let i = 0; i < keys.length; ++i){
        const key = keys[i];
        if (!(key in BaseEvent.prototype)) {
            const descriptor = Object.getOwnPropertyDescriptor(proto, key);
            const isFunc = typeof descriptor.value === "function";
            Object.defineProperty(CustomEvent.prototype, key, isFunc ? defineCallDescriptor(key) : defineRedirectDescriptor(key));
        }
    }
    return CustomEvent;
}
/**
 * Get the wrapper class of a given prototype.
 * @param {Object} proto The prototype of the original event to get its wrapper.
 * @returns {Function} The wrapper class.
 * @private
 */ function getWrapper(proto) {
    if (proto == null || proto === Object.prototype) return Event;
    let wrapper = wrappers.get(proto);
    if (wrapper == null) {
        wrapper = defineWrapper(getWrapper(Object.getPrototypeOf(proto)), proto);
        wrappers.set(proto, wrapper);
    }
    return wrapper;
}
/**
 * Wrap a given event to management a dispatching.
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Object} event The event to wrap.
 * @returns {Event} The wrapper instance.
 * @private
 */ function wrapEvent(eventTarget, event) {
    const Wrapper = getWrapper(Object.getPrototypeOf(event));
    return new Wrapper(eventTarget, event);
}
/**
 * Get the immediateStopped flag of a given event.
 * @param {Event} event The event to get.
 * @returns {boolean} The flag to stop propagation immediately.
 * @private
 */ function isStopped(event) {
    return pd(event).immediateStopped;
}
/**
 * Set the current event phase of a given event.
 * @param {Event} event The event to set current target.
 * @param {number} eventPhase New event phase.
 * @returns {void}
 * @private
 */ function setEventPhase(event, eventPhase) {
    pd(event).eventPhase = eventPhase;
}
/**
 * Set the current target of a given event.
 * @param {Event} event The event to set current target.
 * @param {EventTarget|null} currentTarget New current target.
 * @returns {void}
 * @private
 */ function setCurrentTarget(event, currentTarget) {
    pd(event).currentTarget = currentTarget;
}
/**
 * Set a passive listener of a given event.
 * @param {Event} event The event to set current target.
 * @param {Function|null} passiveListener New passive listener.
 * @returns {void}
 * @private
 */ function setPassiveListener(event, passiveListener) {
    pd(event).passiveListener = passiveListener;
}
/**
 * @typedef {object} ListenerNode
 * @property {Function} listener
 * @property {1|2|3} listenerType
 * @property {boolean} passive
 * @property {boolean} once
 * @property {ListenerNode|null} next
 * @private
 */ /**
 * @type {WeakMap<object, Map<string, ListenerNode>>}
 * @private
 */ const listenersMap = new WeakMap();
// Listener types
const CAPTURE = 1;
const BUBBLE = 2;
const ATTRIBUTE = 3;
/**
 * Check whether a given value is an object or not.
 * @param {any} x The value to check.
 * @returns {boolean} `true` if the value is an object.
 */ function isObject(x) {
    return x !== null && typeof x === "object" //eslint-disable-line no-restricted-syntax
    ;
}
/**
 * Get listeners.
 * @param {EventTarget} eventTarget The event target to get.
 * @returns {Map<string, ListenerNode>} The listeners.
 * @private
 */ function getListeners(eventTarget) {
    const listeners = listenersMap.get(eventTarget);
    if (listeners == null) throw new TypeError("'this' is expected an EventTarget object, but got another value.");
    return listeners;
}
/**
 * Get the property descriptor for the event attribute of a given event.
 * @param {string} eventName The event name to get property descriptor.
 * @returns {PropertyDescriptor} The property descriptor.
 * @private
 */ function defineEventAttributeDescriptor(eventName) {
    return {
        get () {
            const listeners = getListeners(this);
            let node = listeners.get(eventName);
            while(node != null){
                if (node.listenerType === ATTRIBUTE) return node.listener;
                node = node.next;
            }
            return null;
        },
        set (listener) {
            if (typeof listener !== "function" && !isObject(listener)) listener = null; // eslint-disable-line no-param-reassign
            const listeners = getListeners(this);
            // Traverse to the tail while removing old value.
            let prev = null;
            let node = listeners.get(eventName);
            while(node != null){
                if (node.listenerType === ATTRIBUTE) {
                    // Remove old value.
                    if (prev !== null) prev.next = node.next;
                    else if (node.next !== null) listeners.set(eventName, node.next);
                    else listeners.delete(eventName);
                } else prev = node;
                node = node.next;
            }
            // Add new value.
            if (listener !== null) {
                const newNode = {
                    listener,
                    listenerType: ATTRIBUTE,
                    passive: false,
                    once: false,
                    next: null
                };
                if (prev === null) listeners.set(eventName, newNode);
                else prev.next = newNode;
            }
        },
        configurable: true,
        enumerable: true
    };
}
/**
 * Define an event attribute (e.g. `eventTarget.onclick`).
 * @param {Object} eventTargetPrototype The event target prototype to define an event attrbite.
 * @param {string} eventName The event name to define.
 * @returns {void}
 */ function defineEventAttribute(eventTargetPrototype, eventName) {
    Object.defineProperty(eventTargetPrototype, `on${eventName}`, defineEventAttributeDescriptor(eventName));
}
/**
 * Define a custom EventTarget with event attributes.
 * @param {string[]} eventNames Event names for event attributes.
 * @returns {EventTarget} The custom EventTarget.
 * @private
 */ function defineCustomEventTarget(eventNames) {
    /** CustomEventTarget */ function CustomEventTarget() {
        EventTarget.call(this);
    }
    CustomEventTarget.prototype = Object.create(EventTarget.prototype, {
        constructor: {
            value: CustomEventTarget,
            configurable: true,
            writable: true
        }
    });
    for(let i = 0; i < eventNames.length; ++i)defineEventAttribute(CustomEventTarget.prototype, eventNames[i]);
    return CustomEventTarget;
}
/**
 * EventTarget.
 *
 * - This is constructor if no arguments.
 * - This is a function which returns a CustomEventTarget constructor if there are arguments.
 *
 * For example:
 *
 *     class A extends EventTarget {}
 *     class B extends EventTarget("message") {}
 *     class C extends EventTarget("message", "error") {}
 *     class D extends EventTarget(["message", "error"]) {}
 */ function EventTarget() {
    /*eslint-disable consistent-return */ if (this instanceof EventTarget) {
        listenersMap.set(this, new Map());
        return;
    }
    if (arguments.length === 1 && Array.isArray(arguments[0])) return defineCustomEventTarget(arguments[0]);
    if (arguments.length > 0) {
        const types = new Array(arguments.length);
        for(let i = 0; i < arguments.length; ++i)types[i] = arguments[i];
        return defineCustomEventTarget(types);
    }
    throw new TypeError("Cannot call a class as a function");
/*eslint-enable consistent-return */ }
// Should be enumerable, but class methods are not enumerable.
EventTarget.prototype = {
    /**
     * Add a given listener to this event target.
     * @param {string} eventName The event name to add.
     * @param {Function} listener The listener to add.
     * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
     * @returns {void}
     */ addEventListener (eventName, listener, options) {
        if (listener == null) return;
        if (typeof listener !== "function" && !isObject(listener)) throw new TypeError("'listener' should be a function or an object.");
        const listeners = getListeners(this);
        const optionsIsObj = isObject(options);
        const capture = optionsIsObj ? Boolean(options.capture) : Boolean(options);
        const listenerType = capture ? CAPTURE : BUBBLE;
        const newNode = {
            listener,
            listenerType,
            passive: optionsIsObj && Boolean(options.passive),
            once: optionsIsObj && Boolean(options.once),
            next: null
        };
        // Set it as the first node if the first node is null.
        let node = listeners.get(eventName);
        if (node === undefined) {
            listeners.set(eventName, newNode);
            return;
        }
        // Traverse to the tail while checking duplication..
        let prev = null;
        while(node != null){
            if (node.listener === listener && node.listenerType === listenerType) // Should ignore duplication.
            return;
            prev = node;
            node = node.next;
        }
        // Add it.
        prev.next = newNode;
    },
    /**
     * Remove a given listener from this event target.
     * @param {string} eventName The event name to remove.
     * @param {Function} listener The listener to remove.
     * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
     * @returns {void}
     */ removeEventListener (eventName, listener, options) {
        if (listener == null) return;
        const listeners = getListeners(this);
        const capture = isObject(options) ? Boolean(options.capture) : Boolean(options);
        const listenerType = capture ? CAPTURE : BUBBLE;
        let prev = null;
        let node = listeners.get(eventName);
        while(node != null){
            if (node.listener === listener && node.listenerType === listenerType) {
                if (prev !== null) prev.next = node.next;
                else if (node.next !== null) listeners.set(eventName, node.next);
                else listeners.delete(eventName);
                return;
            }
            prev = node;
            node = node.next;
        }
    },
    /**
     * Dispatch a given event.
     * @param {Event|{type:string}} event The event to dispatch.
     * @returns {boolean} `false` if canceled.
     */ dispatchEvent (event) {
        if (event == null || typeof event.type !== "string") throw new TypeError('"event.type" should be a string.');
        // If listeners aren't registered, terminate.
        const listeners = getListeners(this);
        const eventName = event.type;
        let node = listeners.get(eventName);
        if (node == null) return true;
        // Since we cannot rewrite several properties, so wrap object.
        const wrappedEvent = wrapEvent(this, event);
        // This doesn't process capturing phase and bubbling phase.
        // This isn't participating in a tree.
        let prev = null;
        while(node != null){
            // Remove this listener if it's once
            if (node.once) {
                if (prev !== null) prev.next = node.next;
                else if (node.next !== null) listeners.set(eventName, node.next);
                else listeners.delete(eventName);
            } else prev = node;
            // Call this listener
            setPassiveListener(wrappedEvent, node.passive ? node.listener : null);
            if (typeof node.listener === "function") try {
                node.listener.call(this, wrappedEvent);
            } catch (err) {
                if (typeof console !== "undefined" && typeof console.error === "function") console.error(err);
            }
            else if (node.listenerType !== ATTRIBUTE && typeof node.listener.handleEvent === "function") node.listener.handleEvent(wrappedEvent);
            // Break if `event.stopImmediatePropagation` was called.
            if (isStopped(wrappedEvent)) break;
            node = node.next;
        }
        setPassiveListener(wrappedEvent, null);
        setEventPhase(wrappedEvent, 0);
        setCurrentTarget(wrappedEvent, null);
        return !wrappedEvent.defaultPrevented;
    }
};
// `constructor` is not enumerable.
Object.defineProperty(EventTarget.prototype, "constructor", {
    value: EventTarget,
    configurable: true,
    writable: true
});
// Ensure `eventTarget instanceof window.EventTarget` is `true`.
if (typeof window !== "undefined" && typeof window.EventTarget !== "undefined") Object.setPrototypeOf(EventTarget.prototype, window.EventTarget.prototype);
exports.defineEventAttribute = defineEventAttribute;
exports.EventTarget = EventTarget;
exports.default = EventTarget;
module.exports = EventTarget;
module.exports.EventTarget = module.exports["default"] = EventTarget;
module.exports.defineEventAttribute = defineEventAttribute;

},{}],"38hYd":[function(require,module,exports) {
// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
require("9c74275609015ba7");
module.exports = self.fetch.bind(self);

},{"9c74275609015ba7":"3NSiq"}],"3NSiq":[function(require,module,exports) {
/* eslint-disable no-prototype-builtins */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Headers", ()=>Headers);
parcelHelpers.export(exports, "Request", ()=>Request);
parcelHelpers.export(exports, "Response", ()=>Response);
parcelHelpers.export(exports, "DOMException", ()=>DOMException);
parcelHelpers.export(exports, "fetch", ()=>fetch);
var global = arguments[3];
var g = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
typeof global !== "undefined" && global || {};
var support = {
    searchParams: "URLSearchParams" in g,
    iterable: "Symbol" in g && "iterator" in Symbol,
    blob: "FileReader" in g && "Blob" in g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: "FormData" in g,
    arrayBuffer: "ArrayBuffer" in g
};
function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if (support.arrayBuffer) {
    var viewClasses = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ];
    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function normalizeName(name) {
    if (typeof name !== "string") name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function normalizeValue(value) {
    if (typeof value !== "string") value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if (support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function Headers(headers) {
    this.map = {};
    if (headers instanceof Headers) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ", " + value : value;
};
Headers.prototype["delete"] = function(name) {
    delete this.map[normalizeName(name)];
};
Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name));
};
Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
};
Headers.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return iteratorFor(items);
};
Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return iteratorFor(items);
};
Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return iteratorFor(items);
};
if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
function consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
    body.bodyUsed = true;
}
function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : "utf-8";
    reader.readAsText(blob, encoding);
    return promise;
}
function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join("");
}
function bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = "";
        } else if (typeof body === "string") this._bodyText = body;
        else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get("content-type")) {
            if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
            else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
    };
    if (support.blob) this.blob = function() {
        var rejected = consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
        else throw new Error("could not read as ArrayBuffer");
    };
    this.text = function() {
        var rejected = consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error("could not read FormData body as text");
        else return Promise.resolve(this._bodyText);
    };
    if (support.formData) this.formData = function() {
        return this.text().then(decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var methods = [
    "CONNECT",
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "PATCH",
    "POST",
    "PUT",
    "TRACE"
];
function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
}
function Request(input, options) {
    if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof Request) {
        if (input.bodyUsed) throw new TypeError("Already read");
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new Headers(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) this.headers = new Headers(options.headers);
    this.method = normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ("AbortController" in g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
    this._initBody(body);
    if (this.method === "GET" || this.method === "HEAD") {
        if (options.cache === "no-store" || options.cache === "no-cache") {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
            }
        }
    }
}
Request.prototype.clone = function() {
    return new Request(this, {
        body: this._bodyInit
    });
};
function decode(body) {
    var form = new FormData();
    body.trim().split("&").forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split("\r").map(function(header) {
        return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(":");
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(":").trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn("Response " + error.message);
            }
        }
    });
    return headers;
}
Body.call(Request.prototype);
function Response(bodyInit, options) {
    if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = "default";
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
}
Body.call(Response.prototype);
Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new Headers(this.headers),
        url: this.url
    });
};
Response.error = function() {
    var response = new Response(null, {
        status: 200,
        statusText: ""
    });
    response.status = 0;
    response.type = "error";
    return response;
};
var redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
    return new Response(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var DOMException = g.DOMException;
try {
    new DOMException();
} catch (err) {
    DOMException = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    DOMException.prototype = Object.create(Error.prototype);
    DOMException.prototype.constructor = DOMException;
}
function fetch(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new Request(input, init);
        if (request.signal && request.signal.aborted) return reject(new DOMException("Aborted", "AbortError"));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new Response(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new DOMException("Aborted", "AbortError"));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === "" && g.location.href ? g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === "include") xhr.withCredentials = true;
        else if (request.credentials === "omit") xhr.withCredentials = false;
        if ("responseType" in xhr) {
            if (support.blob) xhr.responseType = "blob";
            else if (support.arrayBuffer) xhr.responseType = "arraybuffer";
        }
        if (init && typeof init.headers === "object" && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push(normalizeName(name));
                xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
    });
}
fetch.polyfill = true;
if (!g.fetch) {
    g.fetch = fetch;
    g.Headers = Headers;
    g.Request = Request;
    g.Response = Response;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpLwC":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    var builder, defaults, parser, processors, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    defaults = require("7ea326df427f014c");
    builder = require("115692d66e5bd90b");
    parser = require("259cca7c8022cb30");
    processors = require("4d88504c3e73ae8e");
    exports.defaults = defaults.defaults;
    exports.processors = processors;
    exports.ValidationError = function(superClass) {
        extend(ValidationError, superClass);
        function ValidationError(message) {
            this.message = message;
        }
        return ValidationError;
    }(Error);
    exports.Builder = builder.Builder;
    exports.Parser = parser.Parser;
    exports.parseString = parser.parseString;
    exports.parseStringPromise = parser.parseStringPromise;
}).call(this);

},{"7ea326df427f014c":"1TO0H","115692d66e5bd90b":"8O56t","259cca7c8022cb30":"PM6AC","4d88504c3e73ae8e":"4IawY"}],"1TO0H":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    exports.defaults = {
        "0.1": {
            explicitCharkey: false,
            trim: true,
            normalize: true,
            normalizeTags: false,
            attrkey: "@",
            charkey: "#",
            explicitArray: false,
            ignoreAttrs: false,
            mergeAttrs: false,
            explicitRoot: false,
            validator: null,
            xmlns: false,
            explicitChildren: false,
            childkey: "@@",
            charsAsChildren: false,
            includeWhiteChars: false,
            async: false,
            strict: true,
            attrNameProcessors: null,
            attrValueProcessors: null,
            tagNameProcessors: null,
            valueProcessors: null,
            emptyTag: ""
        },
        "0.2": {
            explicitCharkey: false,
            trim: false,
            normalize: false,
            normalizeTags: false,
            attrkey: "$",
            charkey: "_",
            explicitArray: true,
            ignoreAttrs: false,
            mergeAttrs: false,
            explicitRoot: true,
            validator: null,
            xmlns: false,
            explicitChildren: false,
            preserveChildrenOrder: false,
            childkey: "$$",
            charsAsChildren: false,
            includeWhiteChars: false,
            async: false,
            strict: true,
            attrNameProcessors: null,
            attrValueProcessors: null,
            tagNameProcessors: null,
            valueProcessors: null,
            rootName: "root",
            xmldec: {
                "version": "1.0",
                "encoding": "UTF-8",
                "standalone": true
            },
            doctype: null,
            renderOpts: {
                "pretty": true,
                "indent": "  ",
                "newline": "\n"
            },
            headless: false,
            chunkSize: 10000,
            emptyTag: "",
            cdata: false
        }
    };
}).call(this);

},{}],"8O56t":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    var builder, defaults, escapeCDATA, requiresCDATA, wrapCDATA, hasProp = {}.hasOwnProperty;
    builder = require("ad623f14adf9b5ff");
    defaults = require("1257d11f8d203f5b").defaults;
    requiresCDATA = function(entry) {
        return typeof entry === "string" && (entry.indexOf("&") >= 0 || entry.indexOf(">") >= 0 || entry.indexOf("<") >= 0);
    };
    wrapCDATA = function(entry) {
        return "<![CDATA[" + escapeCDATA(entry) + "]]>";
    };
    escapeCDATA = function(entry) {
        return entry.replace("]]>", "]]]]><![CDATA[>");
    };
    exports.Builder = function() {
        function Builder(opts) {
            var key, ref, value;
            this.options = {};
            ref = defaults["0.2"];
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this.options[key] = value;
            }
            for(key in opts){
                if (!hasProp.call(opts, key)) continue;
                value = opts[key];
                this.options[key] = value;
            }
        }
        Builder.prototype.buildObject = function(rootObj) {
            var attrkey, charkey, render, rootElement, rootName;
            attrkey = this.options.attrkey;
            charkey = this.options.charkey;
            if (Object.keys(rootObj).length === 1 && this.options.rootName === defaults["0.2"].rootName) {
                rootName = Object.keys(rootObj)[0];
                rootObj = rootObj[rootName];
            } else rootName = this.options.rootName;
            render = function(_this) {
                return function(element, obj) {
                    var attr, child, entry, index, key, value;
                    if (typeof obj !== "object") {
                        if (_this.options.cdata && requiresCDATA(obj)) element.raw(wrapCDATA(obj));
                        else element.txt(obj);
                    } else if (Array.isArray(obj)) for(index in obj){
                        if (!hasProp.call(obj, index)) continue;
                        child = obj[index];
                        for(key in child){
                            entry = child[key];
                            element = render(element.ele(key), entry).up();
                        }
                    }
                    else for(key in obj){
                        if (!hasProp.call(obj, key)) continue;
                        child = obj[key];
                        if (key === attrkey) {
                            if (typeof child === "object") for(attr in child){
                                value = child[attr];
                                element = element.att(attr, value);
                            }
                        } else if (key === charkey) {
                            if (_this.options.cdata && requiresCDATA(child)) element = element.raw(wrapCDATA(child));
                            else element = element.txt(child);
                        } else if (Array.isArray(child)) for(index in child){
                            if (!hasProp.call(child, index)) continue;
                            entry = child[index];
                            if (typeof entry === "string") {
                                if (_this.options.cdata && requiresCDATA(entry)) element = element.ele(key).raw(wrapCDATA(entry)).up();
                                else element = element.ele(key, entry).up();
                            } else element = render(element.ele(key), entry).up();
                        }
                        else if (typeof child === "object") element = render(element.ele(key), child).up();
                        else if (typeof child === "string" && _this.options.cdata && requiresCDATA(child)) element = element.ele(key).raw(wrapCDATA(child)).up();
                        else {
                            if (child == null) child = "";
                            element = element.ele(key, child.toString()).up();
                        }
                    }
                    return element;
                };
            }(this);
            rootElement = builder.create(rootName, this.options.xmldec, this.options.doctype, {
                headless: this.options.headless,
                allowSurrogateChars: this.options.allowSurrogateChars
            });
            return render(rootElement, rootObj).end(this.options.renderOpts);
        };
        return Builder;
    }();
}).call(this);

},{"ad623f14adf9b5ff":"9eg6y","1257d11f8d203f5b":"1TO0H"}],"9eg6y":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, WriterState, XMLDOMImplementation, XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;
    ref = require("2647794ec6919cf8"), assign = ref.assign, isFunction = ref.isFunction;
    XMLDOMImplementation = require("204f3257bd042cb8");
    XMLDocument = require("1984b650bfe70c70");
    XMLDocumentCB = require("9dbd1ebdb6a95fc3");
    XMLStringWriter = require("69100afb0dfc47f2");
    XMLStreamWriter = require("fd0f26d6534ce99d");
    NodeType = require("fcf823ff2587a9f2");
    WriterState = require("bba57db33f4cadd6");
    module.exports.create = function(name, xmldec, doctype, options) {
        var doc, root;
        if (name == null) throw new Error("Root element needs a name.");
        options = assign({}, xmldec, doctype, options);
        doc = new XMLDocument(options);
        root = doc.element(name);
        if (!options.headless) {
            doc.declaration(options);
            if (options.pubID != null || options.sysID != null) doc.dtd(options);
        }
        return root;
    };
    module.exports.begin = function(options, onData, onEnd) {
        var ref1;
        if (isFunction(options)) {
            ref1 = [
                options,
                onData
            ], onData = ref1[0], onEnd = ref1[1];
            options = {};
        }
        if (onData) return new XMLDocumentCB(options, onData, onEnd);
        else return new XMLDocument(options);
    };
    module.exports.stringWriter = function(options) {
        return new XMLStringWriter(options);
    };
    module.exports.streamWriter = function(stream, options) {
        return new XMLStreamWriter(stream, options);
    };
    module.exports.implementation = new XMLDOMImplementation();
    module.exports.nodeType = NodeType;
    module.exports.writerState = WriterState;
}).call(this);

},{"2647794ec6919cf8":"1HtuW","204f3257bd042cb8":"338kW","1984b650bfe70c70":"c9FJh","9dbd1ebdb6a95fc3":"asgnZ","69100afb0dfc47f2":"7x53O","fd0f26d6534ce99d":"a6RUH","fcf823ff2587a9f2":"jdzc3","bba57db33f4cadd6":"6PvqX"}],"1HtuW":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var assign, getValue, isArray, isEmpty, isFunction, isObject, isPlainObject, slice = [].slice, hasProp = {}.hasOwnProperty;
    assign = function() {
        var i, key, len, source, sources, target;
        target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
        if (isFunction(Object.assign)) Object.assign.apply(null, arguments);
        else for(i = 0, len = sources.length; i < len; i++){
            source = sources[i];
            if (source != null) for(key in source){
                if (!hasProp.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    };
    isFunction = function(val) {
        return !!val && Object.prototype.toString.call(val) === "[object Function]";
    };
    isObject = function(val) {
        var ref;
        return !!val && ((ref = typeof val) === "function" || ref === "object");
    };
    isArray = function(val) {
        if (isFunction(Array.isArray)) return Array.isArray(val);
        else return Object.prototype.toString.call(val) === "[object Array]";
    };
    isEmpty = function(val) {
        var key;
        if (isArray(val)) return !val.length;
        else {
            for(key in val){
                if (!hasProp.call(val, key)) continue;
                return false;
            }
            return true;
        }
    };
    isPlainObject = function(val) {
        var ctor, proto;
        return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && typeof ctor === "function" && ctor instanceof ctor && Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object);
    };
    getValue = function(obj) {
        if (isFunction(obj.valueOf)) return obj.valueOf();
        else return obj;
    };
    module.exports.assign = assign;
    module.exports.isFunction = isFunction;
    module.exports.isObject = isObject;
    module.exports.isArray = isArray;
    module.exports.isEmpty = isEmpty;
    module.exports.isPlainObject = isPlainObject;
    module.exports.getValue = getValue;
}).call(this);

},{}],"338kW":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDOMImplementation;
    module.exports = XMLDOMImplementation = function() {
        function XMLDOMImplementation() {}
        XMLDOMImplementation.prototype.hasFeature = function(feature, version) {
            return true;
        };
        XMLDOMImplementation.prototype.createDocumentType = function(qualifiedName, publicId, systemId) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLDOMImplementation.prototype.createDocument = function(namespaceURI, qualifiedName, doctype) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLDOMImplementation.prototype.createHTMLDocument = function(title) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLDOMImplementation.prototype.getFeature = function(feature, version) {
            throw new Error("This DOM method is not implemented.");
        };
        return XMLDOMImplementation;
    }();
}).call(this);

},{}],"c9FJh":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDOMConfiguration, XMLDOMImplementation, XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isPlainObject = require("13a5a3baabce41d8").isPlainObject;
    XMLDOMImplementation = require("b6961c96ff36d753");
    XMLDOMConfiguration = require("1f23d28cae8a60a5");
    XMLNode = require("cd39268a029bdce2");
    NodeType = require("ee7140c760116731");
    XMLStringifier = require("f050dc0a62284d96");
    XMLStringWriter = require("1c368e88d7130ef6");
    module.exports = XMLDocument = function(superClass) {
        extend(XMLDocument, superClass);
        function XMLDocument(options) {
            XMLDocument.__super__.constructor.call(this, null);
            this.name = "#document";
            this.type = NodeType.Document;
            this.documentURI = null;
            this.domConfig = new XMLDOMConfiguration();
            options || (options = {});
            if (!options.writer) options.writer = new XMLStringWriter();
            this.options = options;
            this.stringify = new XMLStringifier(options);
        }
        Object.defineProperty(XMLDocument.prototype, "implementation", {
            value: new XMLDOMImplementation()
        });
        Object.defineProperty(XMLDocument.prototype, "doctype", {
            get: function() {
                var child, i, len, ref;
                ref = this.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.DocType) return child;
                }
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "documentElement", {
            get: function() {
                return this.rootObject || null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "inputEncoding", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "strictErrorChecking", {
            get: function() {
                return false;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "xmlEncoding", {
            get: function() {
                if (this.children.length !== 0 && this.children[0].type === NodeType.Declaration) return this.children[0].encoding;
                else return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "xmlStandalone", {
            get: function() {
                if (this.children.length !== 0 && this.children[0].type === NodeType.Declaration) return this.children[0].standalone === "yes";
                else return false;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "xmlVersion", {
            get: function() {
                if (this.children.length !== 0 && this.children[0].type === NodeType.Declaration) return this.children[0].version;
                else return "1.0";
            }
        });
        Object.defineProperty(XMLDocument.prototype, "URL", {
            get: function() {
                return this.documentURI;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "origin", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "compatMode", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "characterSet", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "contentType", {
            get: function() {
                return null;
            }
        });
        XMLDocument.prototype.end = function(writer) {
            var writerOptions;
            writerOptions = {};
            if (!writer) writer = this.options.writer;
            else if (isPlainObject(writer)) {
                writerOptions = writer;
                writer = this.options.writer;
            }
            return writer.document(this, writer.filterOptions(writerOptions));
        };
        XMLDocument.prototype.toString = function(options) {
            return this.options.writer.document(this, this.options.writer.filterOptions(options));
        };
        XMLDocument.prototype.createElement = function(tagName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createDocumentFragment = function() {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createTextNode = function(data) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createComment = function(data) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createCDATASection = function(data) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createProcessingInstruction = function(target, data) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createAttribute = function(name) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createEntityReference = function(name) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.getElementsByTagName = function(tagname) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.importNode = function(importedNode, deep) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createElementNS = function(namespaceURI, qualifiedName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createAttributeNS = function(namespaceURI, qualifiedName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.getElementsByTagNameNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.getElementById = function(elementId) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.adoptNode = function(source) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.normalizeDocument = function() {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.renameNode = function(node, namespaceURI, qualifiedName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.getElementsByClassName = function(classNames) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createEvent = function(eventInterface) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createRange = function() {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createNodeIterator = function(root, whatToShow, filter) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createTreeWalker = function(root, whatToShow, filter) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        return XMLDocument;
    }(XMLNode);
}).call(this);

},{"13a5a3baabce41d8":"1HtuW","b6961c96ff36d753":"338kW","1f23d28cae8a60a5":"dUqHu","cd39268a029bdce2":"lqojX","ee7140c760116731":"jdzc3","f050dc0a62284d96":"7Vj0n","1c368e88d7130ef6":"7x53O"}],"dUqHu":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDOMConfiguration, XMLDOMErrorHandler, XMLDOMStringList;
    XMLDOMErrorHandler = require("c72a8151611a34e9");
    XMLDOMStringList = require("6710741fe0d16dae");
    module.exports = XMLDOMConfiguration = function() {
        function XMLDOMConfiguration() {
            var clonedSelf;
            this.defaultParams = {
                "canonical-form": false,
                "cdata-sections": false,
                "comments": false,
                "datatype-normalization": false,
                "element-content-whitespace": true,
                "entities": true,
                "error-handler": new XMLDOMErrorHandler(),
                "infoset": true,
                "validate-if-schema": false,
                "namespaces": true,
                "namespace-declarations": true,
                "normalize-characters": false,
                "schema-location": "",
                "schema-type": "",
                "split-cdata-sections": true,
                "validate": false,
                "well-formed": true
            };
            this.params = clonedSelf = Object.create(this.defaultParams);
        }
        Object.defineProperty(XMLDOMConfiguration.prototype, "parameterNames", {
            get: function() {
                return new XMLDOMStringList(Object.keys(this.defaultParams));
            }
        });
        XMLDOMConfiguration.prototype.getParameter = function(name) {
            if (this.params.hasOwnProperty(name)) return this.params[name];
            else return null;
        };
        XMLDOMConfiguration.prototype.canSetParameter = function(name, value) {
            return true;
        };
        XMLDOMConfiguration.prototype.setParameter = function(name, value) {
            if (value != null) return this.params[name] = value;
            else return delete this.params[name];
        };
        return XMLDOMConfiguration;
    }();
}).call(this);

},{"c72a8151611a34e9":"cqcyB","6710741fe0d16dae":"diVvG"}],"cqcyB":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDOMErrorHandler;
    module.exports = XMLDOMErrorHandler = function() {
        function XMLDOMErrorHandler() {}
        XMLDOMErrorHandler.prototype.handleError = function(error) {
            throw new Error(error);
        };
        return XMLDOMErrorHandler;
    }();
}).call(this);

},{}],"diVvG":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDOMStringList;
    module.exports = XMLDOMStringList = function() {
        function XMLDOMStringList(arr) {
            this.arr = arr || [];
        }
        Object.defineProperty(XMLDOMStringList.prototype, "length", {
            get: function() {
                return this.arr.length;
            }
        });
        XMLDOMStringList.prototype.item = function(index) {
            return this.arr[index] || null;
        };
        XMLDOMStringList.prototype.contains = function(str) {
            return this.arr.indexOf(str) !== -1;
        };
        return XMLDOMStringList;
    }();
}).call(this);

},{}],"lqojX":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var DocumentPosition, NodeType, XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLNamedNodeMap, XMLNode, XMLNodeList, XMLProcessingInstruction, XMLRaw, XMLText, getValue, isEmpty, isFunction, isObject, ref1, hasProp = {}.hasOwnProperty;
    ref1 = require("704f24b4c9ed0254"), isObject = ref1.isObject, isFunction = ref1.isFunction, isEmpty = ref1.isEmpty, getValue = ref1.getValue;
    XMLElement = null;
    XMLCData = null;
    XMLComment = null;
    XMLDeclaration = null;
    XMLDocType = null;
    XMLRaw = null;
    XMLText = null;
    XMLProcessingInstruction = null;
    XMLDummy = null;
    NodeType = null;
    XMLNodeList = null;
    XMLNamedNodeMap = null;
    DocumentPosition = null;
    module.exports = XMLNode = function() {
        function XMLNode(parent1) {
            this.parent = parent1;
            if (this.parent) {
                this.options = this.parent.options;
                this.stringify = this.parent.stringify;
            }
            this.value = null;
            this.children = [];
            this.baseURI = null;
            if (!XMLElement) {
                XMLElement = require("bb9f43b93220ad7a");
                XMLCData = require("4c7d896cb6b56d63");
                XMLComment = require("91ed1f62eb89b645");
                XMLDeclaration = require("f449ccd8348c817c");
                XMLDocType = require("8ee4082395714d35");
                XMLRaw = require("f9c5b1d6679a33d5");
                XMLText = require("65d90f77c6196668");
                XMLProcessingInstruction = require("8e2e2e7d9c99b0f1");
                XMLDummy = require("f80ef020b5f168cc");
                NodeType = require("7c33a03644563158");
                XMLNodeList = require("ff2b0673a3f10f56");
                XMLNamedNodeMap = require("dbaafd3117e37a72");
                DocumentPosition = require("6214827e72f53399");
            }
        }
        Object.defineProperty(XMLNode.prototype, "nodeName", {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLNode.prototype, "nodeType", {
            get: function() {
                return this.type;
            }
        });
        Object.defineProperty(XMLNode.prototype, "nodeValue", {
            get: function() {
                return this.value;
            }
        });
        Object.defineProperty(XMLNode.prototype, "parentNode", {
            get: function() {
                return this.parent;
            }
        });
        Object.defineProperty(XMLNode.prototype, "childNodes", {
            get: function() {
                if (!this.childNodeList || !this.childNodeList.nodes) this.childNodeList = new XMLNodeList(this.children);
                return this.childNodeList;
            }
        });
        Object.defineProperty(XMLNode.prototype, "firstChild", {
            get: function() {
                return this.children[0] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "lastChild", {
            get: function() {
                return this.children[this.children.length - 1] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "previousSibling", {
            get: function() {
                var i;
                i = this.parent.children.indexOf(this);
                return this.parent.children[i - 1] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "nextSibling", {
            get: function() {
                var i;
                i = this.parent.children.indexOf(this);
                return this.parent.children[i + 1] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "ownerDocument", {
            get: function() {
                return this.document() || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "textContent", {
            get: function() {
                var child, j, len, ref2, str;
                if (this.nodeType === NodeType.Element || this.nodeType === NodeType.DocumentFragment) {
                    str = "";
                    ref2 = this.children;
                    for(j = 0, len = ref2.length; j < len; j++){
                        child = ref2[j];
                        if (child.textContent) str += child.textContent;
                    }
                    return str;
                } else return null;
            },
            set: function(value) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        XMLNode.prototype.setParent = function(parent) {
            var child, j, len, ref2, results;
            this.parent = parent;
            if (parent) {
                this.options = parent.options;
                this.stringify = parent.stringify;
            }
            ref2 = this.children;
            results = [];
            for(j = 0, len = ref2.length; j < len; j++){
                child = ref2[j];
                results.push(child.setParent(this));
            }
            return results;
        };
        XMLNode.prototype.element = function(name, attributes, text) {
            var childNode, item, j, k, key, lastChild, len, len1, ref2, ref3, val;
            lastChild = null;
            if (attributes === null && text == null) ref2 = [
                {},
                null
            ], attributes = ref2[0], text = ref2[1];
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref3 = [
                attributes,
                text
            ], text = ref3[0], attributes = ref3[1];
            if (name != null) name = getValue(name);
            if (Array.isArray(name)) for(j = 0, len = name.length; j < len; j++){
                item = name[j];
                lastChild = this.element(item);
            }
            else if (isFunction(name)) lastChild = this.element(name.apply());
            else if (isObject(name)) for(key in name){
                if (!hasProp.call(name, key)) continue;
                val = name[key];
                if (isFunction(val)) val = val.apply();
                if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
                else if (!this.options.separateArrayItems && Array.isArray(val) && isEmpty(val)) lastChild = this.dummy();
                else if (isObject(val) && isEmpty(val)) lastChild = this.element(key);
                else if (!this.options.keepNullNodes && val == null) lastChild = this.dummy();
                else if (!this.options.separateArrayItems && Array.isArray(val)) for(k = 0, len1 = val.length; k < len1; k++){
                    item = val[k];
                    childNode = {};
                    childNode[key] = item;
                    lastChild = this.element(childNode);
                }
                else if (isObject(val)) {
                    if (!this.options.ignoreDecorators && this.stringify.convertTextKey && key.indexOf(this.stringify.convertTextKey) === 0) lastChild = this.element(val);
                    else {
                        lastChild = this.element(key);
                        lastChild.element(val);
                    }
                } else lastChild = this.element(key, val);
            }
            else if (!this.options.keepNullNodes && text === null) lastChild = this.dummy();
            else {
                if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) lastChild = this.text(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) lastChild = this.cdata(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) lastChild = this.comment(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) lastChild = this.raw(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
                else lastChild = this.node(name, attributes, text);
            }
            if (lastChild == null) throw new Error("Could not create any elements with: " + name + ". " + this.debugInfo());
            return lastChild;
        };
        XMLNode.prototype.insertBefore = function(name, attributes, text) {
            var child, i, newChild, refChild, removed;
            if (name != null ? name.type : void 0) {
                newChild = name;
                refChild = attributes;
                newChild.setParent(this);
                if (refChild) {
                    i = children.indexOf(refChild);
                    removed = children.splice(i);
                    children.push(newChild);
                    Array.prototype.push.apply(children, removed);
                } else children.push(newChild);
                return newChild;
            } else {
                if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
                i = this.parent.children.indexOf(this);
                removed = this.parent.children.splice(i);
                child = this.parent.element(name, attributes, text);
                Array.prototype.push.apply(this.parent.children, removed);
                return child;
            }
        };
        XMLNode.prototype.insertAfter = function(name, attributes, text) {
            var child, i, removed;
            if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.element(name, attributes, text);
            Array.prototype.push.apply(this.parent.children, removed);
            return child;
        };
        XMLNode.prototype.remove = function() {
            var i, ref2;
            if (this.isRoot) throw new Error("Cannot remove the root element. " + this.debugInfo());
            i = this.parent.children.indexOf(this);
            [].splice.apply(this.parent.children, [
                i,
                i - i + 1
            ].concat(ref2 = [])), ref2;
            return this.parent;
        };
        XMLNode.prototype.node = function(name, attributes, text) {
            var child, ref2;
            if (name != null) name = getValue(name);
            attributes || (attributes = {});
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref2 = [
                attributes,
                text
            ], text = ref2[0], attributes = ref2[1];
            child = new XMLElement(this, name, attributes);
            if (text != null) child.text(text);
            this.children.push(child);
            return child;
        };
        XMLNode.prototype.text = function(value) {
            var child;
            if (isObject(value)) this.element(value);
            child = new XMLText(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.cdata = function(value) {
            var child;
            child = new XMLCData(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.comment = function(value) {
            var child;
            child = new XMLComment(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.commentBefore = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.commentAfter = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.raw = function(value) {
            var child;
            child = new XMLRaw(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.dummy = function() {
            var child;
            child = new XMLDummy(this);
            return child;
        };
        XMLNode.prototype.instruction = function(target, value) {
            var insTarget, insValue, instruction, j, len;
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(j = 0, len = target.length; j < len; j++){
                insTarget = target[j];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                instruction = new XMLProcessingInstruction(this, target, value);
                this.children.push(instruction);
            }
            return this;
        };
        XMLNode.prototype.instructionBefore = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.instructionAfter = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.declaration = function(version, encoding, standalone) {
            var doc, xmldec;
            doc = this.document();
            xmldec = new XMLDeclaration(doc, version, encoding, standalone);
            if (doc.children.length === 0) doc.children.unshift(xmldec);
            else if (doc.children[0].type === NodeType.Declaration) doc.children[0] = xmldec;
            else doc.children.unshift(xmldec);
            return doc.root() || doc;
        };
        XMLNode.prototype.dtd = function(pubID, sysID) {
            var child, doc, doctype, i, j, k, len, len1, ref2, ref3;
            doc = this.document();
            doctype = new XMLDocType(doc, pubID, sysID);
            ref2 = doc.children;
            for(i = j = 0, len = ref2.length; j < len; i = ++j){
                child = ref2[i];
                if (child.type === NodeType.DocType) {
                    doc.children[i] = doctype;
                    return doctype;
                }
            }
            ref3 = doc.children;
            for(i = k = 0, len1 = ref3.length; k < len1; i = ++k){
                child = ref3[i];
                if (child.isRoot) {
                    doc.children.splice(i, 0, doctype);
                    return doctype;
                }
            }
            doc.children.push(doctype);
            return doctype;
        };
        XMLNode.prototype.up = function() {
            if (this.isRoot) throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
            return this.parent;
        };
        XMLNode.prototype.root = function() {
            var node;
            node = this;
            while(node){
                if (node.type === NodeType.Document) return node.rootObject;
                else if (node.isRoot) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.document = function() {
            var node;
            node = this;
            while(node){
                if (node.type === NodeType.Document) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.end = function(options) {
            return this.document().end(options);
        };
        XMLNode.prototype.prev = function() {
            var i;
            i = this.parent.children.indexOf(this);
            if (i < 1) throw new Error("Already at the first node. " + this.debugInfo());
            return this.parent.children[i - 1];
        };
        XMLNode.prototype.next = function() {
            var i;
            i = this.parent.children.indexOf(this);
            if (i === -1 || i === this.parent.children.length - 1) throw new Error("Already at the last node. " + this.debugInfo());
            return this.parent.children[i + 1];
        };
        XMLNode.prototype.importDocument = function(doc) {
            var clonedRoot;
            clonedRoot = doc.root().clone();
            clonedRoot.parent = this;
            clonedRoot.isRoot = false;
            this.children.push(clonedRoot);
            return this;
        };
        XMLNode.prototype.debugInfo = function(name) {
            var ref2, ref3;
            name = name || this.name;
            if (name == null && !((ref2 = this.parent) != null ? ref2.name : void 0)) return "";
            else if (name == null) return "parent: <" + this.parent.name + ">";
            else if (!((ref3 = this.parent) != null ? ref3.name : void 0)) return "node: <" + name + ">";
            else return "node: <" + name + ">, parent: <" + this.parent.name + ">";
        };
        XMLNode.prototype.ele = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.doc = function() {
            return this.document();
        };
        XMLNode.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLNode.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.t = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLNode.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.u = function() {
            return this.up();
        };
        XMLNode.prototype.importXMLBuilder = function(doc) {
            return this.importDocument(doc);
        };
        XMLNode.prototype.replaceChild = function(newChild, oldChild) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.removeChild = function(oldChild) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.appendChild = function(newChild) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.hasChildNodes = function() {
            return this.children.length !== 0;
        };
        XMLNode.prototype.cloneNode = function(deep) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.normalize = function() {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.isSupported = function(feature, version) {
            return true;
        };
        XMLNode.prototype.hasAttributes = function() {
            return this.attribs.length !== 0;
        };
        XMLNode.prototype.compareDocumentPosition = function(other) {
            var ref, res;
            ref = this;
            if (ref === other) return 0;
            else if (this.document() !== other.document()) {
                res = DocumentPosition.Disconnected | DocumentPosition.ImplementationSpecific;
                if (Math.random() < 0.5) res |= DocumentPosition.Preceding;
                else res |= DocumentPosition.Following;
                return res;
            } else if (ref.isAncestor(other)) return DocumentPosition.Contains | DocumentPosition.Preceding;
            else if (ref.isDescendant(other)) return DocumentPosition.Contains | DocumentPosition.Following;
            else if (ref.isPreceding(other)) return DocumentPosition.Preceding;
            else return DocumentPosition.Following;
        };
        XMLNode.prototype.isSameNode = function(other) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.lookupPrefix = function(namespaceURI) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.isDefaultNamespace = function(namespaceURI) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.lookupNamespaceURI = function(prefix) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.isEqualNode = function(node) {
            var i, j, ref2;
            if (node.nodeType !== this.nodeType) return false;
            if (node.children.length !== this.children.length) return false;
            for(i = j = 0, ref2 = this.children.length - 1; 0 <= ref2 ? j <= ref2 : j >= ref2; i = 0 <= ref2 ? ++j : --j){
                if (!this.children[i].isEqualNode(node.children[i])) return false;
            }
            return true;
        };
        XMLNode.prototype.getFeature = function(feature, version) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.setUserData = function(key, data, handler) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.getUserData = function(key) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.contains = function(other) {
            if (!other) return false;
            return other === this || this.isDescendant(other);
        };
        XMLNode.prototype.isDescendant = function(node) {
            var child, isDescendantChild, j, len, ref2;
            ref2 = this.children;
            for(j = 0, len = ref2.length; j < len; j++){
                child = ref2[j];
                if (node === child) return true;
                isDescendantChild = child.isDescendant(node);
                if (isDescendantChild) return true;
            }
            return false;
        };
        XMLNode.prototype.isAncestor = function(node) {
            return node.isDescendant(this);
        };
        XMLNode.prototype.isPreceding = function(node) {
            var nodePos, thisPos;
            nodePos = this.treePosition(node);
            thisPos = this.treePosition(this);
            if (nodePos === -1 || thisPos === -1) return false;
            else return nodePos < thisPos;
        };
        XMLNode.prototype.isFollowing = function(node) {
            var nodePos, thisPos;
            nodePos = this.treePosition(node);
            thisPos = this.treePosition(this);
            if (nodePos === -1 || thisPos === -1) return false;
            else return nodePos > thisPos;
        };
        XMLNode.prototype.treePosition = function(node) {
            var found, pos;
            pos = 0;
            found = false;
            this.foreachTreeNode(this.document(), function(childNode) {
                pos++;
                if (!found && childNode === node) return found = true;
            });
            if (found) return pos;
            else return -1;
        };
        XMLNode.prototype.foreachTreeNode = function(node, func) {
            var child, j, len, ref2, res;
            node || (node = this.document());
            ref2 = node.children;
            for(j = 0, len = ref2.length; j < len; j++){
                child = ref2[j];
                if (res = func(child)) return res;
                else {
                    res = this.foreachTreeNode(child, func);
                    if (res) return res;
                }
            }
        };
        return XMLNode;
    }();
}).call(this);

},{"704f24b4c9ed0254":"1HtuW","bb9f43b93220ad7a":"FUSD2","4c7d896cb6b56d63":"6Kwjh","91ed1f62eb89b645":"UeePz","f449ccd8348c817c":"fQz7p","8ee4082395714d35":"7ceju","f9c5b1d6679a33d5":"4xqyS","65d90f77c6196668":"c3oFr","8e2e2e7d9c99b0f1":"a4dKY","f80ef020b5f168cc":"bEsnF","7c33a03644563158":"jdzc3","ff2b0673a3f10f56":"eY3Nn","dbaafd3117e37a72":"3tm9f","6214827e72f53399":"gXsAi"}],"FUSD2":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLAttribute, XMLElement, XMLNamedNodeMap, XMLNode, getValue, isFunction, isObject, ref, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    ref = require("760e1e681b3efb5e"), isObject = ref.isObject, isFunction = ref.isFunction, getValue = ref.getValue;
    XMLNode = require("b30d72617b2d0e");
    NodeType = require("b548af19154e188f");
    XMLAttribute = require("91ce844474972b76");
    XMLNamedNodeMap = require("1a2db5acef6e9ab2");
    module.exports = XMLElement = function(superClass) {
        extend(XMLElement, superClass);
        function XMLElement(parent, name, attributes) {
            var child, j, len, ref1;
            XMLElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing element name. " + this.debugInfo());
            this.name = this.stringify.name(name);
            this.type = NodeType.Element;
            this.attribs = {};
            this.schemaTypeInfo = null;
            if (attributes != null) this.attribute(attributes);
            if (parent.type === NodeType.Document) {
                this.isRoot = true;
                this.documentObject = parent;
                parent.rootObject = this;
                if (parent.children) {
                    ref1 = parent.children;
                    for(j = 0, len = ref1.length; j < len; j++){
                        child = ref1[j];
                        if (child.type === NodeType.DocType) {
                            child.name = this.name;
                            break;
                        }
                    }
                }
            }
        }
        Object.defineProperty(XMLElement.prototype, "tagName", {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLElement.prototype, "namespaceURI", {
            get: function() {
                return "";
            }
        });
        Object.defineProperty(XMLElement.prototype, "prefix", {
            get: function() {
                return "";
            }
        });
        Object.defineProperty(XMLElement.prototype, "localName", {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLElement.prototype, "id", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLElement.prototype, "className", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLElement.prototype, "classList", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLElement.prototype, "attributes", {
            get: function() {
                if (!this.attributeMap || !this.attributeMap.nodes) this.attributeMap = new XMLNamedNodeMap(this.attribs);
                return this.attributeMap;
            }
        });
        XMLElement.prototype.clone = function() {
            var att, attName, clonedSelf, ref1;
            clonedSelf = Object.create(this);
            if (clonedSelf.isRoot) clonedSelf.documentObject = null;
            clonedSelf.attribs = {};
            ref1 = this.attribs;
            for(attName in ref1){
                if (!hasProp.call(ref1, attName)) continue;
                att = ref1[attName];
                clonedSelf.attribs[attName] = att.clone();
            }
            clonedSelf.children = [];
            this.children.forEach(function(child) {
                var clonedChild;
                clonedChild = child.clone();
                clonedChild.parent = clonedSelf;
                return clonedSelf.children.push(clonedChild);
            });
            return clonedSelf;
        };
        XMLElement.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (this.options.keepNullAttributes && value == null) this.attribs[name] = new XMLAttribute(this, name, "");
                else if (value != null) this.attribs[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLElement.prototype.removeAttribute = function(name) {
            var attName, j, len;
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo());
            name = getValue(name);
            if (Array.isArray(name)) for(j = 0, len = name.length; j < len; j++){
                attName = name[j];
                delete this.attribs[attName];
            }
            else delete this.attribs[name];
            return this;
        };
        XMLElement.prototype.toString = function(options) {
            return this.options.writer.element(this, this.options.writer.filterOptions(options));
        };
        XMLElement.prototype.att = function(name, value) {
            return this.attribute(name, value);
        };
        XMLElement.prototype.a = function(name, value) {
            return this.attribute(name, value);
        };
        XMLElement.prototype.getAttribute = function(name) {
            if (this.attribs.hasOwnProperty(name)) return this.attribs[name].value;
            else return null;
        };
        XMLElement.prototype.setAttribute = function(name, value) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getAttributeNode = function(name) {
            if (this.attribs.hasOwnProperty(name)) return this.attribs[name];
            else return null;
        };
        XMLElement.prototype.setAttributeNode = function(newAttr) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.removeAttributeNode = function(oldAttr) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByTagName = function(name) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getAttributeNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.setAttributeNS = function(namespaceURI, qualifiedName, value) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.removeAttributeNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getAttributeNodeNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.setAttributeNodeNS = function(newAttr) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByTagNameNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.hasAttribute = function(name) {
            return this.attribs.hasOwnProperty(name);
        };
        XMLElement.prototype.hasAttributeNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.setIdAttribute = function(name, isId) {
            if (this.attribs.hasOwnProperty(name)) return this.attribs[name].isId;
            else return isId;
        };
        XMLElement.prototype.setIdAttributeNS = function(namespaceURI, localName, isId) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.setIdAttributeNode = function(idAttr, isId) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByTagName = function(tagname) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByTagNameNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByClassName = function(classNames) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.isEqualNode = function(node) {
            var i, j, ref1;
            if (!XMLElement.__super__.isEqualNode.apply(this, arguments).isEqualNode(node)) return false;
            if (node.namespaceURI !== this.namespaceURI) return false;
            if (node.prefix !== this.prefix) return false;
            if (node.localName !== this.localName) return false;
            if (node.attribs.length !== this.attribs.length) return false;
            for(i = j = 0, ref1 = this.attribs.length - 1; 0 <= ref1 ? j <= ref1 : j >= ref1; i = 0 <= ref1 ? ++j : --j){
                if (!this.attribs[i].isEqualNode(node.attribs[i])) return false;
            }
            return true;
        };
        return XMLElement;
    }(XMLNode);
}).call(this);

},{"760e1e681b3efb5e":"1HtuW","b30d72617b2d0e":"lqojX","b548af19154e188f":"jdzc3","91ce844474972b76":"24JgK","1a2db5acef6e9ab2":"3tm9f"}],"jdzc3":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    module.exports = {
        Element: 1,
        Attribute: 2,
        Text: 3,
        CData: 4,
        EntityReference: 5,
        EntityDeclaration: 6,
        ProcessingInstruction: 7,
        Comment: 8,
        Document: 9,
        DocType: 10,
        DocumentFragment: 11,
        NotationDeclaration: 12,
        Declaration: 201,
        Raw: 202,
        AttributeDeclaration: 203,
        ElementDeclaration: 204,
        Dummy: 205
    };
}).call(this);

},{}],"24JgK":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLAttribute, XMLNode;
    NodeType = require("2ac94b791509906a");
    XMLNode = require("4460ed8c305de0cc");
    module.exports = XMLAttribute = function() {
        function XMLAttribute(parent, name, value) {
            this.parent = parent;
            if (this.parent) {
                this.options = this.parent.options;
                this.stringify = this.parent.stringify;
            }
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo(name));
            this.name = this.stringify.name(name);
            this.value = this.stringify.attValue(value);
            this.type = NodeType.Attribute;
            this.isId = false;
            this.schemaTypeInfo = null;
        }
        Object.defineProperty(XMLAttribute.prototype, "nodeType", {
            get: function() {
                return this.type;
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "ownerElement", {
            get: function() {
                return this.parent;
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "textContent", {
            get: function() {
                return this.value;
            },
            set: function(value) {
                return this.value = value || "";
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "namespaceURI", {
            get: function() {
                return "";
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "prefix", {
            get: function() {
                return "";
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "localName", {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "specified", {
            get: function() {
                return true;
            }
        });
        XMLAttribute.prototype.clone = function() {
            return Object.create(this);
        };
        XMLAttribute.prototype.toString = function(options) {
            return this.options.writer.attribute(this, this.options.writer.filterOptions(options));
        };
        XMLAttribute.prototype.debugInfo = function(name) {
            name = name || this.name;
            if (name == null) return "parent: <" + this.parent.name + ">";
            else return "attribute: {" + name + "}, parent: <" + this.parent.name + ">";
        };
        XMLAttribute.prototype.isEqualNode = function(node) {
            if (node.namespaceURI !== this.namespaceURI) return false;
            if (node.prefix !== this.prefix) return false;
            if (node.localName !== this.localName) return false;
            if (node.value !== this.value) return false;
            return true;
        };
        return XMLAttribute;
    }();
}).call(this);

},{"2ac94b791509906a":"jdzc3","4460ed8c305de0cc":"lqojX"}],"3tm9f":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNamedNodeMap;
    module.exports = XMLNamedNodeMap = function() {
        function XMLNamedNodeMap(nodes) {
            this.nodes = nodes;
        }
        Object.defineProperty(XMLNamedNodeMap.prototype, "length", {
            get: function() {
                return Object.keys(this.nodes).length || 0;
            }
        });
        XMLNamedNodeMap.prototype.clone = function() {
            return this.nodes = null;
        };
        XMLNamedNodeMap.prototype.getNamedItem = function(name) {
            return this.nodes[name];
        };
        XMLNamedNodeMap.prototype.setNamedItem = function(node) {
            var oldNode;
            oldNode = this.nodes[node.nodeName];
            this.nodes[node.nodeName] = node;
            return oldNode || null;
        };
        XMLNamedNodeMap.prototype.removeNamedItem = function(name) {
            var oldNode;
            oldNode = this.nodes[name];
            delete this.nodes[name];
            return oldNode || null;
        };
        XMLNamedNodeMap.prototype.item = function(index) {
            return this.nodes[Object.keys(this.nodes)[index]] || null;
        };
        XMLNamedNodeMap.prototype.getNamedItemNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLNamedNodeMap.prototype.setNamedItemNS = function(node) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLNamedNodeMap.prototype.removeNamedItemNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented.");
        };
        return XMLNamedNodeMap;
    }();
}).call(this);

},{}],"6Kwjh":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLCData, XMLCharacterData, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = require("1d10efe8d12710ca");
    XMLCharacterData = require("da41985d18d84bf2");
    module.exports = XMLCData = function(superClass) {
        extend(XMLCData, superClass);
        function XMLCData(parent, text) {
            XMLCData.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing CDATA text. " + this.debugInfo());
            this.name = "#cdata-section";
            this.type = NodeType.CData;
            this.value = this.stringify.cdata(text);
        }
        XMLCData.prototype.clone = function() {
            return Object.create(this);
        };
        XMLCData.prototype.toString = function(options) {
            return this.options.writer.cdata(this, this.options.writer.filterOptions(options));
        };
        return XMLCData;
    }(XMLCharacterData);
}).call(this);

},{"1d10efe8d12710ca":"jdzc3","da41985d18d84bf2":"oenKk"}],"oenKk":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCharacterData, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = require("d99443ca7fe2d67d");
    module.exports = XMLCharacterData = function(superClass) {
        extend(XMLCharacterData, superClass);
        function XMLCharacterData(parent) {
            XMLCharacterData.__super__.constructor.call(this, parent);
            this.value = "";
        }
        Object.defineProperty(XMLCharacterData.prototype, "data", {
            get: function() {
                return this.value;
            },
            set: function(value) {
                return this.value = value || "";
            }
        });
        Object.defineProperty(XMLCharacterData.prototype, "length", {
            get: function() {
                return this.value.length;
            }
        });
        Object.defineProperty(XMLCharacterData.prototype, "textContent", {
            get: function() {
                return this.value;
            },
            set: function(value) {
                return this.value = value || "";
            }
        });
        XMLCharacterData.prototype.clone = function() {
            return Object.create(this);
        };
        XMLCharacterData.prototype.substringData = function(offset, count) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.appendData = function(arg) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.insertData = function(offset, arg) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.deleteData = function(offset, count) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.replaceData = function(offset, count, arg) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.isEqualNode = function(node) {
            if (!XMLCharacterData.__super__.isEqualNode.apply(this, arguments).isEqualNode(node)) return false;
            if (node.data !== this.data) return false;
            return true;
        };
        return XMLCharacterData;
    }(XMLNode);
}).call(this);

},{"d99443ca7fe2d67d":"lqojX"}],"UeePz":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLCharacterData, XMLComment, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = require("b0dbe926c1622528");
    XMLCharacterData = require("d18aaaf3ab58e603");
    module.exports = XMLComment = function(superClass) {
        extend(XMLComment, superClass);
        function XMLComment(parent, text) {
            XMLComment.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing comment text. " + this.debugInfo());
            this.name = "#comment";
            this.type = NodeType.Comment;
            this.value = this.stringify.comment(text);
        }
        XMLComment.prototype.clone = function() {
            return Object.create(this);
        };
        XMLComment.prototype.toString = function(options) {
            return this.options.writer.comment(this, this.options.writer.filterOptions(options));
        };
        return XMLComment;
    }(XMLCharacterData);
}).call(this);

},{"b0dbe926c1622528":"jdzc3","d18aaaf3ab58e603":"oenKk"}],"fQz7p":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDeclaration, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = require("cf2a3ddbe00c2bec").isObject;
    XMLNode = require("b70b0f72196be228");
    NodeType = require("7910f9e4e0ec2b8c");
    module.exports = XMLDeclaration = function(superClass) {
        extend(XMLDeclaration, superClass);
        function XMLDeclaration(parent, version, encoding, standalone) {
            var ref;
            XMLDeclaration.__super__.constructor.call(this, parent);
            if (isObject(version)) ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
            if (!version) version = "1.0";
            this.type = NodeType.Declaration;
            this.version = this.stringify.xmlVersion(version);
            if (encoding != null) this.encoding = this.stringify.xmlEncoding(encoding);
            if (standalone != null) this.standalone = this.stringify.xmlStandalone(standalone);
        }
        XMLDeclaration.prototype.toString = function(options) {
            return this.options.writer.declaration(this, this.options.writer.filterOptions(options));
        };
        return XMLDeclaration;
    }(XMLNode);
}).call(this);

},{"cf2a3ddbe00c2bec":"1HtuW","b70b0f72196be228":"lqojX","7910f9e4e0ec2b8c":"jdzc3"}],"7ceju":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNamedNodeMap, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = require("2d96570e9ce5a61a").isObject;
    XMLNode = require("10eff02d526f1f13");
    NodeType = require("9167240c545a1251");
    XMLDTDAttList = require("364c364aa3224d14");
    XMLDTDEntity = require("f24de147ed1d6fb5");
    XMLDTDElement = require("a588b70eba73aefb");
    XMLDTDNotation = require("6f9e9e9353c73e81");
    XMLNamedNodeMap = require("dbb2e06d6fd270ad");
    module.exports = XMLDocType = function(superClass) {
        extend(XMLDocType, superClass);
        function XMLDocType(parent, pubID, sysID) {
            var child, i, len, ref, ref1, ref2;
            XMLDocType.__super__.constructor.call(this, parent);
            this.type = NodeType.DocType;
            if (parent.children) {
                ref = parent.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.Element) {
                        this.name = child.name;
                        break;
                    }
                }
            }
            this.documentObject = parent;
            if (isObject(pubID)) ref1 = pubID, pubID = ref1.pubID, sysID = ref1.sysID;
            if (sysID == null) ref2 = [
                pubID,
                sysID
            ], sysID = ref2[0], pubID = ref2[1];
            if (pubID != null) this.pubID = this.stringify.dtdPubID(pubID);
            if (sysID != null) this.sysID = this.stringify.dtdSysID(sysID);
        }
        Object.defineProperty(XMLDocType.prototype, "entities", {
            get: function() {
                var child, i, len, nodes, ref;
                nodes = {};
                ref = this.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.EntityDeclaration && !child.pe) nodes[child.name] = child;
                }
                return new XMLNamedNodeMap(nodes);
            }
        });
        Object.defineProperty(XMLDocType.prototype, "notations", {
            get: function() {
                var child, i, len, nodes, ref;
                nodes = {};
                ref = this.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.NotationDeclaration) nodes[child.name] = child;
                }
                return new XMLNamedNodeMap(nodes);
            }
        });
        Object.defineProperty(XMLDocType.prototype, "publicId", {
            get: function() {
                return this.pubID;
            }
        });
        Object.defineProperty(XMLDocType.prototype, "systemId", {
            get: function() {
                return this.sysID;
            }
        });
        Object.defineProperty(XMLDocType.prototype, "internalSubset", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        XMLDocType.prototype.element = function(name, value) {
            var child;
            child = new XMLDTDElement(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var child;
            child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.entity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, false, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.pEntity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, true, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.notation = function(name, value) {
            var child;
            child = new XMLDTDNotation(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.toString = function(options) {
            return this.options.writer.docType(this, this.options.writer.filterOptions(options));
        };
        XMLDocType.prototype.ele = function(name, value) {
            return this.element(name, value);
        };
        XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
        };
        XMLDocType.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocType.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocType.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        XMLDocType.prototype.up = function() {
            return this.root() || this.documentObject;
        };
        XMLDocType.prototype.isEqualNode = function(node) {
            if (!XMLDocType.__super__.isEqualNode.apply(this, arguments).isEqualNode(node)) return false;
            if (node.name !== this.name) return false;
            if (node.publicId !== this.publicId) return false;
            if (node.systemId !== this.systemId) return false;
            return true;
        };
        return XMLDocType;
    }(XMLNode);
}).call(this);

},{"2d96570e9ce5a61a":"1HtuW","10eff02d526f1f13":"lqojX","9167240c545a1251":"jdzc3","364c364aa3224d14":"wLxwc","f24de147ed1d6fb5":"hJVIJ","a588b70eba73aefb":"beBpN","6f9e9e9353c73e81":"5IZ5H","dbb2e06d6fd270ad":"3tm9f"}],"wLxwc":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDAttList, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = require("e63acd90dbde9d27");
    NodeType = require("e38e2d5ce2a0a55");
    module.exports = XMLDTDAttList = function(superClass) {
        extend(XMLDTDAttList, superClass);
        function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            XMLDTDAttList.__super__.constructor.call(this, parent);
            if (elementName == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (attributeName == null) throw new Error("Missing DTD attribute name. " + this.debugInfo(elementName));
            if (!attributeType) throw new Error("Missing DTD attribute type. " + this.debugInfo(elementName));
            if (!defaultValueType) throw new Error("Missing DTD attribute default. " + this.debugInfo(elementName));
            if (defaultValueType.indexOf("#") !== 0) defaultValueType = "#" + defaultValueType;
            if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) throw new Error("Default value only applies to #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            this.elementName = this.stringify.name(elementName);
            this.type = NodeType.AttributeDeclaration;
            this.attributeName = this.stringify.name(attributeName);
            this.attributeType = this.stringify.dtdAttType(attributeType);
            if (defaultValue) this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
            this.defaultValueType = defaultValueType;
        }
        XMLDTDAttList.prototype.toString = function(options) {
            return this.options.writer.dtdAttList(this, this.options.writer.filterOptions(options));
        };
        return XMLDTDAttList;
    }(XMLNode);
}).call(this);

},{"e63acd90dbde9d27":"lqojX","e38e2d5ce2a0a55":"jdzc3"}],"hJVIJ":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDEntity, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = require("6b00c2638d6cff6e").isObject;
    XMLNode = require("5619e8138a9444ca");
    NodeType = require("2e642c53b1846a5e");
    module.exports = XMLDTDEntity = function(superClass) {
        extend(XMLDTDEntity, superClass);
        function XMLDTDEntity(parent, pe, name, value) {
            XMLDTDEntity.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD entity name. " + this.debugInfo(name));
            if (value == null) throw new Error("Missing DTD entity value. " + this.debugInfo(name));
            this.pe = !!pe;
            this.name = this.stringify.name(name);
            this.type = NodeType.EntityDeclaration;
            if (!isObject(value)) {
                this.value = this.stringify.dtdEntityValue(value);
                this.internal = true;
            } else {
                if (!value.pubID && !value.sysID) throw new Error("Public and/or system identifiers are required for an external entity. " + this.debugInfo(name));
                if (value.pubID && !value.sysID) throw new Error("System identifier is required for a public external entity. " + this.debugInfo(name));
                this.internal = false;
                if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
                if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
                if (value.nData != null) this.nData = this.stringify.dtdNData(value.nData);
                if (this.pe && this.nData) throw new Error("Notation declaration is not allowed in a parameter entity. " + this.debugInfo(name));
            }
        }
        Object.defineProperty(XMLDTDEntity.prototype, "publicId", {
            get: function() {
                return this.pubID;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "systemId", {
            get: function() {
                return this.sysID;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "notationName", {
            get: function() {
                return this.nData || null;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "inputEncoding", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "xmlEncoding", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "xmlVersion", {
            get: function() {
                return null;
            }
        });
        XMLDTDEntity.prototype.toString = function(options) {
            return this.options.writer.dtdEntity(this, this.options.writer.filterOptions(options));
        };
        return XMLDTDEntity;
    }(XMLNode);
}).call(this);

},{"6b00c2638d6cff6e":"1HtuW","5619e8138a9444ca":"lqojX","2e642c53b1846a5e":"jdzc3"}],"beBpN":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDElement, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = require("58f833e8788221ff");
    NodeType = require("bd936b22ecaf9e3e");
    module.exports = XMLDTDElement = function(superClass) {
        extend(XMLDTDElement, superClass);
        function XMLDTDElement(parent, name, value) {
            XMLDTDElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (!value) value = "(#PCDATA)";
            if (Array.isArray(value)) value = "(" + value.join(",") + ")";
            this.name = this.stringify.name(name);
            this.type = NodeType.ElementDeclaration;
            this.value = this.stringify.dtdElementValue(value);
        }
        XMLDTDElement.prototype.toString = function(options) {
            return this.options.writer.dtdElement(this, this.options.writer.filterOptions(options));
        };
        return XMLDTDElement;
    }(XMLNode);
}).call(this);

},{"58f833e8788221ff":"lqojX","bd936b22ecaf9e3e":"jdzc3"}],"5IZ5H":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDNotation, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = require("30e258c5f358ba86");
    NodeType = require("3458890a6746c52e");
    module.exports = XMLDTDNotation = function(superClass) {
        extend(XMLDTDNotation, superClass);
        function XMLDTDNotation(parent, name, value) {
            XMLDTDNotation.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD notation name. " + this.debugInfo(name));
            if (!value.pubID && !value.sysID) throw new Error("Public or system identifiers are required for an external entity. " + this.debugInfo(name));
            this.name = this.stringify.name(name);
            this.type = NodeType.NotationDeclaration;
            if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
            if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        Object.defineProperty(XMLDTDNotation.prototype, "publicId", {
            get: function() {
                return this.pubID;
            }
        });
        Object.defineProperty(XMLDTDNotation.prototype, "systemId", {
            get: function() {
                return this.sysID;
            }
        });
        XMLDTDNotation.prototype.toString = function(options) {
            return this.options.writer.dtdNotation(this, this.options.writer.filterOptions(options));
        };
        return XMLDTDNotation;
    }(XMLNode);
}).call(this);

},{"30e258c5f358ba86":"lqojX","3458890a6746c52e":"jdzc3"}],"4xqyS":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLNode, XMLRaw, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = require("dcd9ea319a520167");
    XMLNode = require("47e90ce7f40a2f89");
    module.exports = XMLRaw = function(superClass) {
        extend(XMLRaw, superClass);
        function XMLRaw(parent, text) {
            XMLRaw.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing raw text. " + this.debugInfo());
            this.type = NodeType.Raw;
            this.value = this.stringify.raw(text);
        }
        XMLRaw.prototype.clone = function() {
            return Object.create(this);
        };
        XMLRaw.prototype.toString = function(options) {
            return this.options.writer.raw(this, this.options.writer.filterOptions(options));
        };
        return XMLRaw;
    }(XMLNode);
}).call(this);

},{"dcd9ea319a520167":"jdzc3","47e90ce7f40a2f89":"lqojX"}],"c3oFr":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLCharacterData, XMLText, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = require("e16b55d7b9ae6110");
    XMLCharacterData = require("6951a1495b9b2aef");
    module.exports = XMLText = function(superClass) {
        extend(XMLText, superClass);
        function XMLText(parent, text) {
            XMLText.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing element text. " + this.debugInfo());
            this.name = "#text";
            this.type = NodeType.Text;
            this.value = this.stringify.text(text);
        }
        Object.defineProperty(XMLText.prototype, "isElementContentWhitespace", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLText.prototype, "wholeText", {
            get: function() {
                var next, prev, str;
                str = "";
                prev = this.previousSibling;
                while(prev){
                    str = prev.data + str;
                    prev = prev.previousSibling;
                }
                str += this.data;
                next = this.nextSibling;
                while(next){
                    str = str + next.data;
                    next = next.nextSibling;
                }
                return str;
            }
        });
        XMLText.prototype.clone = function() {
            return Object.create(this);
        };
        XMLText.prototype.toString = function(options) {
            return this.options.writer.text(this, this.options.writer.filterOptions(options));
        };
        XMLText.prototype.splitText = function(offset) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLText.prototype.replaceWholeText = function(content) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        return XMLText;
    }(XMLCharacterData);
}).call(this);

},{"e16b55d7b9ae6110":"jdzc3","6951a1495b9b2aef":"oenKk"}],"a4dKY":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLCharacterData, XMLProcessingInstruction, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = require("dc0d646c907512fa");
    XMLCharacterData = require("3417ec217a826ec8");
    module.exports = XMLProcessingInstruction = function(superClass) {
        extend(XMLProcessingInstruction, superClass);
        function XMLProcessingInstruction(parent, target, value) {
            XMLProcessingInstruction.__super__.constructor.call(this, parent);
            if (target == null) throw new Error("Missing instruction target. " + this.debugInfo());
            this.type = NodeType.ProcessingInstruction;
            this.target = this.stringify.insTarget(target);
            this.name = this.target;
            if (value) this.value = this.stringify.insValue(value);
        }
        XMLProcessingInstruction.prototype.clone = function() {
            return Object.create(this);
        };
        XMLProcessingInstruction.prototype.toString = function(options) {
            return this.options.writer.processingInstruction(this, this.options.writer.filterOptions(options));
        };
        XMLProcessingInstruction.prototype.isEqualNode = function(node) {
            if (!XMLProcessingInstruction.__super__.isEqualNode.apply(this, arguments).isEqualNode(node)) return false;
            if (node.target !== this.target) return false;
            return true;
        };
        return XMLProcessingInstruction;
    }(XMLCharacterData);
}).call(this);

},{"dc0d646c907512fa":"jdzc3","3417ec217a826ec8":"oenKk"}],"bEsnF":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDummy, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = require("a213921cd91c2245");
    NodeType = require("47cd197d16eee265");
    module.exports = XMLDummy = function(superClass) {
        extend(XMLDummy, superClass);
        function XMLDummy(parent) {
            XMLDummy.__super__.constructor.call(this, parent);
            this.type = NodeType.Dummy;
        }
        XMLDummy.prototype.clone = function() {
            return Object.create(this);
        };
        XMLDummy.prototype.toString = function(options) {
            return "";
        };
        return XMLDummy;
    }(XMLNode);
}).call(this);

},{"a213921cd91c2245":"lqojX","47cd197d16eee265":"jdzc3"}],"eY3Nn":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNodeList;
    module.exports = XMLNodeList = function() {
        function XMLNodeList(nodes) {
            this.nodes = nodes;
        }
        Object.defineProperty(XMLNodeList.prototype, "length", {
            get: function() {
                return this.nodes.length || 0;
            }
        });
        XMLNodeList.prototype.clone = function() {
            return this.nodes = null;
        };
        XMLNodeList.prototype.item = function(index) {
            return this.nodes[index] || null;
        };
        return XMLNodeList;
    }();
}).call(this);

},{}],"gXsAi":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    module.exports = {
        Disconnected: 1,
        Preceding: 2,
        Following: 4,
        Contains: 8,
        ContainedBy: 16,
        ImplementationSpecific: 32
    };
}).call(this);

},{}],"7Vj0n":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLStringifier, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, hasProp = {}.hasOwnProperty;
    module.exports = XMLStringifier = function() {
        function XMLStringifier(options) {
            this.assertLegalName = bind(this.assertLegalName, this);
            this.assertLegalChar = bind(this.assertLegalChar, this);
            var key, ref, value;
            options || (options = {});
            this.options = options;
            if (!this.options.version) this.options.version = "1.0";
            ref = options.stringify || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this[key] = value;
            }
        }
        XMLStringifier.prototype.name = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalName("" + val || "");
        };
        XMLStringifier.prototype.text = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar(this.textEscape("" + val || ""));
        };
        XMLStringifier.prototype.cdata = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            val = val.replace("]]>", "]]]]><![CDATA[>");
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.comment = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            if (val.match(/--/)) throw new Error("Comment text cannot contain double-hypen: " + val);
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.raw = function(val) {
            if (this.options.noValidation) return val;
            return "" + val || "";
        };
        XMLStringifier.prototype.attValue = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar(this.attEscape(val = "" + val || ""));
        };
        XMLStringifier.prototype.insTarget = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.insValue = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            if (val.match(/\?>/)) throw new Error("Invalid processing instruction value: " + val);
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.xmlVersion = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            if (!val.match(/1\.[0-9]+/)) throw new Error("Invalid version number: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlEncoding = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) throw new Error("Invalid encoding: " + val);
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.xmlStandalone = function(val) {
            if (this.options.noValidation) return val;
            if (val) return "yes";
            else return "no";
        };
        XMLStringifier.prototype.dtdPubID = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdSysID = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdElementValue = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdAttType = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdAttDefault = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdEntityValue = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdNData = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.convertAttKey = "@";
        XMLStringifier.prototype.convertPIKey = "?";
        XMLStringifier.prototype.convertTextKey = "#text";
        XMLStringifier.prototype.convertCDataKey = "#cdata";
        XMLStringifier.prototype.convertCommentKey = "#comment";
        XMLStringifier.prototype.convertRawKey = "#raw";
        XMLStringifier.prototype.assertLegalChar = function(str) {
            var regex, res;
            if (this.options.noValidation) return str;
            regex = "";
            if (this.options.version === "1.0") {
                regex = /[\0-\x08\x0B\f\x0E-\x1F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
                if (res = str.match(regex)) throw new Error("Invalid character in string: " + str + " at index " + res.index);
            } else if (this.options.version === "1.1") {
                regex = /[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
                if (res = str.match(regex)) throw new Error("Invalid character in string: " + str + " at index " + res.index);
            }
            return str;
        };
        XMLStringifier.prototype.assertLegalName = function(str) {
            var regex;
            if (this.options.noValidation) return str;
            this.assertLegalChar(str);
            regex = /^([:A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])([\x2D\.0-:A-Z_a-z\xB7\xC0-\xD6\xD8-\xF6\xF8-\u037D\u037F-\u1FFF\u200C\u200D\u203F\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])*$/;
            if (!str.match(regex)) throw new Error("Invalid character in name");
            return str;
        };
        XMLStringifier.prototype.textEscape = function(str) {
            var ampregex;
            if (this.options.noValidation) return str;
            ampregex = this.options.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r/g, "&#xD;");
        };
        XMLStringifier.prototype.attEscape = function(str) {
            var ampregex;
            if (this.options.noValidation) return str;
            ampregex = this.options.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/\t/g, "&#x9;").replace(/\n/g, "&#xA;").replace(/\r/g, "&#xD;");
        };
        return XMLStringifier;
    }();
}).call(this);

},{}],"7x53O":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLStringWriter, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLWriterBase = require("9d52dc0ac6724da0");
    module.exports = XMLStringWriter = function(superClass) {
        extend(XMLStringWriter, superClass);
        function XMLStringWriter(options) {
            XMLStringWriter.__super__.constructor.call(this, options);
        }
        XMLStringWriter.prototype.document = function(doc, options) {
            var child, i, len, r, ref;
            options = this.filterOptions(options);
            r = "";
            ref = doc.children;
            for(i = 0, len = ref.length; i < len; i++){
                child = ref[i];
                r += this.writeChildNode(child, options, 0);
            }
            if (options.pretty && r.slice(-options.newline.length) === options.newline) r = r.slice(0, -options.newline.length);
            return r;
        };
        return XMLStringWriter;
    }(XMLWriterBase);
}).call(this);

},{"9d52dc0ac6724da0":"iAZ6h"}],"iAZ6h":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, WriterState, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLProcessingInstruction, XMLRaw, XMLText, XMLWriterBase, assign, hasProp = {}.hasOwnProperty;
    assign = require("75817c14e3dd56ca").assign;
    NodeType = require("d6d53251a09a6ee1");
    XMLDeclaration = require("9730194a8c0c4783");
    XMLDocType = require("ede7c141272b1dd5");
    XMLCData = require("a57838031903ea3f");
    XMLComment = require("f7ead1ad3653d490");
    XMLElement = require("dcc173f9e43bfc0a");
    XMLRaw = require("349c9f4a67644a6d");
    XMLText = require("6db0cc37b41855c3");
    XMLProcessingInstruction = require("167c0e9fd7f100e6");
    XMLDummy = require("15cae005a9a3ed5a");
    XMLDTDAttList = require("ce8d6b343d31d749");
    XMLDTDElement = require("2cddea69d2f73295");
    XMLDTDEntity = require("5bcc55fbd5532354");
    XMLDTDNotation = require("8beeee48423bc83");
    WriterState = require("dd94c2394fe6b644");
    module.exports = XMLWriterBase = function() {
        function XMLWriterBase(options) {
            var key, ref, value;
            options || (options = {});
            this.options = options;
            ref = options.writer || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this["_" + key] = this[key];
                this[key] = value;
            }
        }
        XMLWriterBase.prototype.filterOptions = function(options) {
            var filteredOptions, ref, ref1, ref2, ref3, ref4, ref5, ref6;
            options || (options = {});
            options = assign({}, this.options, options);
            filteredOptions = {
                writer: this
            };
            filteredOptions.pretty = options.pretty || false;
            filteredOptions.allowEmpty = options.allowEmpty || false;
            filteredOptions.indent = (ref = options.indent) != null ? ref : "  ";
            filteredOptions.newline = (ref1 = options.newline) != null ? ref1 : "\n";
            filteredOptions.offset = (ref2 = options.offset) != null ? ref2 : 0;
            filteredOptions.dontPrettyTextNodes = (ref3 = (ref4 = options.dontPrettyTextNodes) != null ? ref4 : options.dontprettytextnodes) != null ? ref3 : 0;
            filteredOptions.spaceBeforeSlash = (ref5 = (ref6 = options.spaceBeforeSlash) != null ? ref6 : options.spacebeforeslash) != null ? ref5 : "";
            if (filteredOptions.spaceBeforeSlash === true) filteredOptions.spaceBeforeSlash = " ";
            filteredOptions.suppressPrettyCount = 0;
            filteredOptions.user = {};
            filteredOptions.state = WriterState.None;
            return filteredOptions;
        };
        XMLWriterBase.prototype.indent = function(node, options, level) {
            var indentLevel;
            if (!options.pretty || options.suppressPrettyCount) return "";
            else if (options.pretty) {
                indentLevel = (level || 0) + options.offset + 1;
                if (indentLevel > 0) return new Array(indentLevel).join(options.indent);
            }
            return "";
        };
        XMLWriterBase.prototype.endline = function(node, options, level) {
            if (!options.pretty || options.suppressPrettyCount) return "";
            else return options.newline;
        };
        XMLWriterBase.prototype.attribute = function(att, options, level) {
            var r;
            this.openAttribute(att, options, level);
            r = " " + att.name + '="' + att.value + '"';
            this.closeAttribute(att, options, level);
            return r;
        };
        XMLWriterBase.prototype.cdata = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<![CDATA[";
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += "]]>" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.comment = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!-- ";
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += " -->" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.declaration = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<?xml";
            options.state = WriterState.InsideTag;
            r += ' version="' + node.version + '"';
            if (node.encoding != null) r += ' encoding="' + node.encoding + '"';
            if (node.standalone != null) r += ' standalone="' + node.standalone + '"';
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + "?>";
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.docType = function(node, options, level) {
            var child, i, len, r, ref;
            level || (level = 0);
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level);
            r += "<!DOCTYPE " + node.root().name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            if (node.children.length > 0) {
                r += " [";
                r += this.endline(node, options, level);
                options.state = WriterState.InsideTag;
                ref = node.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    r += this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                r += "]";
            }
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">";
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.element = function(node, options, level) {
            var att, child, childNodeCount, firstChildNode, i, j, len, len1, name, prettySuppressed, r, ref, ref1, ref2;
            level || (level = 0);
            prettySuppressed = false;
            r = "";
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r += this.indent(node, options, level) + "<" + node.name;
            ref = node.attribs;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                r += this.attribute(att, options, level);
            }
            childNodeCount = node.children.length;
            firstChildNode = childNodeCount === 0 ? null : node.children[0];
            if (childNodeCount === 0 || node.children.every(function(e) {
                return (e.type === NodeType.Text || e.type === NodeType.Raw) && e.value === "";
            })) {
                if (options.allowEmpty) {
                    r += ">";
                    options.state = WriterState.CloseTag;
                    r += "</" + node.name + ">" + this.endline(node, options, level);
                } else {
                    options.state = WriterState.CloseTag;
                    r += options.spaceBeforeSlash + "/>" + this.endline(node, options, level);
                }
            } else if (options.pretty && childNodeCount === 1 && (firstChildNode.type === NodeType.Text || firstChildNode.type === NodeType.Raw) && firstChildNode.value != null) {
                r += ">";
                options.state = WriterState.InsideTag;
                options.suppressPrettyCount++;
                prettySuppressed = true;
                r += this.writeChildNode(firstChildNode, options, level + 1);
                options.suppressPrettyCount--;
                prettySuppressed = false;
                options.state = WriterState.CloseTag;
                r += "</" + node.name + ">" + this.endline(node, options, level);
            } else {
                if (options.dontPrettyTextNodes) {
                    ref1 = node.children;
                    for(i = 0, len = ref1.length; i < len; i++){
                        child = ref1[i];
                        if ((child.type === NodeType.Text || child.type === NodeType.Raw) && child.value != null) {
                            options.suppressPrettyCount++;
                            prettySuppressed = true;
                            break;
                        }
                    }
                }
                r += ">" + this.endline(node, options, level);
                options.state = WriterState.InsideTag;
                ref2 = node.children;
                for(j = 0, len1 = ref2.length; j < len1; j++){
                    child = ref2[j];
                    r += this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                r += this.indent(node, options, level) + "</" + node.name + ">";
                if (prettySuppressed) options.suppressPrettyCount--;
                r += this.endline(node, options, level);
                options.state = WriterState.None;
            }
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.writeChildNode = function(node, options, level) {
            switch(node.type){
                case NodeType.CData:
                    return this.cdata(node, options, level);
                case NodeType.Comment:
                    return this.comment(node, options, level);
                case NodeType.Element:
                    return this.element(node, options, level);
                case NodeType.Raw:
                    return this.raw(node, options, level);
                case NodeType.Text:
                    return this.text(node, options, level);
                case NodeType.ProcessingInstruction:
                    return this.processingInstruction(node, options, level);
                case NodeType.Dummy:
                    return "";
                case NodeType.Declaration:
                    return this.declaration(node, options, level);
                case NodeType.DocType:
                    return this.docType(node, options, level);
                case NodeType.AttributeDeclaration:
                    return this.dtdAttList(node, options, level);
                case NodeType.ElementDeclaration:
                    return this.dtdElement(node, options, level);
                case NodeType.EntityDeclaration:
                    return this.dtdEntity(node, options, level);
                case NodeType.NotationDeclaration:
                    return this.dtdNotation(node, options, level);
                default:
                    throw new Error("Unknown XML node type: " + node.constructor.name);
            }
        };
        XMLWriterBase.prototype.processingInstruction = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<?";
            options.state = WriterState.InsideTag;
            r += node.target;
            if (node.value) r += " " + node.value;
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + "?>";
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.raw = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level);
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.text = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level);
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.dtdAttList = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!ATTLIST";
            options.state = WriterState.InsideTag;
            r += " " + node.elementName + " " + node.attributeName + " " + node.attributeType;
            if (node.defaultValueType !== "#DEFAULT") r += " " + node.defaultValueType;
            if (node.defaultValue) r += ' "' + node.defaultValue + '"';
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.dtdElement = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!ELEMENT";
            options.state = WriterState.InsideTag;
            r += " " + node.name + " " + node.value;
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.dtdEntity = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!ENTITY";
            options.state = WriterState.InsideTag;
            if (node.pe) r += " %";
            r += " " + node.name;
            if (node.value) r += ' "' + node.value + '"';
            else {
                if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
                if (node.nData) r += " NDATA " + node.nData;
            }
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.dtdNotation = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!NOTATION";
            options.state = WriterState.InsideTag;
            r += " " + node.name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.pubID) r += ' PUBLIC "' + node.pubID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.openNode = function(node, options, level) {};
        XMLWriterBase.prototype.closeNode = function(node, options, level) {};
        XMLWriterBase.prototype.openAttribute = function(att, options, level) {};
        XMLWriterBase.prototype.closeAttribute = function(att, options, level) {};
        return XMLWriterBase;
    }();
}).call(this);

},{"75817c14e3dd56ca":"1HtuW","d6d53251a09a6ee1":"jdzc3","9730194a8c0c4783":"fQz7p","ede7c141272b1dd5":"7ceju","a57838031903ea3f":"6Kwjh","f7ead1ad3653d490":"UeePz","dcc173f9e43bfc0a":"FUSD2","349c9f4a67644a6d":"4xqyS","6db0cc37b41855c3":"c3oFr","167c0e9fd7f100e6":"a4dKY","15cae005a9a3ed5a":"bEsnF","ce8d6b343d31d749":"wLxwc","2cddea69d2f73295":"beBpN","5bcc55fbd5532354":"hJVIJ","8beeee48423bc83":"5IZ5H","dd94c2394fe6b644":"6PvqX"}],"6PvqX":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    module.exports = {
        None: 0,
        OpenTag: 1,
        InsideTag: 2,
        CloseTag: 3
    };
}).call(this);

},{}],"asgnZ":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, WriterState, XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocument, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, getValue, isFunction, isObject, isPlainObject, ref, hasProp = {}.hasOwnProperty;
    ref = require("4a0b6b137d547786"), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject, getValue = ref.getValue;
    NodeType = require("97c418eb43415d1");
    XMLDocument = require("bbdde255e9b44c2a");
    XMLElement = require("7caa93eaeb2c96a7");
    XMLCData = require("e6175a20b2232a77");
    XMLComment = require("b035b3e1bd26442f");
    XMLRaw = require("526deec19abea5fe");
    XMLText = require("55ab1233b224d930");
    XMLProcessingInstruction = require("d22472ac05d87f1c");
    XMLDeclaration = require("39cdad257f5d6100");
    XMLDocType = require("9cbc536e76baf6e7");
    XMLDTDAttList = require("f30e4e8b2fd7fcd0");
    XMLDTDEntity = require("191528b53de83946");
    XMLDTDElement = require("1817e86507e2f1b4");
    XMLDTDNotation = require("26d62c2b781ea9d6");
    XMLAttribute = require("8e92d10ad0cfdf87");
    XMLStringifier = require("d654416cbe0a799d");
    XMLStringWriter = require("bb156ac07b50c66a");
    WriterState = require("ba39b9e659007a91");
    module.exports = XMLDocumentCB = function() {
        function XMLDocumentCB(options, onData, onEnd) {
            var writerOptions;
            this.name = "?xml";
            this.type = NodeType.Document;
            options || (options = {});
            writerOptions = {};
            if (!options.writer) options.writer = new XMLStringWriter();
            else if (isPlainObject(options.writer)) {
                writerOptions = options.writer;
                options.writer = new XMLStringWriter();
            }
            this.options = options;
            this.writer = options.writer;
            this.writerOptions = this.writer.filterOptions(writerOptions);
            this.stringify = new XMLStringifier(options);
            this.onDataCallback = onData || function() {};
            this.onEndCallback = onEnd || function() {};
            this.currentNode = null;
            this.currentLevel = -1;
            this.openTags = {};
            this.documentStarted = false;
            this.documentCompleted = false;
            this.root = null;
        }
        XMLDocumentCB.prototype.createChildNode = function(node) {
            var att, attName, attributes, child, i, len, ref1, ref2;
            switch(node.type){
                case NodeType.CData:
                    this.cdata(node.value);
                    break;
                case NodeType.Comment:
                    this.comment(node.value);
                    break;
                case NodeType.Element:
                    attributes = {};
                    ref1 = node.attribs;
                    for(attName in ref1){
                        if (!hasProp.call(ref1, attName)) continue;
                        att = ref1[attName];
                        attributes[attName] = att.value;
                    }
                    this.node(node.name, attributes);
                    break;
                case NodeType.Dummy:
                    this.dummy();
                    break;
                case NodeType.Raw:
                    this.raw(node.value);
                    break;
                case NodeType.Text:
                    this.text(node.value);
                    break;
                case NodeType.ProcessingInstruction:
                    this.instruction(node.target, node.value);
                    break;
                default:
                    throw new Error("This XML node type is not supported in a JS object: " + node.constructor.name);
            }
            ref2 = node.children;
            for(i = 0, len = ref2.length; i < len; i++){
                child = ref2[i];
                this.createChildNode(child);
                if (child.type === NodeType.Element) this.up();
            }
            return this;
        };
        XMLDocumentCB.prototype.dummy = function() {
            return this;
        };
        XMLDocumentCB.prototype.node = function(name, attributes, text) {
            var ref1;
            if (name == null) throw new Error("Missing node name.");
            if (this.root && this.currentLevel === -1) throw new Error("Document can only have one root node. " + this.debugInfo(name));
            this.openCurrent();
            name = getValue(name);
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref1 = [
                attributes,
                text
            ], text = ref1[0], attributes = ref1[1];
            this.currentNode = new XMLElement(this, name, attributes);
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            if (text != null) this.text(text);
            return this;
        };
        XMLDocumentCB.prototype.element = function(name, attributes, text) {
            var child, i, len, oldValidationFlag, ref1, root;
            if (this.currentNode && this.currentNode.type === NodeType.DocType) this.dtdElement.apply(this, arguments);
            else if (Array.isArray(name) || isObject(name) || isFunction(name)) {
                oldValidationFlag = this.options.noValidation;
                this.options.noValidation = true;
                root = new XMLDocument(this.options).element("TEMP_ROOT");
                root.element(name);
                this.options.noValidation = oldValidationFlag;
                ref1 = root.children;
                for(i = 0, len = ref1.length; i < len; i++){
                    child = ref1[i];
                    this.createChildNode(child);
                    if (child.type === NodeType.Element) this.up();
                }
            } else this.node(name, attributes, text);
            return this;
        };
        XMLDocumentCB.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (!this.currentNode || this.currentNode.children) throw new Error("att() can only be used immediately after an ele() call in callback mode. " + this.debugInfo(name));
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (this.options.keepNullAttributes && value == null) this.currentNode.attribs[name] = new XMLAttribute(this, name, "");
                else if (value != null) this.currentNode.attribs[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLDocumentCB.prototype.text = function(value) {
            var node;
            this.openCurrent();
            node = new XMLText(this, value);
            this.onData(this.writer.text(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.cdata = function(value) {
            var node;
            this.openCurrent();
            node = new XMLCData(this, value);
            this.onData(this.writer.cdata(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.comment = function(value) {
            var node;
            this.openCurrent();
            node = new XMLComment(this, value);
            this.onData(this.writer.comment(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.raw = function(value) {
            var node;
            this.openCurrent();
            node = new XMLRaw(this, value);
            this.onData(this.writer.raw(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.instruction = function(target, value) {
            var i, insTarget, insValue, len, node;
            this.openCurrent();
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(i = 0, len = target.length; i < len; i++){
                insTarget = target[i];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                node = new XMLProcessingInstruction(this, target, value);
                this.onData(this.writer.processingInstruction(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            }
            return this;
        };
        XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
            var node;
            this.openCurrent();
            if (this.documentStarted) throw new Error("declaration() must be the first node.");
            node = new XMLDeclaration(this, version, encoding, standalone);
            this.onData(this.writer.declaration(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
            this.openCurrent();
            if (root == null) throw new Error("Missing root node name.");
            if (this.root) throw new Error("dtd() must come before the root node.");
            this.currentNode = new XMLDocType(this, pubID, sysID);
            this.currentNode.rootNodeName = root;
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            return this;
        };
        XMLDocumentCB.prototype.dtdElement = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDElement(this, name, value);
            this.onData(this.writer.dtdElement(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var node;
            this.openCurrent();
            node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.onData(this.writer.dtdAttList(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.entity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, false, name, value);
            this.onData(this.writer.dtdEntity(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.pEntity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, true, name, value);
            this.onData(this.writer.dtdEntity(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.notation = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDNotation(this, name, value);
            this.onData(this.writer.dtdNotation(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.up = function() {
            if (this.currentLevel < 0) throw new Error("The document node has no parent.");
            if (this.currentNode) {
                if (this.currentNode.children) this.closeNode(this.currentNode);
                else this.openNode(this.currentNode);
                this.currentNode = null;
            } else this.closeNode(this.openTags[this.currentLevel]);
            delete this.openTags[this.currentLevel];
            this.currentLevel--;
            return this;
        };
        XMLDocumentCB.prototype.end = function() {
            while(this.currentLevel >= 0)this.up();
            return this.onEnd();
        };
        XMLDocumentCB.prototype.openCurrent = function() {
            if (this.currentNode) {
                this.currentNode.children = true;
                return this.openNode(this.currentNode);
            }
        };
        XMLDocumentCB.prototype.openNode = function(node) {
            var att, chunk, name, ref1;
            if (!node.isOpen) {
                if (!this.root && this.currentLevel === 0 && node.type === NodeType.Element) this.root = node;
                chunk = "";
                if (node.type === NodeType.Element) {
                    this.writerOptions.state = WriterState.OpenTag;
                    chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + "<" + node.name;
                    ref1 = node.attribs;
                    for(name in ref1){
                        if (!hasProp.call(ref1, name)) continue;
                        att = ref1[name];
                        chunk += this.writer.attribute(att, this.writerOptions, this.currentLevel);
                    }
                    chunk += (node.children ? ">" : "/>") + this.writer.endline(node, this.writerOptions, this.currentLevel);
                    this.writerOptions.state = WriterState.InsideTag;
                } else {
                    this.writerOptions.state = WriterState.OpenTag;
                    chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + "<!DOCTYPE " + node.rootNodeName;
                    if (node.pubID && node.sysID) chunk += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                    else if (node.sysID) chunk += ' SYSTEM "' + node.sysID + '"';
                    if (node.children) {
                        chunk += " [";
                        this.writerOptions.state = WriterState.InsideTag;
                    } else {
                        this.writerOptions.state = WriterState.CloseTag;
                        chunk += ">";
                    }
                    chunk += this.writer.endline(node, this.writerOptions, this.currentLevel);
                }
                this.onData(chunk, this.currentLevel);
                return node.isOpen = true;
            }
        };
        XMLDocumentCB.prototype.closeNode = function(node) {
            var chunk;
            if (!node.isClosed) {
                chunk = "";
                this.writerOptions.state = WriterState.CloseTag;
                if (node.type === NodeType.Element) chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + "</" + node.name + ">" + this.writer.endline(node, this.writerOptions, this.currentLevel);
                else chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + "]>" + this.writer.endline(node, this.writerOptions, this.currentLevel);
                this.writerOptions.state = WriterState.None;
                this.onData(chunk, this.currentLevel);
                return node.isClosed = true;
            }
        };
        XMLDocumentCB.prototype.onData = function(chunk, level) {
            this.documentStarted = true;
            return this.onDataCallback(chunk, level + 1);
        };
        XMLDocumentCB.prototype.onEnd = function() {
            this.documentCompleted = true;
            return this.onEndCallback();
        };
        XMLDocumentCB.prototype.debugInfo = function(name) {
            if (name == null) return "";
            else return "node: <" + name + ">";
        };
        XMLDocumentCB.prototype.ele = function() {
            return this.element.apply(this, arguments);
        };
        XMLDocumentCB.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
            return this.doctype(root, pubID, sysID);
        };
        XMLDocumentCB.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLDocumentCB.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.t = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLDocumentCB.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.att = function() {
            if (this.currentNode && this.currentNode.type === NodeType.DocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.a = function() {
            if (this.currentNode && this.currentNode.type === NodeType.DocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocumentCB.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocumentCB.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        return XMLDocumentCB;
    }();
}).call(this);

},{"4a0b6b137d547786":"1HtuW","97c418eb43415d1":"jdzc3","bbdde255e9b44c2a":"c9FJh","7caa93eaeb2c96a7":"FUSD2","e6175a20b2232a77":"6Kwjh","b035b3e1bd26442f":"UeePz","526deec19abea5fe":"4xqyS","55ab1233b224d930":"c3oFr","d22472ac05d87f1c":"a4dKY","39cdad257f5d6100":"fQz7p","9cbc536e76baf6e7":"7ceju","f30e4e8b2fd7fcd0":"wLxwc","191528b53de83946":"hJVIJ","1817e86507e2f1b4":"beBpN","26d62c2b781ea9d6":"5IZ5H","8e92d10ad0cfdf87":"24JgK","d654416cbe0a799d":"7Vj0n","bb156ac07b50c66a":"7x53O","ba39b9e659007a91":"6PvqX"}],"a6RUH":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, WriterState, XMLStreamWriter, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = require("2724c4fa3231a13e");
    XMLWriterBase = require("b06c90945fd90755");
    WriterState = require("f344b6746962647f");
    module.exports = XMLStreamWriter = function(superClass) {
        extend(XMLStreamWriter, superClass);
        function XMLStreamWriter(stream, options) {
            this.stream = stream;
            XMLStreamWriter.__super__.constructor.call(this, options);
        }
        XMLStreamWriter.prototype.endline = function(node, options, level) {
            if (node.isLastRootNode && options.state === WriterState.CloseTag) return "";
            else return XMLStreamWriter.__super__.endline.call(this, node, options, level);
        };
        XMLStreamWriter.prototype.document = function(doc, options) {
            var child, i, j, k, len, len1, ref, ref1, results;
            ref = doc.children;
            for(i = j = 0, len = ref.length; j < len; i = ++j){
                child = ref[i];
                child.isLastRootNode = i === doc.children.length - 1;
            }
            options = this.filterOptions(options);
            ref1 = doc.children;
            results = [];
            for(k = 0, len1 = ref1.length; k < len1; k++){
                child = ref1[k];
                results.push(this.writeChildNode(child, options, 0));
            }
            return results;
        };
        XMLStreamWriter.prototype.attribute = function(att, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.attribute.call(this, att, options, level));
        };
        XMLStreamWriter.prototype.cdata = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.cdata.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.comment = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.comment.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.declaration = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.declaration.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.docType = function(node, options, level) {
            var child, j, len, ref;
            level || (level = 0);
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            this.stream.write(this.indent(node, options, level));
            this.stream.write("<!DOCTYPE " + node.root().name);
            if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
            else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
            if (node.children.length > 0) {
                this.stream.write(" [");
                this.stream.write(this.endline(node, options, level));
                options.state = WriterState.InsideTag;
                ref = node.children;
                for(j = 0, len = ref.length; j < len; j++){
                    child = ref[j];
                    this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                this.stream.write("]");
            }
            options.state = WriterState.CloseTag;
            this.stream.write(options.spaceBeforeSlash + ">");
            this.stream.write(this.endline(node, options, level));
            options.state = WriterState.None;
            return this.closeNode(node, options, level);
        };
        XMLStreamWriter.prototype.element = function(node, options, level) {
            var att, child, childNodeCount, firstChildNode, j, len, name, prettySuppressed, ref, ref1;
            level || (level = 0);
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            this.stream.write(this.indent(node, options, level) + "<" + node.name);
            ref = node.attribs;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                this.attribute(att, options, level);
            }
            childNodeCount = node.children.length;
            firstChildNode = childNodeCount === 0 ? null : node.children[0];
            if (childNodeCount === 0 || node.children.every(function(e) {
                return (e.type === NodeType.Text || e.type === NodeType.Raw) && e.value === "";
            })) {
                if (options.allowEmpty) {
                    this.stream.write(">");
                    options.state = WriterState.CloseTag;
                    this.stream.write("</" + node.name + ">");
                } else {
                    options.state = WriterState.CloseTag;
                    this.stream.write(options.spaceBeforeSlash + "/>");
                }
            } else if (options.pretty && childNodeCount === 1 && (firstChildNode.type === NodeType.Text || firstChildNode.type === NodeType.Raw) && firstChildNode.value != null) {
                this.stream.write(">");
                options.state = WriterState.InsideTag;
                options.suppressPrettyCount++;
                prettySuppressed = true;
                this.writeChildNode(firstChildNode, options, level + 1);
                options.suppressPrettyCount--;
                prettySuppressed = false;
                options.state = WriterState.CloseTag;
                this.stream.write("</" + node.name + ">");
            } else {
                this.stream.write(">" + this.endline(node, options, level));
                options.state = WriterState.InsideTag;
                ref1 = node.children;
                for(j = 0, len = ref1.length; j < len; j++){
                    child = ref1[j];
                    this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                this.stream.write(this.indent(node, options, level) + "</" + node.name + ">");
            }
            this.stream.write(this.endline(node, options, level));
            options.state = WriterState.None;
            return this.closeNode(node, options, level);
        };
        XMLStreamWriter.prototype.processingInstruction = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.processingInstruction.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.raw = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.raw.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.text = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.text.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.dtdAttList = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.dtdAttList.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.dtdElement = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.dtdElement.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.dtdEntity = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.dtdEntity.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.dtdNotation = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.dtdNotation.call(this, node, options, level));
        };
        return XMLStreamWriter;
    }(XMLWriterBase);
}).call(this);

},{"2724c4fa3231a13e":"jdzc3","b06c90945fd90755":"iAZ6h","f344b6746962647f":"6PvqX"}],"PM6AC":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    var bom, defaults, events, isEmpty, processItem, processors, sax, setImmediate, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    sax = require("13410777db2f54ad");
    events = require("d9a5d36551474a58");
    bom = require("8551b3c8f0063f8b");
    processors = require("7ac38f981f246dd7");
    setImmediate = require("524970f650843682").setImmediate;
    defaults = require("657f91eda6e269d2").defaults;
    isEmpty = function(thing) {
        return typeof thing === "object" && thing != null && Object.keys(thing).length === 0;
    };
    processItem = function(processors, item, key) {
        var i, len, process;
        for(i = 0, len = processors.length; i < len; i++){
            process = processors[i];
            item = process(item, key);
        }
        return item;
    };
    exports.Parser = function(superClass) {
        extend(Parser, superClass);
        function Parser(opts) {
            this.parseStringPromise = bind(this.parseStringPromise, this);
            this.parseString = bind(this.parseString, this);
            this.reset = bind(this.reset, this);
            this.assignOrPush = bind(this.assignOrPush, this);
            this.processAsync = bind(this.processAsync, this);
            var key, ref, value;
            if (!(this instanceof exports.Parser)) return new exports.Parser(opts);
            this.options = {};
            ref = defaults["0.2"];
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this.options[key] = value;
            }
            for(key in opts){
                if (!hasProp.call(opts, key)) continue;
                value = opts[key];
                this.options[key] = value;
            }
            if (this.options.xmlns) this.options.xmlnskey = this.options.attrkey + "ns";
            if (this.options.normalizeTags) {
                if (!this.options.tagNameProcessors) this.options.tagNameProcessors = [];
                this.options.tagNameProcessors.unshift(processors.normalize);
            }
            this.reset();
        }
        Parser.prototype.processAsync = function() {
            var chunk, err;
            try {
                if (this.remaining.length <= this.options.chunkSize) {
                    chunk = this.remaining;
                    this.remaining = "";
                    this.saxParser = this.saxParser.write(chunk);
                    return this.saxParser.close();
                } else {
                    chunk = this.remaining.substr(0, this.options.chunkSize);
                    this.remaining = this.remaining.substr(this.options.chunkSize, this.remaining.length);
                    this.saxParser = this.saxParser.write(chunk);
                    return setImmediate(this.processAsync);
                }
            } catch (error1) {
                err = error1;
                if (!this.saxParser.errThrown) {
                    this.saxParser.errThrown = true;
                    return this.emit(err);
                }
            }
        };
        Parser.prototype.assignOrPush = function(obj, key, newValue) {
            if (!(key in obj)) {
                if (!this.options.explicitArray) return obj[key] = newValue;
                else return obj[key] = [
                    newValue
                ];
            } else {
                if (!(obj[key] instanceof Array)) obj[key] = [
                    obj[key]
                ];
                return obj[key].push(newValue);
            }
        };
        Parser.prototype.reset = function() {
            var attrkey, charkey, ontext, stack;
            this.removeAllListeners();
            this.saxParser = sax.parser(this.options.strict, {
                trim: false,
                normalize: false,
                xmlns: this.options.xmlns
            });
            this.saxParser.errThrown = false;
            this.saxParser.onerror = function(_this) {
                return function(error) {
                    _this.saxParser.resume();
                    if (!_this.saxParser.errThrown) {
                        _this.saxParser.errThrown = true;
                        return _this.emit("error", error);
                    }
                };
            }(this);
            this.saxParser.onend = function(_this) {
                return function() {
                    if (!_this.saxParser.ended) {
                        _this.saxParser.ended = true;
                        return _this.emit("end", _this.resultObject);
                    }
                };
            }(this);
            this.saxParser.ended = false;
            this.EXPLICIT_CHARKEY = this.options.explicitCharkey;
            this.resultObject = null;
            stack = [];
            attrkey = this.options.attrkey;
            charkey = this.options.charkey;
            this.saxParser.onopentag = function(_this) {
                return function(node) {
                    var key, newValue, obj, processedKey, ref;
                    obj = {};
                    obj[charkey] = "";
                    if (!_this.options.ignoreAttrs) {
                        ref = node.attributes;
                        for(key in ref){
                            if (!hasProp.call(ref, key)) continue;
                            if (!(attrkey in obj) && !_this.options.mergeAttrs) obj[attrkey] = {};
                            newValue = _this.options.attrValueProcessors ? processItem(_this.options.attrValueProcessors, node.attributes[key], key) : node.attributes[key];
                            processedKey = _this.options.attrNameProcessors ? processItem(_this.options.attrNameProcessors, key) : key;
                            if (_this.options.mergeAttrs) _this.assignOrPush(obj, processedKey, newValue);
                            else obj[attrkey][processedKey] = newValue;
                        }
                    }
                    obj["#name"] = _this.options.tagNameProcessors ? processItem(_this.options.tagNameProcessors, node.name) : node.name;
                    if (_this.options.xmlns) obj[_this.options.xmlnskey] = {
                        uri: node.uri,
                        local: node.local
                    };
                    return stack.push(obj);
                };
            }(this);
            this.saxParser.onclosetag = function(_this) {
                return function() {
                    var cdata, emptyStr, key, node, nodeName, obj, objClone, old, s, xpath;
                    obj = stack.pop();
                    nodeName = obj["#name"];
                    if (!_this.options.explicitChildren || !_this.options.preserveChildrenOrder) delete obj["#name"];
                    if (obj.cdata === true) {
                        cdata = obj.cdata;
                        delete obj.cdata;
                    }
                    s = stack[stack.length - 1];
                    if (obj[charkey].match(/^\s*$/) && !cdata) {
                        emptyStr = obj[charkey];
                        delete obj[charkey];
                    } else {
                        if (_this.options.trim) obj[charkey] = obj[charkey].trim();
                        if (_this.options.normalize) obj[charkey] = obj[charkey].replace(/\s{2,}/g, " ").trim();
                        obj[charkey] = _this.options.valueProcessors ? processItem(_this.options.valueProcessors, obj[charkey], nodeName) : obj[charkey];
                        if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) obj = obj[charkey];
                    }
                    if (isEmpty(obj)) obj = _this.options.emptyTag !== "" ? _this.options.emptyTag : emptyStr;
                    if (_this.options.validator != null) {
                        xpath = "/" + (function() {
                            var i, len, results;
                            results = [];
                            for(i = 0, len = stack.length; i < len; i++){
                                node = stack[i];
                                results.push(node["#name"]);
                            }
                            return results;
                        })().concat(nodeName).join("/");
                        (function() {
                            var err;
                            try {
                                return obj = _this.options.validator(xpath, s && s[nodeName], obj);
                            } catch (error1) {
                                err = error1;
                                return _this.emit("error", err);
                            }
                        })();
                    }
                    if (_this.options.explicitChildren && !_this.options.mergeAttrs && typeof obj === "object") {
                        if (!_this.options.preserveChildrenOrder) {
                            node = {};
                            if (_this.options.attrkey in obj) {
                                node[_this.options.attrkey] = obj[_this.options.attrkey];
                                delete obj[_this.options.attrkey];
                            }
                            if (!_this.options.charsAsChildren && _this.options.charkey in obj) {
                                node[_this.options.charkey] = obj[_this.options.charkey];
                                delete obj[_this.options.charkey];
                            }
                            if (Object.getOwnPropertyNames(obj).length > 0) node[_this.options.childkey] = obj;
                            obj = node;
                        } else if (s) {
                            s[_this.options.childkey] = s[_this.options.childkey] || [];
                            objClone = {};
                            for(key in obj){
                                if (!hasProp.call(obj, key)) continue;
                                objClone[key] = obj[key];
                            }
                            s[_this.options.childkey].push(objClone);
                            delete obj["#name"];
                            if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) obj = obj[charkey];
                        }
                    }
                    if (stack.length > 0) return _this.assignOrPush(s, nodeName, obj);
                    else {
                        if (_this.options.explicitRoot) {
                            old = obj;
                            obj = {};
                            obj[nodeName] = old;
                        }
                        _this.resultObject = obj;
                        _this.saxParser.ended = true;
                        return _this.emit("end", _this.resultObject);
                    }
                };
            }(this);
            ontext = function(_this) {
                return function(text) {
                    var charChild, s;
                    s = stack[stack.length - 1];
                    if (s) {
                        s[charkey] += text;
                        if (_this.options.explicitChildren && _this.options.preserveChildrenOrder && _this.options.charsAsChildren && (_this.options.includeWhiteChars || text.replace(/\\n/g, "").trim() !== "")) {
                            s[_this.options.childkey] = s[_this.options.childkey] || [];
                            charChild = {
                                "#name": "__text__"
                            };
                            charChild[charkey] = text;
                            if (_this.options.normalize) charChild[charkey] = charChild[charkey].replace(/\s{2,}/g, " ").trim();
                            s[_this.options.childkey].push(charChild);
                        }
                        return s;
                    }
                };
            }(this);
            this.saxParser.ontext = ontext;
            return this.saxParser.oncdata = function(_this) {
                return function(text) {
                    var s;
                    s = ontext(text);
                    if (s) return s.cdata = true;
                };
            }(this);
        };
        Parser.prototype.parseString = function(str, cb) {
            var err;
            if (cb != null && typeof cb === "function") {
                this.on("end", function(result) {
                    this.reset();
                    return cb(null, result);
                });
                this.on("error", function(err) {
                    this.reset();
                    return cb(err);
                });
            }
            try {
                str = str.toString();
                if (str.trim() === "") {
                    this.emit("end", null);
                    return true;
                }
                str = bom.stripBOM(str);
                if (this.options.async) {
                    this.remaining = str;
                    setImmediate(this.processAsync);
                    return this.saxParser;
                }
                return this.saxParser.write(str).close();
            } catch (error1) {
                err = error1;
                if (!(this.saxParser.errThrown || this.saxParser.ended)) {
                    this.emit("error", err);
                    return this.saxParser.errThrown = true;
                } else if (this.saxParser.ended) throw err;
            }
        };
        Parser.prototype.parseStringPromise = function(str) {
            return new Promise(function(_this) {
                return function(resolve, reject) {
                    return _this.parseString(str, function(err, value) {
                        if (err) return reject(err);
                        else return resolve(value);
                    });
                };
            }(this));
        };
        return Parser;
    }(events);
    exports.parseString = function(str, a, b) {
        var cb, options, parser;
        if (b != null) {
            if (typeof b === "function") cb = b;
            if (typeof a === "object") options = a;
        } else {
            if (typeof a === "function") cb = a;
            options = {};
        }
        parser = new exports.Parser(options);
        return parser.parseString(str, cb);
    };
    exports.parseStringPromise = function(str, a) {
        var options, parser;
        if (typeof a === "object") options = a;
        parser = new exports.Parser(options);
        return parser.parseStringPromise(str);
    };
}).call(this);

},{"13410777db2f54ad":"fsy5R","d9a5d36551474a58":"fqTtD","8551b3c8f0063f8b":"8qETt","7ac38f981f246dd7":"4IawY","524970f650843682":"k5LxD","657f91eda6e269d2":"1TO0H"}],"fsy5R":[function(require,module,exports) {
var Buffer = require("e8399c94bace2e95").Buffer;
(function(sax) {
    sax.parser = function(strict, opt) {
        return new SAXParser(strict, opt);
    };
    sax.SAXParser = SAXParser;
    sax.SAXStream = SAXStream;
    sax.createStream = createStream;
    // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
    // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
    // since that's the earliest that a buffer overrun could occur.  This way, checks are
    // as rare as required, but as often as necessary to ensure never crossing this bound.
    // Furthermore, buffers are only tested at most once per write(), so passing a very
    // large string into write() might have undesirable effects, but this is manageable by
    // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
    // edge case, result in creating at most one complete copy of the string passed in.
    // Set to Infinity to have unlimited buffers.
    sax.MAX_BUFFER_LENGTH = 65536;
    var buffers = [
        "comment",
        "sgmlDecl",
        "textNode",
        "tagName",
        "doctype",
        "procInstName",
        "procInstBody",
        "entity",
        "attribName",
        "attribValue",
        "cdata",
        "script"
    ];
    sax.EVENTS = [
        "text",
        "processinginstruction",
        "sgmldeclaration",
        "doctype",
        "comment",
        "opentagstart",
        "attribute",
        "opentag",
        "closetag",
        "opencdata",
        "cdata",
        "closecdata",
        "error",
        "end",
        "ready",
        "script",
        "opennamespace",
        "closenamespace"
    ];
    function SAXParser(strict, opt) {
        if (!(this instanceof SAXParser)) return new SAXParser(strict, opt);
        var parser = this;
        clearBuffers(parser);
        parser.q = parser.c = "";
        parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
        parser.opt = opt || {};
        parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
        parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase";
        parser.tags = [];
        parser.closed = parser.closedRoot = parser.sawRoot = false;
        parser.tag = parser.error = null;
        parser.strict = !!strict;
        parser.noscript = !!(strict || parser.opt.noscript);
        parser.state = S.BEGIN;
        parser.strictEntities = parser.opt.strictEntities;
        parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
        parser.attribList = [];
        // namespaces form a prototype chain.
        // it always points at the current tag,
        // which protos to its parent tag.
        if (parser.opt.xmlns) parser.ns = Object.create(rootNS);
        // mostly just for error reporting
        parser.trackPosition = parser.opt.position !== false;
        if (parser.trackPosition) parser.position = parser.line = parser.column = 0;
        emit(parser, "onready");
    }
    if (!Object.create) Object.create = function(o) {
        function F() {}
        F.prototype = o;
        var newf = new F();
        return newf;
    };
    if (!Object.keys) Object.keys = function(o) {
        var a = [];
        for(var i in o)if (o.hasOwnProperty(i)) a.push(i);
        return a;
    };
    function checkBufferLength(parser) {
        var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
        var maxActual = 0;
        for(var i = 0, l = buffers.length; i < l; i++){
            var len = parser[buffers[i]].length;
            if (len > maxAllowed) // Text/cdata nodes can get big, and since they're buffered,
            // we can get here under normal conditions.
            // Avoid issues by emitting the text node now,
            // so at least it won't get any bigger.
            switch(buffers[i]){
                case "textNode":
                    closeText(parser);
                    break;
                case "cdata":
                    emitNode(parser, "oncdata", parser.cdata);
                    parser.cdata = "";
                    break;
                case "script":
                    emitNode(parser, "onscript", parser.script);
                    parser.script = "";
                    break;
                default:
                    error(parser, "Max buffer length exceeded: " + buffers[i]);
            }
            maxActual = Math.max(maxActual, len);
        }
        // schedule the next check for the earliest possible buffer overrun.
        var m = sax.MAX_BUFFER_LENGTH - maxActual;
        parser.bufferCheckPosition = m + parser.position;
    }
    function clearBuffers(parser) {
        for(var i = 0, l = buffers.length; i < l; i++)parser[buffers[i]] = "";
    }
    function flushBuffers(parser) {
        closeText(parser);
        if (parser.cdata !== "") {
            emitNode(parser, "oncdata", parser.cdata);
            parser.cdata = "";
        }
        if (parser.script !== "") {
            emitNode(parser, "onscript", parser.script);
            parser.script = "";
        }
    }
    SAXParser.prototype = {
        end: function() {
            end(this);
        },
        write: write,
        resume: function() {
            this.error = null;
            return this;
        },
        close: function() {
            return this.write(null);
        },
        flush: function() {
            flushBuffers(this);
        }
    };
    var Stream;
    try {
        Stream = require("55cad32d9fc3850b").Stream;
    } catch (ex) {
        Stream = function() {};
    }
    var streamWraps = sax.EVENTS.filter(function(ev) {
        return ev !== "error" && ev !== "end";
    });
    function createStream(strict, opt) {
        return new SAXStream(strict, opt);
    }
    function SAXStream(strict, opt) {
        if (!(this instanceof SAXStream)) return new SAXStream(strict, opt);
        Stream.apply(this);
        this._parser = new SAXParser(strict, opt);
        this.writable = true;
        this.readable = true;
        var me = this;
        this._parser.onend = function() {
            me.emit("end");
        };
        this._parser.onerror = function(er) {
            me.emit("error", er);
            // if didn't throw, then means error was handled.
            // go ahead and clear error, so we can write again.
            me._parser.error = null;
        };
        this._decoder = null;
        streamWraps.forEach(function(ev) {
            Object.defineProperty(me, "on" + ev, {
                get: function() {
                    return me._parser["on" + ev];
                },
                set: function(h) {
                    if (!h) {
                        me.removeAllListeners(ev);
                        me._parser["on" + ev] = h;
                        return h;
                    }
                    me.on(ev, h);
                },
                enumerable: true,
                configurable: false
            });
        });
    }
    SAXStream.prototype = Object.create(Stream.prototype, {
        constructor: {
            value: SAXStream
        }
    });
    SAXStream.prototype.write = function(data) {
        if (typeof Buffer === "function" && typeof Buffer.isBuffer === "function" && Buffer.isBuffer(data)) {
            if (!this._decoder) {
                var SD = require("f36f08810ace8da5").StringDecoder;
                this._decoder = new SD("utf8");
            }
            data = this._decoder.write(data);
        }
        this._parser.write(data.toString());
        this.emit("data", data);
        return true;
    };
    SAXStream.prototype.end = function(chunk) {
        if (chunk && chunk.length) this.write(chunk);
        this._parser.end();
        return true;
    };
    SAXStream.prototype.on = function(ev, handler) {
        var me = this;
        if (!me._parser["on" + ev] && streamWraps.indexOf(ev) !== -1) me._parser["on" + ev] = function() {
            var args = arguments.length === 1 ? [
                arguments[0]
            ] : Array.apply(null, arguments);
            args.splice(0, 0, ev);
            me.emit.apply(me, args);
        };
        return Stream.prototype.on.call(me, ev, handler);
    };
    // this really needs to be replaced with character classes.
    // XML allows all manner of ridiculous numbers and digits.
    var CDATA = "[CDATA[";
    var DOCTYPE = "DOCTYPE";
    var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
    var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
    var rootNS = {
        xml: XML_NAMESPACE,
        xmlns: XMLNS_NAMESPACE
    };
    // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
    // This implementation works on strings, a single character at a time
    // as such, it cannot ever support astral-plane characters (10000-EFFFF)
    // without a significant breaking change to either this  parser, or the
    // JavaScript language.  Implementation of an emoji-capable xml parser
    // is left as an exercise for the reader.
    var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    function isWhitespace(c) {
        return c === " " || c === "\n" || c === "\r" || c === "	";
    }
    function isQuote(c) {
        return c === '"' || c === "'";
    }
    function isAttribEnd(c) {
        return c === ">" || isWhitespace(c);
    }
    function isMatch(regex, c) {
        return regex.test(c);
    }
    function notMatch(regex, c) {
        return !isMatch(regex, c);
    }
    var S = 0;
    sax.STATE = {
        BEGIN: S++,
        BEGIN_WHITESPACE: S++,
        TEXT: S++,
        TEXT_ENTITY: S++,
        OPEN_WAKA: S++,
        SGML_DECL: S++,
        SGML_DECL_QUOTED: S++,
        DOCTYPE: S++,
        DOCTYPE_QUOTED: S++,
        DOCTYPE_DTD: S++,
        DOCTYPE_DTD_QUOTED: S++,
        COMMENT_STARTING: S++,
        COMMENT: S++,
        COMMENT_ENDING: S++,
        COMMENT_ENDED: S++,
        CDATA: S++,
        CDATA_ENDING: S++,
        CDATA_ENDING_2: S++,
        PROC_INST: S++,
        PROC_INST_BODY: S++,
        PROC_INST_ENDING: S++,
        OPEN_TAG: S++,
        OPEN_TAG_SLASH: S++,
        ATTRIB: S++,
        ATTRIB_NAME: S++,
        ATTRIB_NAME_SAW_WHITE: S++,
        ATTRIB_VALUE: S++,
        ATTRIB_VALUE_QUOTED: S++,
        ATTRIB_VALUE_CLOSED: S++,
        ATTRIB_VALUE_UNQUOTED: S++,
        ATTRIB_VALUE_ENTITY_Q: S++,
        ATTRIB_VALUE_ENTITY_U: S++,
        CLOSE_TAG: S++,
        CLOSE_TAG_SAW_WHITE: S++,
        SCRIPT: S++,
        SCRIPT_ENDING: S++ // <script> ... <
    };
    sax.XML_ENTITIES = {
        "amp": "&",
        "gt": ">",
        "lt": "<",
        "quot": '"',
        "apos": "'"
    };
    sax.ENTITIES = {
        "amp": "&",
        "gt": ">",
        "lt": "<",
        "quot": '"',
        "apos": "'",
        "AElig": 198,
        "Aacute": 193,
        "Acirc": 194,
        "Agrave": 192,
        "Aring": 197,
        "Atilde": 195,
        "Auml": 196,
        "Ccedil": 199,
        "ETH": 208,
        "Eacute": 201,
        "Ecirc": 202,
        "Egrave": 200,
        "Euml": 203,
        "Iacute": 205,
        "Icirc": 206,
        "Igrave": 204,
        "Iuml": 207,
        "Ntilde": 209,
        "Oacute": 211,
        "Ocirc": 212,
        "Ograve": 210,
        "Oslash": 216,
        "Otilde": 213,
        "Ouml": 214,
        "THORN": 222,
        "Uacute": 218,
        "Ucirc": 219,
        "Ugrave": 217,
        "Uuml": 220,
        "Yacute": 221,
        "aacute": 225,
        "acirc": 226,
        "aelig": 230,
        "agrave": 224,
        "aring": 229,
        "atilde": 227,
        "auml": 228,
        "ccedil": 231,
        "eacute": 233,
        "ecirc": 234,
        "egrave": 232,
        "eth": 240,
        "euml": 235,
        "iacute": 237,
        "icirc": 238,
        "igrave": 236,
        "iuml": 239,
        "ntilde": 241,
        "oacute": 243,
        "ocirc": 244,
        "ograve": 242,
        "oslash": 248,
        "otilde": 245,
        "ouml": 246,
        "szlig": 223,
        "thorn": 254,
        "uacute": 250,
        "ucirc": 251,
        "ugrave": 249,
        "uuml": 252,
        "yacute": 253,
        "yuml": 255,
        "copy": 169,
        "reg": 174,
        "nbsp": 160,
        "iexcl": 161,
        "cent": 162,
        "pound": 163,
        "curren": 164,
        "yen": 165,
        "brvbar": 166,
        "sect": 167,
        "uml": 168,
        "ordf": 170,
        "laquo": 171,
        "not": 172,
        "shy": 173,
        "macr": 175,
        "deg": 176,
        "plusmn": 177,
        "sup1": 185,
        "sup2": 178,
        "sup3": 179,
        "acute": 180,
        "micro": 181,
        "para": 182,
        "middot": 183,
        "cedil": 184,
        "ordm": 186,
        "raquo": 187,
        "frac14": 188,
        "frac12": 189,
        "frac34": 190,
        "iquest": 191,
        "times": 215,
        "divide": 247,
        "OElig": 338,
        "oelig": 339,
        "Scaron": 352,
        "scaron": 353,
        "Yuml": 376,
        "fnof": 402,
        "circ": 710,
        "tilde": 732,
        "Alpha": 913,
        "Beta": 914,
        "Gamma": 915,
        "Delta": 916,
        "Epsilon": 917,
        "Zeta": 918,
        "Eta": 919,
        "Theta": 920,
        "Iota": 921,
        "Kappa": 922,
        "Lambda": 923,
        "Mu": 924,
        "Nu": 925,
        "Xi": 926,
        "Omicron": 927,
        "Pi": 928,
        "Rho": 929,
        "Sigma": 931,
        "Tau": 932,
        "Upsilon": 933,
        "Phi": 934,
        "Chi": 935,
        "Psi": 936,
        "Omega": 937,
        "alpha": 945,
        "beta": 946,
        "gamma": 947,
        "delta": 948,
        "epsilon": 949,
        "zeta": 950,
        "eta": 951,
        "theta": 952,
        "iota": 953,
        "kappa": 954,
        "lambda": 955,
        "mu": 956,
        "nu": 957,
        "xi": 958,
        "omicron": 959,
        "pi": 960,
        "rho": 961,
        "sigmaf": 962,
        "sigma": 963,
        "tau": 964,
        "upsilon": 965,
        "phi": 966,
        "chi": 967,
        "psi": 968,
        "omega": 969,
        "thetasym": 977,
        "upsih": 978,
        "piv": 982,
        "ensp": 8194,
        "emsp": 8195,
        "thinsp": 8201,
        "zwnj": 8204,
        "zwj": 8205,
        "lrm": 8206,
        "rlm": 8207,
        "ndash": 8211,
        "mdash": 8212,
        "lsquo": 8216,
        "rsquo": 8217,
        "sbquo": 8218,
        "ldquo": 8220,
        "rdquo": 8221,
        "bdquo": 8222,
        "dagger": 8224,
        "Dagger": 8225,
        "bull": 8226,
        "hellip": 8230,
        "permil": 8240,
        "prime": 8242,
        "Prime": 8243,
        "lsaquo": 8249,
        "rsaquo": 8250,
        "oline": 8254,
        "frasl": 8260,
        "euro": 8364,
        "image": 8465,
        "weierp": 8472,
        "real": 8476,
        "trade": 8482,
        "alefsym": 8501,
        "larr": 8592,
        "uarr": 8593,
        "rarr": 8594,
        "darr": 8595,
        "harr": 8596,
        "crarr": 8629,
        "lArr": 8656,
        "uArr": 8657,
        "rArr": 8658,
        "dArr": 8659,
        "hArr": 8660,
        "forall": 8704,
        "part": 8706,
        "exist": 8707,
        "empty": 8709,
        "nabla": 8711,
        "isin": 8712,
        "notin": 8713,
        "ni": 8715,
        "prod": 8719,
        "sum": 8721,
        "minus": 8722,
        "lowast": 8727,
        "radic": 8730,
        "prop": 8733,
        "infin": 8734,
        "ang": 8736,
        "and": 8743,
        "or": 8744,
        "cap": 8745,
        "cup": 8746,
        "int": 8747,
        "there4": 8756,
        "sim": 8764,
        "cong": 8773,
        "asymp": 8776,
        "ne": 8800,
        "equiv": 8801,
        "le": 8804,
        "ge": 8805,
        "sub": 8834,
        "sup": 8835,
        "nsub": 8836,
        "sube": 8838,
        "supe": 8839,
        "oplus": 8853,
        "otimes": 8855,
        "perp": 8869,
        "sdot": 8901,
        "lceil": 8968,
        "rceil": 8969,
        "lfloor": 8970,
        "rfloor": 8971,
        "lang": 9001,
        "rang": 9002,
        "loz": 9674,
        "spades": 9824,
        "clubs": 9827,
        "hearts": 9829,
        "diams": 9830
    };
    Object.keys(sax.ENTITIES).forEach(function(key) {
        var e = sax.ENTITIES[key];
        var s = typeof e === "number" ? String.fromCharCode(e) : e;
        sax.ENTITIES[key] = s;
    });
    for(var s in sax.STATE)sax.STATE[sax.STATE[s]] = s;
    // shorthand
    S = sax.STATE;
    function emit(parser, event, data) {
        parser[event] && parser[event](data);
    }
    function emitNode(parser, nodeType, data) {
        if (parser.textNode) closeText(parser);
        emit(parser, nodeType, data);
    }
    function closeText(parser) {
        parser.textNode = textopts(parser.opt, parser.textNode);
        if (parser.textNode) emit(parser, "ontext", parser.textNode);
        parser.textNode = "";
    }
    function textopts(opt, text) {
        if (opt.trim) text = text.trim();
        if (opt.normalize) text = text.replace(/\s+/g, " ");
        return text;
    }
    function error(parser, er) {
        closeText(parser);
        if (parser.trackPosition) er += "\nLine: " + parser.line + "\nColumn: " + parser.column + "\nChar: " + parser.c;
        er = new Error(er);
        parser.error = er;
        emit(parser, "onerror", er);
        return parser;
    }
    function end(parser) {
        if (parser.sawRoot && !parser.closedRoot) strictFail(parser, "Unclosed root tag");
        if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) error(parser, "Unexpected end");
        closeText(parser);
        parser.c = "";
        parser.closed = true;
        emit(parser, "onend");
        SAXParser.call(parser, parser.strict, parser.opt);
        return parser;
    }
    function strictFail(parser, message) {
        if (typeof parser !== "object" || !(parser instanceof SAXParser)) throw new Error("bad call to strictFail");
        if (parser.strict) error(parser, message);
    }
    function newTag(parser) {
        if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
        var parent = parser.tags[parser.tags.length - 1] || parser;
        var tag = parser.tag = {
            name: parser.tagName,
            attributes: {}
        };
        // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
        if (parser.opt.xmlns) tag.ns = parent.ns;
        parser.attribList.length = 0;
        emitNode(parser, "onopentagstart", tag);
    }
    function qname(name, attribute) {
        var i = name.indexOf(":");
        var qualName = i < 0 ? [
            "",
            name
        ] : name.split(":");
        var prefix = qualName[0];
        var local = qualName[1];
        // <x "xmlns"="http://foo">
        if (attribute && name === "xmlns") {
            prefix = "xmlns";
            local = "";
        }
        return {
            prefix: prefix,
            local: local
        };
    }
    function attrib(parser) {
        if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]();
        if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
            parser.attribName = parser.attribValue = "";
            return;
        }
        if (parser.opt.xmlns) {
            var qn = qname(parser.attribName, true);
            var prefix = qn.prefix;
            var local = qn.local;
            if (prefix === "xmlns") {
                // namespace binding attribute. push the binding into scope
                if (local === "xml" && parser.attribValue !== XML_NAMESPACE) strictFail(parser, "xml: prefix must be bound to " + XML_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) strictFail(parser, "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                else {
                    var tag = parser.tag;
                    var parent = parser.tags[parser.tags.length - 1] || parser;
                    if (tag.ns === parent.ns) tag.ns = Object.create(parent.ns);
                    tag.ns[local] = parser.attribValue;
                }
            }
            // defer onattribute events until all attributes have been seen
            // so any new bindings can take effect. preserve attribute order
            // so deferred events can be emitted in document order
            parser.attribList.push([
                parser.attribName,
                parser.attribValue
            ]);
        } else {
            // in non-xmlns mode, we can emit the event right away
            parser.tag.attributes[parser.attribName] = parser.attribValue;
            emitNode(parser, "onattribute", {
                name: parser.attribName,
                value: parser.attribValue
            });
        }
        parser.attribName = parser.attribValue = "";
    }
    function openTag(parser, selfClosing) {
        if (parser.opt.xmlns) {
            // emit namespace binding events
            var tag = parser.tag;
            // add namespace info to tag
            var qn = qname(parser.tagName);
            tag.prefix = qn.prefix;
            tag.local = qn.local;
            tag.uri = tag.ns[qn.prefix] || "";
            if (tag.prefix && !tag.uri) {
                strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(parser.tagName));
                tag.uri = qn.prefix;
            }
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (tag.ns && parent.ns !== tag.ns) Object.keys(tag.ns).forEach(function(p) {
                emitNode(parser, "onopennamespace", {
                    prefix: p,
                    uri: tag.ns[p]
                });
            });
            // handle deferred onattribute events
            // Note: do not apply default ns to attributes:
            //   http://www.w3.org/TR/REC-xml-names/#defaulting
            for(var i = 0, l = parser.attribList.length; i < l; i++){
                var nv = parser.attribList[i];
                var name = nv[0];
                var value = nv[1];
                var qualName = qname(name, true);
                var prefix = qualName.prefix;
                var local = qualName.local;
                var uri = prefix === "" ? "" : tag.ns[prefix] || "";
                var a = {
                    name: name,
                    value: value,
                    prefix: prefix,
                    local: local,
                    uri: uri
                };
                // if there's any attributes with an undefined namespace,
                // then fail on them now.
                if (prefix && prefix !== "xmlns" && !uri) {
                    strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(prefix));
                    a.uri = prefix;
                }
                parser.tag.attributes[name] = a;
                emitNode(parser, "onattribute", a);
            }
            parser.attribList.length = 0;
        }
        parser.tag.isSelfClosing = !!selfClosing;
        // process the tag
        parser.sawRoot = true;
        parser.tags.push(parser.tag);
        emitNode(parser, "onopentag", parser.tag);
        if (!selfClosing) {
            // special case for <script> in non-strict mode.
            if (!parser.noscript && parser.tagName.toLowerCase() === "script") parser.state = S.SCRIPT;
            else parser.state = S.TEXT;
            parser.tag = null;
            parser.tagName = "";
        }
        parser.attribName = parser.attribValue = "";
        parser.attribList.length = 0;
    }
    function closeTag(parser) {
        if (!parser.tagName) {
            strictFail(parser, "Weird empty close tag.");
            parser.textNode += "</>";
            parser.state = S.TEXT;
            return;
        }
        if (parser.script) {
            if (parser.tagName !== "script") {
                parser.script += "</" + parser.tagName + ">";
                parser.tagName = "";
                parser.state = S.SCRIPT;
                return;
            }
            emitNode(parser, "onscript", parser.script);
            parser.script = "";
        }
        // first make sure that the closing tag actually exists.
        // <a><b></c></b></a> will close everything, otherwise.
        var t = parser.tags.length;
        var tagName = parser.tagName;
        if (!parser.strict) tagName = tagName[parser.looseCase]();
        var closeTo = tagName;
        while(t--){
            var close = parser.tags[t];
            if (close.name !== closeTo) // fail the first time in strict mode
            strictFail(parser, "Unexpected close tag");
            else break;
        }
        // didn't find it.  we already failed for strict, so just abort.
        if (t < 0) {
            strictFail(parser, "Unmatched closing tag: " + parser.tagName);
            parser.textNode += "</" + parser.tagName + ">";
            parser.state = S.TEXT;
            return;
        }
        parser.tagName = tagName;
        var s = parser.tags.length;
        while(s-- > t){
            var tag = parser.tag = parser.tags.pop();
            parser.tagName = parser.tag.name;
            emitNode(parser, "onclosetag", parser.tagName);
            var x = {};
            for(var i in tag.ns)x[i] = tag.ns[i];
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (parser.opt.xmlns && tag.ns !== parent.ns) // remove namespace bindings introduced by tag
            Object.keys(tag.ns).forEach(function(p) {
                var n = tag.ns[p];
                emitNode(parser, "onclosenamespace", {
                    prefix: p,
                    uri: n
                });
            });
        }
        if (t === 0) parser.closedRoot = true;
        parser.tagName = parser.attribValue = parser.attribName = "";
        parser.attribList.length = 0;
        parser.state = S.TEXT;
    }
    function parseEntity(parser) {
        var entity = parser.entity;
        var entityLC = entity.toLowerCase();
        var num;
        var numStr = "";
        if (parser.ENTITIES[entity]) return parser.ENTITIES[entity];
        if (parser.ENTITIES[entityLC]) return parser.ENTITIES[entityLC];
        entity = entityLC;
        if (entity.charAt(0) === "#") {
            if (entity.charAt(1) === "x") {
                entity = entity.slice(2);
                num = parseInt(entity, 16);
                numStr = num.toString(16);
            } else {
                entity = entity.slice(1);
                num = parseInt(entity, 10);
                numStr = num.toString(10);
            }
        }
        entity = entity.replace(/^0+/, "");
        if (isNaN(num) || numStr.toLowerCase() !== entity) {
            strictFail(parser, "Invalid character entity");
            return "&" + parser.entity + ";";
        }
        return String.fromCodePoint(num);
    }
    function beginWhiteSpace(parser, c) {
        if (c === "<") {
            parser.state = S.OPEN_WAKA;
            parser.startTagPosition = parser.position;
        } else if (!isWhitespace(c)) {
            // have to process this as a text node.
            // weird, but happens.
            strictFail(parser, "Non-whitespace before first tag.");
            parser.textNode = c;
            parser.state = S.TEXT;
        }
    }
    function charAt(chunk, i) {
        var result = "";
        if (i < chunk.length) result = chunk.charAt(i);
        return result;
    }
    function write(chunk) {
        var parser = this;
        if (this.error) throw this.error;
        if (parser.closed) return error(parser, "Cannot write after close. Assign an onready handler.");
        if (chunk === null) return end(parser);
        if (typeof chunk === "object") chunk = chunk.toString();
        var i = 0;
        var c = "";
        while(true){
            c = charAt(chunk, i++);
            parser.c = c;
            if (!c) break;
            if (parser.trackPosition) {
                parser.position++;
                if (c === "\n") {
                    parser.line++;
                    parser.column = 0;
                } else parser.column++;
            }
            switch(parser.state){
                case S.BEGIN:
                    parser.state = S.BEGIN_WHITESPACE;
                    if (c === "\uFEFF") continue;
                    beginWhiteSpace(parser, c);
                    continue;
                case S.BEGIN_WHITESPACE:
                    beginWhiteSpace(parser, c);
                    continue;
                case S.TEXT:
                    if (parser.sawRoot && !parser.closedRoot) {
                        var starti = i - 1;
                        while(c && c !== "<" && c !== "&"){
                            c = charAt(chunk, i++);
                            if (c && parser.trackPosition) {
                                parser.position++;
                                if (c === "\n") {
                                    parser.line++;
                                    parser.column = 0;
                                } else parser.column++;
                            }
                        }
                        parser.textNode += chunk.substring(starti, i - 1);
                    }
                    if (c === "<" && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                        parser.state = S.OPEN_WAKA;
                        parser.startTagPosition = parser.position;
                    } else {
                        if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) strictFail(parser, "Text data outside of root node.");
                        if (c === "&") parser.state = S.TEXT_ENTITY;
                        else parser.textNode += c;
                    }
                    continue;
                case S.SCRIPT:
                    // only non-strict
                    if (c === "<") parser.state = S.SCRIPT_ENDING;
                    else parser.script += c;
                    continue;
                case S.SCRIPT_ENDING:
                    if (c === "/") parser.state = S.CLOSE_TAG;
                    else {
                        parser.script += "<" + c;
                        parser.state = S.SCRIPT;
                    }
                    continue;
                case S.OPEN_WAKA:
                    // either a /, ?, !, or text is coming next.
                    if (c === "!") {
                        parser.state = S.SGML_DECL;
                        parser.sgmlDecl = "";
                    } else if (isWhitespace(c)) ;
                    else if (isMatch(nameStart, c)) {
                        parser.state = S.OPEN_TAG;
                        parser.tagName = c;
                    } else if (c === "/") {
                        parser.state = S.CLOSE_TAG;
                        parser.tagName = "";
                    } else if (c === "?") {
                        parser.state = S.PROC_INST;
                        parser.procInstName = parser.procInstBody = "";
                    } else {
                        strictFail(parser, "Unencoded <");
                        // if there was some whitespace, then add that in.
                        if (parser.startTagPosition + 1 < parser.position) {
                            var pad = parser.position - parser.startTagPosition;
                            c = new Array(pad).join(" ") + c;
                        }
                        parser.textNode += "<" + c;
                        parser.state = S.TEXT;
                    }
                    continue;
                case S.SGML_DECL:
                    if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                        emitNode(parser, "onopencdata");
                        parser.state = S.CDATA;
                        parser.sgmlDecl = "";
                        parser.cdata = "";
                    } else if (parser.sgmlDecl + c === "--") {
                        parser.state = S.COMMENT;
                        parser.comment = "";
                        parser.sgmlDecl = "";
                    } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                        parser.state = S.DOCTYPE;
                        if (parser.doctype || parser.sawRoot) strictFail(parser, "Inappropriately located doctype declaration");
                        parser.doctype = "";
                        parser.sgmlDecl = "";
                    } else if (c === ">") {
                        emitNode(parser, "onsgmldeclaration", parser.sgmlDecl);
                        parser.sgmlDecl = "";
                        parser.state = S.TEXT;
                    } else if (isQuote(c)) {
                        parser.state = S.SGML_DECL_QUOTED;
                        parser.sgmlDecl += c;
                    } else parser.sgmlDecl += c;
                    continue;
                case S.SGML_DECL_QUOTED:
                    if (c === parser.q) {
                        parser.state = S.SGML_DECL;
                        parser.q = "";
                    }
                    parser.sgmlDecl += c;
                    continue;
                case S.DOCTYPE:
                    if (c === ">") {
                        parser.state = S.TEXT;
                        emitNode(parser, "ondoctype", parser.doctype);
                        parser.doctype = true // just remember that we saw it.
                        ;
                    } else {
                        parser.doctype += c;
                        if (c === "[") parser.state = S.DOCTYPE_DTD;
                        else if (isQuote(c)) {
                            parser.state = S.DOCTYPE_QUOTED;
                            parser.q = c;
                        }
                    }
                    continue;
                case S.DOCTYPE_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.q = "";
                        parser.state = S.DOCTYPE;
                    }
                    continue;
                case S.DOCTYPE_DTD:
                    parser.doctype += c;
                    if (c === "]") parser.state = S.DOCTYPE;
                    else if (isQuote(c)) {
                        parser.state = S.DOCTYPE_DTD_QUOTED;
                        parser.q = c;
                    }
                    continue;
                case S.DOCTYPE_DTD_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.state = S.DOCTYPE_DTD;
                        parser.q = "";
                    }
                    continue;
                case S.COMMENT:
                    if (c === "-") parser.state = S.COMMENT_ENDING;
                    else parser.comment += c;
                    continue;
                case S.COMMENT_ENDING:
                    if (c === "-") {
                        parser.state = S.COMMENT_ENDED;
                        parser.comment = textopts(parser.opt, parser.comment);
                        if (parser.comment) emitNode(parser, "oncomment", parser.comment);
                        parser.comment = "";
                    } else {
                        parser.comment += "-" + c;
                        parser.state = S.COMMENT;
                    }
                    continue;
                case S.COMMENT_ENDED:
                    if (c !== ">") {
                        strictFail(parser, "Malformed comment");
                        // allow <!-- blah -- bloo --> in non-strict mode,
                        // which is a comment of " blah -- bloo "
                        parser.comment += "--" + c;
                        parser.state = S.COMMENT;
                    } else parser.state = S.TEXT;
                    continue;
                case S.CDATA:
                    if (c === "]") parser.state = S.CDATA_ENDING;
                    else parser.cdata += c;
                    continue;
                case S.CDATA_ENDING:
                    if (c === "]") parser.state = S.CDATA_ENDING_2;
                    else {
                        parser.cdata += "]" + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.CDATA_ENDING_2:
                    if (c === ">") {
                        if (parser.cdata) emitNode(parser, "oncdata", parser.cdata);
                        emitNode(parser, "onclosecdata");
                        parser.cdata = "";
                        parser.state = S.TEXT;
                    } else if (c === "]") parser.cdata += "]";
                    else {
                        parser.cdata += "]]" + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.PROC_INST:
                    if (c === "?") parser.state = S.PROC_INST_ENDING;
                    else if (isWhitespace(c)) parser.state = S.PROC_INST_BODY;
                    else parser.procInstName += c;
                    continue;
                case S.PROC_INST_BODY:
                    if (!parser.procInstBody && isWhitespace(c)) continue;
                    else if (c === "?") parser.state = S.PROC_INST_ENDING;
                    else parser.procInstBody += c;
                    continue;
                case S.PROC_INST_ENDING:
                    if (c === ">") {
                        emitNode(parser, "onprocessinginstruction", {
                            name: parser.procInstName,
                            body: parser.procInstBody
                        });
                        parser.procInstName = parser.procInstBody = "";
                        parser.state = S.TEXT;
                    } else {
                        parser.procInstBody += "?" + c;
                        parser.state = S.PROC_INST_BODY;
                    }
                    continue;
                case S.OPEN_TAG:
                    if (isMatch(nameBody, c)) parser.tagName += c;
                    else {
                        newTag(parser);
                        if (c === ">") openTag(parser);
                        else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                        else {
                            if (!isWhitespace(c)) strictFail(parser, "Invalid character in tag name");
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.OPEN_TAG_SLASH:
                    if (c === ">") {
                        openTag(parser, true);
                        closeTag(parser);
                    } else {
                        strictFail(parser, "Forward-slash in opening tag not followed by >");
                        parser.state = S.ATTRIB;
                    }
                    continue;
                case S.ATTRIB:
                    // haven't read the attribute name yet.
                    if (isWhitespace(c)) continue;
                    else if (c === ">") openTag(parser);
                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        parser.attribName = c;
                        parser.attribValue = "";
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_NAME:
                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                    else if (c === ">") {
                        strictFail(parser, "Attribute without value");
                        parser.attribValue = parser.attribName;
                        attrib(parser);
                        openTag(parser);
                    } else if (isWhitespace(c)) parser.state = S.ATTRIB_NAME_SAW_WHITE;
                    else if (isMatch(nameBody, c)) parser.attribName += c;
                    else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_NAME_SAW_WHITE:
                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                    else if (isWhitespace(c)) continue;
                    else {
                        strictFail(parser, "Attribute without value");
                        parser.tag.attributes[parser.attribName] = "";
                        parser.attribValue = "";
                        emitNode(parser, "onattribute", {
                            name: parser.attribName,
                            value: ""
                        });
                        parser.attribName = "";
                        if (c === ">") openTag(parser);
                        else if (isMatch(nameStart, c)) {
                            parser.attribName = c;
                            parser.state = S.ATTRIB_NAME;
                        } else {
                            strictFail(parser, "Invalid attribute name");
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.ATTRIB_VALUE:
                    if (isWhitespace(c)) continue;
                    else if (isQuote(c)) {
                        parser.q = c;
                        parser.state = S.ATTRIB_VALUE_QUOTED;
                    } else {
                        strictFail(parser, "Unquoted attribute value");
                        parser.state = S.ATTRIB_VALUE_UNQUOTED;
                        parser.attribValue = c;
                    }
                    continue;
                case S.ATTRIB_VALUE_QUOTED:
                    if (c !== parser.q) {
                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    parser.q = "";
                    parser.state = S.ATTRIB_VALUE_CLOSED;
                    continue;
                case S.ATTRIB_VALUE_CLOSED:
                    if (isWhitespace(c)) parser.state = S.ATTRIB;
                    else if (c === ">") openTag(parser);
                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        strictFail(parser, "No whitespace between attributes");
                        parser.attribName = c;
                        parser.attribValue = "";
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_VALUE_UNQUOTED:
                    if (!isAttribEnd(c)) {
                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    if (c === ">") openTag(parser);
                    else parser.state = S.ATTRIB;
                    continue;
                case S.CLOSE_TAG:
                    if (!parser.tagName) {
                        if (isWhitespace(c)) continue;
                        else if (notMatch(nameStart, c)) {
                            if (parser.script) {
                                parser.script += "</" + c;
                                parser.state = S.SCRIPT;
                            } else strictFail(parser, "Invalid tagname in closing tag.");
                        } else parser.tagName = c;
                    } else if (c === ">") closeTag(parser);
                    else if (isMatch(nameBody, c)) parser.tagName += c;
                    else if (parser.script) {
                        parser.script += "</" + parser.tagName;
                        parser.tagName = "";
                        parser.state = S.SCRIPT;
                    } else {
                        if (!isWhitespace(c)) strictFail(parser, "Invalid tagname in closing tag");
                        parser.state = S.CLOSE_TAG_SAW_WHITE;
                    }
                    continue;
                case S.CLOSE_TAG_SAW_WHITE:
                    if (isWhitespace(c)) continue;
                    if (c === ">") closeTag(parser);
                    else strictFail(parser, "Invalid characters in closing tag");
                    continue;
                case S.TEXT_ENTITY:
                case S.ATTRIB_VALUE_ENTITY_Q:
                case S.ATTRIB_VALUE_ENTITY_U:
                    var returnState;
                    var buffer;
                    switch(parser.state){
                        case S.TEXT_ENTITY:
                            returnState = S.TEXT;
                            buffer = "textNode";
                            break;
                        case S.ATTRIB_VALUE_ENTITY_Q:
                            returnState = S.ATTRIB_VALUE_QUOTED;
                            buffer = "attribValue";
                            break;
                        case S.ATTRIB_VALUE_ENTITY_U:
                            returnState = S.ATTRIB_VALUE_UNQUOTED;
                            buffer = "attribValue";
                            break;
                    }
                    if (c === ";") {
                        parser[buffer] += parseEntity(parser);
                        parser.entity = "";
                        parser.state = returnState;
                    } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) parser.entity += c;
                    else {
                        strictFail(parser, "Invalid character in entity name");
                        parser[buffer] += "&" + parser.entity + c;
                        parser.entity = "";
                        parser.state = returnState;
                    }
                    continue;
                default:
                    throw new Error(parser, "Unknown state: " + parser.state);
            }
        } // while
        if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser);
        return parser;
    }
    /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */ /* istanbul ignore next */ if (!String.fromCodePoint) (function() {
        var stringFromCharCode = String.fromCharCode;
        var floor = Math.floor;
        var fromCodePoint = function() {
            var MAX_SIZE = 0x4000;
            var codeUnits = [];
            var highSurrogate;
            var lowSurrogate;
            var index = -1;
            var length = arguments.length;
            if (!length) return "";
            var result = "";
            while(++index < length){
                var codePoint = Number(arguments[index]);
                if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                codePoint < 0 || // not a valid Unicode code point
                codePoint > 0x10FFFF || // not a valid Unicode code point
                floor(codePoint) !== codePoint // not an integer
                ) throw RangeError("Invalid code point: " + codePoint);
                if (codePoint <= 0xFFFF) codeUnits.push(codePoint);
                else {
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    codePoint -= 0x10000;
                    highSurrogate = (codePoint >> 10) + 0xD800;
                    lowSurrogate = codePoint % 0x400 + 0xDC00;
                    codeUnits.push(highSurrogate, lowSurrogate);
                }
                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                    result += stringFromCharCode.apply(null, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
        /* istanbul ignore next */ if (Object.defineProperty) Object.defineProperty(String, "fromCodePoint", {
            value: fromCodePoint,
            configurable: true,
            writable: true
        });
        else String.fromCodePoint = fromCodePoint;
    })();
})(exports);

},{"e8399c94bace2e95":"l5Twm","55cad32d9fc3850b":"gHHLM","f36f08810ace8da5":"dr7zb"}],"l5Twm":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"6Pb1S":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"6ifNR":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"gHHLM":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = Stream;
var EE = require("96b62835346f84f0").EventEmitter;
var inherits = require("4a6ee9586f51c38d");
inherits(Stream, EE);
Stream.Readable = require("e6206e1f4d20abc7");
Stream.Writable = require("a3f1405f37e1dfb1");
Stream.Duplex = require("6691a72c5fc222fd");
Stream.Transform = require("43a905ce7ec6ac9e");
Stream.PassThrough = require("dd715550d7783885");
Stream.finished = require("d90a3520974ec96e");
Stream.pipeline = require("eb2779cfd287c5c9");
// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function Stream() {
    EE.call(this);
}
Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if (EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

},{"96b62835346f84f0":"fqTtD","4a6ee9586f51c38d":"8LxVj","e6206e1f4d20abc7":"2lSfl","a3f1405f37e1dfb1":"h1TWI","6691a72c5fc222fd":"iit8P","43a905ce7ec6ac9e":"hKL6L","dd715550d7783885":"8IGbc","d90a3520974ec96e":"1bkox","eb2779cfd287c5c9":"epHmD"}],"fqTtD":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"8LxVj":[function(require,module,exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"2lSfl":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("5cd4b65a2667f30e");
"use strict";
module.exports = Readable;
/*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("c152f2119aca4689").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("ee1c46a25703890d");
/*</replacement>*/ var Buffer = require("efffad1605c95e76").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/ var debugUtil = require("f6690d8cb5f89003");
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
else debug = function debug() {};
/*</replacement>*/ var BufferList = require("f8c4515e8234bd59");
var destroyImpl = require("2b842a435cfab72e");
var _require = require("6f90938893f80e4b"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("daceb54799edbc39").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require("6b2730f2f68f00ce")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    Duplex = Duplex || require("d53c82af0b49f760");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("e7e497563ff3b269").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("d53c82af0b49f760");
    if (!(this instanceof Readable)) return new Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    this._readableState = new ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("e7e497563ff3b269").StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        process.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        process.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) process.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        var ret = dest.write(chunk);
        debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug("on readable", state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) process.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        process.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("746c700ae68bf97c");
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        process.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
    if (from === undefined) from = require("7770a768738aeba9");
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"5cd4b65a2667f30e":"5QIF0","c152f2119aca4689":"fqTtD","ee1c46a25703890d":"hLQgu","efffad1605c95e76":"l5Twm","f6690d8cb5f89003":"13Pcp","f8c4515e8234bd59":"1OWRK","2b842a435cfab72e":"7TylM","6f90938893f80e4b":"djKrV","daceb54799edbc39":"6fz7L","6b2730f2f68f00ce":"8LxVj","d53c82af0b49f760":"iit8P","e7e497563ff3b269":"dr7zb","746c700ae68bf97c":"kuFRa","7770a768738aeba9":"8uQNF"}],"5QIF0":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"hLQgu":[function(require,module,exports) {
module.exports = require("256d09989820a7e9").EventEmitter;

},{"256d09989820a7e9":"fqTtD"}],"13Pcp":[function(require,module,exports) {
"use strict";

},{}],"1OWRK":[function(require,module,exports) {
"use strict";
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var _require = require("56f983784a0fab6f"), Buffer = _require.Buffer;
var _require2 = require("95cdcc9e77389728"), inspect = _require2.inspect;
var custom = inspect && inspect.custom || "inspect";
function copyBuffer(src, target, offset) {
    Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    _createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return Buffer.alloc(0);
                var ret = Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: custom,
            value: function value(_, options) {
                return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

},{"56f983784a0fab6f":"l5Twm","95cdcc9e77389728":"13Pcp"}],"7TylM":[function(require,module,exports) {
var process = require("688ab6a28ddb436d");
"use strict";
// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                process.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                process.nextTick(emitErrorAndCloseNT, _this, err);
            } else process.nextTick(emitCloseNT, _this);
        } else if (cb) {
            process.nextTick(emitCloseNT, _this);
            cb(err);
        } else process.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self, err) {
    emitErrorNT(self, err);
    emitCloseNT(self);
}
function emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit("error", err);
}
function errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy
};

},{"688ab6a28ddb436d":"5QIF0"}],"djKrV":[function(require,module,exports) {
"use strict";
var ERR_INVALID_OPT_VALUE = require("4543c6055fd8382c").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: getHighWaterMark
};

},{"4543c6055fd8382c":"6fz7L"}],"6fz7L":[function(require,module,exports) {
"use strict";
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes = {};
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
module.exports.codes = codes;

},{}],"iit8P":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
var process = require("34d2aeaf352b4512");
"use strict";
/*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
var Readable = require("7b75ce1e482a8dfb");
var Writable = require("fd2e3b6f36c506e9");
require("7dcb079aaf2f7ac6")(Duplex, Readable);
// Allow the keys array to be GC'ed.
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    process.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

},{"34d2aeaf352b4512":"5QIF0","7b75ce1e482a8dfb":"2lSfl","fd2e3b6f36c506e9":"h1TWI","7dcb079aaf2f7ac6":"8LxVj"}],"h1TWI":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
var process = require("960325341c691095");
"use strict";
module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: require("7d0952b2aab2880f")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("d4a8b8f0181be806");
/*</replacement>*/ var Buffer = require("329aa7fef0ab6df1").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require("6a39a8b28b6e8ab4");
var _require = require("4b9079029d7ad85f"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("4d4d95a33057eaa").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require("df23fd9c6d29b882")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    Duplex = Duplex || require("a02e72411207d1a6");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, "buffer", {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("a02e72411207d1a6");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        process.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        process.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        process.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            process.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) process.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

},{"960325341c691095":"5QIF0","7d0952b2aab2880f":"3YafI","d4a8b8f0181be806":"hLQgu","329aa7fef0ab6df1":"l5Twm","6a39a8b28b6e8ab4":"7TylM","4b9079029d7ad85f":"djKrV","4d4d95a33057eaa":"6fz7L","df23fd9c6d29b882":"8LxVj","a02e72411207d1a6":"iit8P"}],"3YafI":[function(require,module,exports) {
/**
 * Module exports.
 */ var global = arguments[3];
module.exports = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config("throwDeprecation")) throw new Error(msg);
            else if (config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

},{}],"dr7zb":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
/*<replacement>*/ var Buffer = require("2a29807c689a070a").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "�";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "�";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "�";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "�";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

},{"2a29807c689a070a":"6hBQU"}],"6hBQU":[function(require,module,exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("7e0d6ecd698c3ca6");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
SafeBuffer.prototype = Object.create(Buffer.prototype);
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return buffer.SlowBuffer(size);
};

},{"7e0d6ecd698c3ca6":"l5Twm"}],"kuFRa":[function(require,module,exports) {
var process = require("cc8bd4d851c0d480");
"use strict";
var _Object$setPrototypeO;
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var finished = require("c70af6a403549764");
var kLastResolve = Symbol("lastResolve");
var kLastReject = Symbol("lastReject");
var kError = Symbol("error");
var kEnded = Symbol("ended");
var kLastPromise = Symbol("lastPromise");
var kHandlePromise = Symbol("handlePromise");
var kStream = Symbol("stream");
function createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
        var data = iter[kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[kLastPromise] = null;
            iter[kLastResolve] = null;
            iter[kLastReject] = null;
            resolve(createIterResult(data, false));
        }
    }
}
function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
            }
            iter[kHandlePromise](resolve, reject);
        }, reject);
    };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream () {
        return this[kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[kError];
        if (error !== null) return Promise.reject(error);
        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            process.nextTick(function() {
                if (_this[kError]) reject(_this[kError]);
                else resolve(createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[kStream].read();
            if (data !== null) return Promise.resolve(createIterResult(data, false));
            promise = new Promise(this[kHandlePromise]);
        }
        this[kLastPromise] = promise;
        return promise;
    }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve(createIterResult(undefined, true));
        });
    });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
        value: stream,
        writable: true
    }), _defineProperty(_Object$create, kLastResolve, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kLastReject, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kError, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), _defineProperty(_Object$create, kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[kStream].read();
            if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
            } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    finished(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
            }
            iterator[kError] = err;
            return;
        }
        var resolve = iterator[kLastResolve];
        if (resolve !== null) {
            iterator[kLastPromise] = null;
            iterator[kLastResolve] = null;
            iterator[kLastReject] = null;
            resolve(createIterResult(undefined, true));
        }
        iterator[kEnded] = true;
    });
    stream.on("readable", onReadable.bind(null, iterator));
    return iterator;
};
module.exports = createReadableStreamAsyncIterator;

},{"cc8bd4d851c0d480":"5QIF0","c70af6a403549764":"1bkox"}],"1bkox":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var ERR_STREAM_PREMATURE_CLOSE = require("260b8c2ccb6493b7").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop() {}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function eos(stream, opts, callback) {
    if (typeof opts === "function") return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once(callback || noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if (isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = eos;

},{"260b8c2ccb6493b7":"6fz7L"}],"8uQNF":[function(require,module,exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

},{}],"hKL6L":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = Transform;
var _require$codes = require("181e3ac8da6bd561").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require("74feb8f76dae610a");
require("7382ff9fb3538488")(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

},{"181e3ac8da6bd561":"6fz7L","74feb8f76dae610a":"iit8P","7382ff9fb3538488":"8LxVj"}],"8IGbc":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = PassThrough;
var Transform = require("ef151ac5a8afeb5c");
require("ad2dd1617f55ad62")(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"ef151ac5a8afeb5c":"hKL6L","ad2dd1617f55ad62":"8LxVj"}],"epHmD":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes = require("e9d469d31ac56495").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if (eos === undefined) eos = require("96a756f22061fd7");
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED("pipe"));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== "function") return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
module.exports = pipeline;

},{"e9d469d31ac56495":"6fz7L","96a756f22061fd7":"1bkox"}],"8qETt":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    exports.stripBOM = function(str) {
        if (str[0] === "\uFEFF") return str.substring(1);
        else return str;
    };
}).call(this);

},{}],"4IawY":[function(require,module,exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    var prefixMatch;
    prefixMatch = new RegExp(/(?!xmlns)^.*:/);
    exports.normalize = function(str) {
        return str.toLowerCase();
    };
    exports.firstCharLowerCase = function(str) {
        return str.charAt(0).toLowerCase() + str.slice(1);
    };
    exports.stripPrefix = function(str) {
        return str.replace(prefixMatch, "");
    };
    exports.parseNumbers = function(str) {
        if (!isNaN(str)) str = str % 1 === 0 ? parseInt(str, 10) : parseFloat(str);
        return str;
    };
    exports.parseBooleans = function(str) {
        if (/^(?:true|false)$/i.test(str)) str = str.toLowerCase() === "true";
        return str;
    };
}).call(this);

},{}],"k5LxD":[function(require,module,exports) {
var global = arguments[3];
var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;
// DOM APIs, for completeness
exports.setTimeout = function() {
    return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
    return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function(timeout) {
    if (timeout) timeout.close();
};
function Timeout(id, clearFn) {
    this._id = id;
    this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
    this._clearFn.call(scope, this._id);
};
// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
    clearTimeout(item._idleTimeoutId);
    item._idleTimeout = msecs;
};
exports.unenroll = function(item) {
    clearTimeout(item._idleTimeoutId);
    item._idleTimeout = -1;
};
exports._unrefActive = exports.active = function(item) {
    clearTimeout(item._idleTimeoutId);
    var msecs = item._idleTimeout;
    if (msecs >= 0) item._idleTimeoutId = setTimeout(function onTimeout() {
        if (item._onTimeout) item._onTimeout();
    }, msecs);
};
// setimmediate attaches itself to the global object
require("55080a345f0b7464");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;

},{"55080a345f0b7464":"hOz44"}],"hOz44":[function(require,module,exports) {
var process = require("96b87729426a727d");
var global = arguments[3];
(function(global, undefined) {
    "use strict";
    if (global.setImmediate) return;
    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;
    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") callback = new Function("" + callback);
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i + 1];
        // Store and register the task
        var task = {
            callback: callback,
            args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch(args.length){
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }
    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // "too much recursion" error.
        setTimeout(runIfPresent, 0, handle);
        else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally{
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }
    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function() {
                runIfPresent(handle);
            });
        };
    }
    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }
    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) runIfPresent(+event.data.slice(messagePrefix.length));
        };
        if (global.addEventListener) global.addEventListener("message", onGlobalMessage, false);
        else global.attachEvent("onmessage", onGlobalMessage);
        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function() {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
    // Don't get fooled by e.g. browserify environments.
    if (({}).toString.call(global.process) === "[object process]") // For Node.js before 0.9
    installNextTickImplementation();
    else if (canUsePostMessage()) // For non-IE10 modern browsers
    installPostMessageImplementation();
    else if (global.MessageChannel) // For web workers, where supported
    installMessageChannelImplementation();
    else if (doc && "onreadystatechange" in doc.createElement("script")) // For IE 6–8
    installReadyStateChangeImplementation();
    else // For older browsers
    installSetTimeoutImplementation();
    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);

},{"96b87729426a727d":"5QIF0"}]},["ic68B"], "ic68B", "parcelRequire460e")

//# sourceMappingURL=admin.257f58c7.js.map
